const ptBR = {
    'chatAiDevis.qualityIncell': 'InCell',
    'chatAiDevis.qualityOled': 'OLED',
    'chatAiDevis.qualityOriginal': 'Original / OEM',
    'chatAiDevis.qualityCompatible': 'Compatível',
    'chatAiDevis.qualityReconditionné': 'Recondicionado',
    'chatAiDevis.qualityPremium': 'Premium',
    'chatAiDevis.qualityStandard': 'Padrão',
    'chatAiDevis.fieldName': 'nome',
    'chatAiDevis.fieldPhone': 'telefone',
    'chatAiDevis.fieldEmail': 'e-mail',
    'chatAiDevis.familyAccessoryStock': 'Acessório · estoque',
    'chatAiDevis.familyAccessoryCapped': 'Acessório · ≤ 49 €',
    'chatAiDevis.familyAccessory': 'Acessório',
    'chatAiDevis.familyPart': 'Peça',
    'chatAiDevis.familyScreen': 'Tela',
    'chatAiDevis.badgeFallback': 'Preço estimado (fallback)',
    'chatAiDevis.badgeModelScore': 'Pontuação do modelo {{score}}',
    'chatAiDevis.badgeModelScoreShort': 'Pontuação do modelo',
    'chatAiDevis.badgeNeedsReview': 'A verificar',
    'chatAiDevis.altOtherParts': 'Outras peças (todos os fornecedores)',
    'chatAiDevis.altSelected': 'Selecionada',
    'chatAiDevis.useBtn': 'Usar',
    'chatAiDevis.compareTitle': 'Comparativo Jens / Mobilax / LCD-Phone',
    'chatAiDevis.compareCurrentLabel': 'Atual:',
    'chatAiDevis.htSuffix': 'sem impostos',
    'chatAiDevis.compareNoneFound': 'Nenhuma peça encontrada nos 3 fornecedores.',
    'chatAiDevis.colSupplier': 'Fornecedor',
    'chatAiDevis.colPart': 'Peça',
    'chatAiDevis.colPurchaseHt': 'Compra sem impostos',
    'chatAiDevis.colTtcEst': 'Est. c/ impostos',
    'chatAiDevis.colStock': 'Estoque',
    'chatAiDevis.colExactModel': 'Modelo exato',
    'chatAiDevis.badgeCheapest': 'mais barato',
    'chatAiDevis.badgeCurrent': 'atual',
    'chatAiDevis.scoreInline': 'pontuação {{score}}',
    'chatAiDevis.compareNoResultFor': 'Sem resultado: {{suppliers}}',
    'chatAiDevis.cadbotEmptyCache': 'Solicitação CADBOT — cache do fornecedor vazio. Informe o preço de compra sem impostos e clique em Validar para enviar o orçamento.',
    'chatAiDevis.purchaseMissingZero': 'Preço de compra ausente (0 €) — Atualize a peça ou informe o preço de compra manualmente.',
    'chatAiDevis.supplierPrimary': 'principal',
    'chatAiDevis.supplierAlternate': 'alternativo',
    'chatAiDevis.defaultRepair': 'Reparo',
    'chatAiDevis.defaultPart': 'Peça',
    'chatAiDevis.defaultClient': 'Cliente',
    'chatAiDevis.identityIncompleteInline': 'Ficha do cliente incompleta ({{fields}}) — obrigatória antes de validar',
    'chatAiDevis.willSendTo': 'O orçamento será enviado para {{email}}',
    'chatAiDevis.phName': 'Nome completo *',
    'chatAiDevis.phPhone': 'Telefone *',
    'chatAiDevis.phEmail': 'E-mail *',
    'chatAiDevis.saveIdentityBtn': 'Salvar ficha do cliente',
    'chatAiDevis.ttcCalcul': 'c/ impostos · /calcul',
    'chatAiDevis.selectedPart': 'Peça selecionada',
    'chatAiDevis.purchasePriceHt': 'Preço de compra sem impostos',
    'chatAiDevis.labor': 'Mão de obra',
    'chatAiDevis.recalcTotal': 'Recalcular o total',
    'chatAiDevis.hideCompare': 'Ocultar comparativo',
    'chatAiDevis.compareBtn': 'Comparar Jens / Mobilax / LCD-Phone',
    'chatAiDevis.showAlternatives': 'Ver alternativas (lista)',
    'chatAiDevis.hideAlternatives': 'Ocultar alternativas (lista)',
    'chatAiDevis.botStaff': 'Bot da equipe',
    'chatAiDevis.bestPartAuto': 'Melhor peça (auto)',
    'chatAiDevis.pdf': 'PDF',
    'chatAiDevis.approveSingle': 'Validar (individual)',
    'chatAiDevis.reject': 'Recusar',
    'chatAiDevis.print': 'Imprimir',
    'chatAiDevis.dirAdminTitle': 'Direção / admin da loja',
    'chatAiDevis.delete': 'Excluir',
    'chatAiDevis.approvedShort': 'Validado',
    'chatAiDevis.rejectedShort': 'Recusado',
    'chatAiDevis.batchLabel': 'Lote {{count}} orçamentos',
    'chatAiDevis.clientChat': 'Chat do cliente',
    'chatAiDevis.approveAllSend': 'Validar os {{count}} e enviar',
    'chatAiDevis.deleteBatch': 'Excluir o lote',
    'chatAiDevis.pageTitle': 'Orçamentos IA — validação',
    'chatAiDevis.pageSubtitle': '4 opções por solicitação de tela · InCell · OLED · Recondicionado · Original',
    'chatAiDevis.filterPending': 'Pendentes',
    'chatAiDevis.filterApproved': 'Validados',
    'chatAiDevis.filterRejected': 'Recusados',
    'chatAiDevis.filterAll': 'Todos',
    'chatAiDevis.infoTitle': 'Chat IA e Auto-Devis — fornecedores',
    'chatAiDevis.infoJensPrimary': 'é o fornecedor principal (prioridade na pontuação).',
    'chatAiDevis.infoAnd': 'e',
    'chatAiDevis.infoMobilaxLcd': 'são consultados se houver melhor correspondência ou se a Jens não tiver a peça.',
    'chatAiDevis.infoEachRange': 'Cada gama (InCell, OLED, etc.) pode vir de um fornecedor diferente — verifique antes de validar.',
    'chatAiDevis.infoCompareExplain': '« Comparar Jens / Mobilax / LCD-Phone » mostra o preço de compra sem impostos, o total com impostos estimado, o estoque e o modelo exato em cada fornecedor — « Usar » troca o rascunho.',
    'chatAiDevis.infoBadgesLabel': 'Selos:',
    'chatAiDevis.infoBadgesCheck': '— confira a peça antes de validar.',
    'chatAiDevis.infoBotStaffExplain': '(painel à direita) — descreva um reparo para criar os rascunhos, ou digite « comparer » para ver todos os fornecedores.',
    'chatAiDevis.loading': 'Carregando…',
    'chatAiDevis.noQuotesPending': 'Nenhum orçamento pendente.',
    'chatAiDevis.noQuotes': 'Nenhum orçamento.',
    'chatAiDevis.emptyHint': 'Use o Bot Auto-Devis à direita para criar um (ex. « Tela iPhone 14 »).',
    'chatAiDevis.backToStaff': '← Voltar ao espaço da equipe',
    'chatAiDevis.botAutoDevis': 'Bot Auto-Devis',
    'chatAiDevis.staffSpace': '← Espaço da equipe',
    'chatAiDevis.errPdfPreview': 'Erro na pré-visualização do PDF',
    'chatAiDevis.alertPurchaseMissingPrint': 'Preço de compra ausente — informe um preço ou atualize a peça antes de imprimir.',
    'chatAiDevis.errPrintTicket': 'Erro ao imprimir o tíquete de 80 mm',
    'chatAiDevis.errRecalc': 'Erro no recálculo',
    'chatAiDevis.errPartNotFound': 'Peça não encontrada no cache do fornecedor',
    'chatAiDevis.errCompare': 'Erro na comparação de fornecedores',
    'chatAiDevis.errAlternatives': 'Erro ao carregar alternativas',
    'chatAiDevis.errSaveIdentity': 'Erro ao salvar a ficha do cliente',
    'chatAiDevis.alertIdentityIncomplete': 'Ficha do cliente incompleta: {{fields}}. Nome, telefone e e-mail são obrigatórios antes de validar e enviar o orçamento.',
    'chatAiDevis.mailWillSend': 'Um e-mail com o PDF será enviado para: {{email}}',
    'chatAiDevis.noClientEmail': '(Sem e-mail do cliente — validação apenas por chat)',
    'chatAiDevis.confirmApprove': 'Validar este orçamento e enviá-lo ao cliente?',
    'chatAiDevis.sumupWarn': 'Atenção: não foi possível criar o link de pagamento SumUp ({{error}}). O botão do e-mail oferecerá o pagamento ao clicar; verifique a chave de API do SumUp nas configurações.',
    'chatAiDevis.sumupUnavailable': 'SumUp indisponível',
    'chatAiDevis.approvedMailSent': 'Orçamento validado — e-mail enviado para {{email}}.',
    'chatAiDevis.approvedSent': 'Orçamento validado e enviado ao cliente.',
    'chatAiDevis.errApprove': 'Erro de validação',
    'chatAiDevis.confirmApproveBatch': 'Validar os {{count}} orçamentos e enviar o resumo ao cliente?',
    'chatAiDevis.batchApproved': '{{count}} orçamentos validados e enviados ao cliente.',
    'chatAiDevis.errApproveBatch': 'Erro na validação do lote',
    'chatAiDevis.promptRejectReason': 'Motivo da recusa (opcional):',
    'chatAiDevis.errGeneric': 'Erro',
    'chatAiDevis.confirmDeleteDevis': 'Excluir definitivamente o orçamento {{ref}}?\n\nAção irreversível.',
    'chatAiDevis.errDelete': 'Erro ao excluir',
    'chatAiDevis.confirmDeleteBatch': 'Excluir definitivamente os {{count}} orçamentos do lote?\n\nAção irreversível.',
    'chatAiDevis.errDeleteBatch': 'Erro ao excluir o lote',
    'saLayout.nav_dashboard': 'Painel',
    'saLayout.nav_analytics': 'Análises',
    'saLayout.nav_companies': 'Empresas',
    'saLayout.nav_subscriptions': 'Assinaturas',
    'saLayout.nav_users': 'Usuários',
    'saLayout.nav_stats': 'Estatísticas',
    'saLayout.nav_communications': 'Comunicações',
    'saLayout.nav_impersonation': 'Modo Suporte',
    'saLayout.nav_config': 'Configuração',
    'saLayout.nav_integrations': 'Integrações de API',
    'saLayout.nav_security': 'Segurança (2FA)',
    'saLayout.nav_logs': 'Registro e auditoria',
    'saLayout.super_admin': 'Super Admin',
    'saLayout.role_super_admin': 'Super Administrador',
    'saLayout.logout': 'Sair',
    'saLayout.top_bar_title': 'Painel Super Admin',
    'saConfig.error': 'Erro',
    'saConfig.confirmMaintenance': 'Ativar o modo de manutenção? Os clientes não poderão mais acessar a plataforma.',
    'saConfig.title': 'Configuração',
    'saConfig.subtitle': 'Configurações globais da plataforma',
    'saConfig.saved': 'Salvo',
    'saConfig.saving': 'Salvando...',
    'saConfig.save': 'Salvar',
    'saConfig.maintenanceTitle': 'Modo de manutenção',
    'saConfig.maintenanceDesc': 'Bloquear temporariamente o acesso dos clientes',
    'saConfig.generalSettings': 'Configurações gerais',
    'saConfig.platformName': 'Nome da plataforma',
    'saConfig.gracePeriod': 'Período de carência (dias)',
    'saConfig.plans': 'Planos de preços',
    'saConfig.planPrice': 'Preço (EUR/mês)',
    'saConfig.maxShops': 'Máx. lojas',
    'saConfig.maxUsers': 'Máx. usuários',
    'saConfig.features': 'Funcionalidades',
    'saImpersonation.title': 'Modo Suporte (Personificação)',
    'saImpersonation.subtitle': 'Acessar temporariamente a conta de uma empresa',
    'saImpersonation.confirmEnter': 'Entrar no modo suporte para esta empresa?',
    'saImpersonation.errorGeneric': 'Erro',
    'saImpersonation.activeBannerTitle': 'Modo Suporte ativo',
    'saImpersonation.connectedAs': 'Conectado como: {{name}}',
    'saImpersonation.stopSupport': 'Sair do modo suporte',
    'saImpersonation.warningTitle': 'Atenção — Função sensível',
    'saImpersonation.warningText': 'A personificação concede acesso total à conta do cliente. Todas as suas ações são registradas. A senha do cliente nunca será alterada.',
    'saImpersonation.searchPlaceholder': 'Buscar uma empresa...',
    'saImpersonation.emptyList': 'Nenhuma empresa encontrada',
    'saImpersonation.companyMeta': '{{email}} - Plano {{plan}}',
    'saImpersonation.enterBtn': 'Entrar',
    'saPackages.title': 'Gerenciamento de pacotes',
    'saPackages.subtitle': 'Substitua diretamente os ZIPs e o agente Windows servidos em produção.',
    'saPackages.refresh': 'Atualizar',
    'saPackages.statAvailable': 'Artefatos disponíveis',
    'saPackages.statTotalSize': 'Tamanho total',
    'saPackages.statAlert': 'Alerta',
    'saPackages.alertText': 'As substituições sobrescrevem o arquivo ativo. Não há exclusão separada.',
    'saPackages.statusAvailable': 'Disponível',
    'saPackages.statusMissing': 'Ausente',
    'saPackages.download': 'Baixar',
    'saPackages.activeFile': 'Arquivo ativo',
    'saPackages.size': 'Tamanho',
    'saPackages.lastUpdate': 'Última atualização',
    'saPackages.uploadedBy': 'Enviado por',
    'saPackages.replaceLiveFile': 'Substituir o arquivo ativo',
    'saPackages.uploading': 'Enviando…',
    'saPackages.replace': 'Substituir',
    'saPackages.replaceHint': 'O arquivo escolhido substitui diretamente o que é servido aos usuários em remobiles.com.',
    'saPackages.selectedFile': 'Arquivo selecionado: {{name}}',
    'saPackages.errorLoad': 'Erro ao carregar os arquivos',
    'saPackages.downloadLinkUnavailable': 'Link de download indisponível',
    'saPackages.downloadFailed': 'Não foi possível baixar',
    'saPackages.selectFileFor': 'Selecione um arquivo para {{label}}.',
    'saPackages.confirmReplace': 'Substituir agora {{label}} por {{name}}?',
    'saPackages.replaceSuccess': '{{label}} substituído com sucesso.',
    'saPackages.errorUpload': 'Erro durante o envio',
    'saPackages.superAdminOnly': 'Acesso somente para superadministradores',
    'saPackages.superAdminDesc': 'Esta página permite atualizar os arquivos atualmente servidos pelo remobiles.com. Os links de download públicos continuam controlados pelas rotas assinadas do backend.',
    'saDashboard.title': 'Painel',
    'saDashboard.subtitle': 'Visão geral da plataforma {{brand}}',
    'saDashboard.companies': 'Empresas',
    'saDashboard.activeCount': '{{count}} ativas',
    'saDashboard.users': 'Usuários',
    'saDashboard.shops': 'Lojas',
    'saDashboard.mrr': 'MRR',
    'saDashboard.mrrSub': 'Receita recorrente mensal',
    'saDashboard.newThisMonth': 'Novos este mês',
    'saDashboard.expired': 'Expirados',
    'saDashboard.suspended': 'Suspensas',
    'saDashboard.recentCompanies': 'Empresas recentes',
    'saDashboard.viewAll': 'Ver tudo',
    'saDashboard.noCompanies': 'Nenhuma empresa ainda',
    'saDashboard.recentActivity': 'Atividade recente',
    'saDashboard.noActivity': 'Nenhuma atividade recente',
    'saAnalytics.title': 'Análise da plataforma',
    'saAnalytics.subtitle': 'KPIs globais e desempenho por empresa',
    'saAnalytics.kpiRepairsToday': 'Reparos hoje',
    'saAnalytics.kpiActiveRepairs': 'Reparos ativos',
    'saAnalytics.kpiRevenueMonth': 'Receita deste mês',
    'saAnalytics.kpiClientsTotal': 'Total de clientes',
    'saAnalytics.kpiRepairsWeek': 'Reparos na semana',
    'saAnalytics.kpiRepairsMonth': 'Reparos no mês',
    'saAnalytics.kpiRepairsTotal': 'Total de reparos',
    'saAnalytics.kpiRevenueTotal': 'Receita total',
    'saAnalytics.kpiActiveCompanies': 'Empresas ativas',
    'saAnalytics.companyPerformance': 'Desempenho por empresa',
    'saAnalytics.companiesCount': '{{count}} empresas',
    'saAnalytics.emptyCompanies': 'Nenhuma empresa ativa',
    'saAnalytics.colCompany': 'Empresa',
    'saAnalytics.colPlan': 'Plano',
    'saAnalytics.colRepairs': 'Reparos',
    'saAnalytics.colActive': 'Ativos',
    'saAnalytics.colClients': 'Clientes',
    'saAnalytics.colStock': 'Estoque',
    'saAnalytics.colSales': 'Vendas',
    'saAnalytics.colRevenue': 'Receita',
    'saAnalytics.colAvgTime': 'Tempo méd.',
    'saAnalytics.daysShort': '{{n}}d',
    'saLogs.title': 'Registro e Segurança',
    'saLogs.subtitle': 'Auditoria de ações e integridade do sistema',
    'saLogs.systemHealth': 'Integridade do Sistema',
    'saLogs.database': 'Banco de dados',
    'saLogs.statusOk': 'OK',
    'saLogs.statusError': 'Erro',
    'saLogs.filterAll': 'Todas as ações',
    'saLogs.filterCreateCompany': 'Criação de empresa',
    'saLogs.filterUpdateCompany': 'Alteração de empresa',
    'saLogs.filterSuspend': 'Suspensão',
    'saLogs.filterActivate': 'Reativação',
    'saLogs.filterImpersonate': 'Personificação',
    'saLogs.filterCreateUser': 'Criação de usuário',
    'saLogs.filterDeleteUser': 'Exclusão de usuário',
    'saLogs.filterResetPassword': 'Redefinir senha',
    'saLogs.filterUpdateSubscription': 'Alteração de assinatura',
    'saLogs.filterUpdateConfig': 'Alteração de config',
    'saLogs.entriesCount': '{{count}} entradas',
    'saLogs.empty': 'Nenhuma entrada no registro',
    'saLogs.onTarget': 'em {{target}}',
    'saLogs.byUserAt': 'por {{user}} - {{date}}',
    'saComm.title': 'Comunicações',
    'saComm.messagesSent': '{{count}} mensagens enviadas',
    'saComm.newMessage': 'Nova mensagem',
    'saComm.emptyList': 'Nenhuma comunicação enviada',
    'saComm.noSubject': 'Sem assunto',
    'saComm.allClients': 'Todos os clientes',
    'saComm.companiesCount': '{{count}} empresa(s)',
    'saComm.modalTitle': 'Enviar uma comunicação',
    'saComm.typeLabel': 'Tipo',
    'saComm.typeNotification': 'Notificação',
    'saComm.typeMaintenance': 'Manutenção',
    'saComm.typeUpdate': 'Atualização',
    'saComm.recipients': 'Destinatários',
    'saComm.targetSelected': 'Seleção',
    'saComm.targetedCompanies': 'Empresas selecionadas',
    'saComm.subjectLabel': 'Assunto *',
    'saComm.messageLabel': 'Mensagem *',
    'saComm.cancel': 'Cancelar',
    'saComm.send': 'Enviar',
    'saComm.errorGeneric': 'Erro',
    'saSecurity.pageTitle': 'Segurança da conta',
    'saSecurity.pageSubtitle': '2FA, restrição de IP e configurações de segurança',
    'saSecurity.errorGeneric': 'Erro',
    'saSecurity.twoFAEnabledSuccess': '2FA ativado com sucesso!',
    'saSecurity.invalidCode': 'Código inválido',
    'saSecurity.twoFADisabled': '2FA desativado',
    'saSecurity.saveError': 'Erro ao salvar',
    'saSecurity.twoFATitle': 'Autenticação de dois fatores (2FA)',
    'saSecurity.statusEnabled': 'Ativado',
    'saSecurity.statusDisabled': 'Desativado',
    'saSecurity.setupBtn': 'Configurar 2FA',
    'saSecurity.scanQrInstruction': 'Escaneie este QR code com o Google Authenticator:',
    'saSecurity.qrCodeAlt': 'QR code',
    'saSecurity.manualKeyInstruction': 'Ou insira esta chave manualmente:',
    'saSecurity.verificationCodeLabel': 'Código de verificação',
    'saSecurity.verifyBtn': 'Verificar',
    'saSecurity.disableInstruction': 'Para desativar o 2FA, insira seu código atual:',
    'saSecurity.ipRestrictionTitle': 'Restrição de IP (opcional)',
    'saSecurity.ipRestrictionSubtitle': 'Limitar o acesso de superadministrador a determinados endereços IP',
    'saSecurity.ipPlaceholder': 'Um IP por linha (ex.: 192.168.1.1)',
    'saSecurity.saved': 'Salvo',
    'saSecurity.save': 'Salvar',
    'saStats.title': 'Estatísticas de negócio',
    'saStats.subtitle': 'Análises e projeções financeiras',
    'saStats.mrrTitle': 'Receita recorrente mensal (MRR)',
    'saStats.planDistTitle': 'Distribuição de planos',
    'saStats.emptyData': 'Nenhum dado',
    'saStats.churnTitle': 'Taxa de cancelamento (Churn)',
    'saStats.cancelledCount': '{{count}} cancelado(s)',
    'saStats.growthTitle': 'Crescimento - Novas empresas',
    'repairUi.repairs': 'Reparos',
    'repairUi.repairSheet': 'Ficha de reparo',
    'repairUi.edit': 'Editar',
    'repairUi.print': 'Imprimir',
    'repairUi.backToRepairs': 'Voltar para reparos',
    'repairUi.editRepair': 'Editar reparo',
    'repairUi.newDeposit': 'Nova entrada',
    'repairUi.ref': 'Ref',
    'saSubscriptions.title': 'Assinaturas',
    'saSubscriptions.count': '{{count}} assinaturas',
    'saSubscriptions.filter_all_statuses': 'Todos os status',
    'saSubscriptions.filter_all_plans': 'Todos os planos',
    'saSubscriptions.status_active': 'Ativo',
    'saSubscriptions.status_suspended': 'Suspenso',
    'saSubscriptions.status_expired': 'Expirado',
    'saSubscriptions.status_overdue': 'Em atraso',
    'saSubscriptions.status_cancelled': 'Cancelado',
    'saSubscriptions.col_company': 'Empresa',
    'saSubscriptions.col_plan': 'Plano',
    'saSubscriptions.col_price': 'Preço',
    'saSubscriptions.col_status': 'Status',
    'saSubscriptions.col_next_billing': 'Próxima cobrança',
    'saSubscriptions.col_discount': 'Desconto',
    'saSubscriptions.col_actions': 'Ações',
    'saSubscriptions.empty': 'Nenhuma assinatura',
    'saSubscriptions.action_edit': 'Editar',
    'saSubscriptions.action_extend': 'Prolongar',
    'saSubscriptions.modal_title': 'Editar assinatura',
    'saSubscriptions.label_discount': 'Desconto (%)',
    'saSubscriptions.plan_option_start': 'Start ({{price}})',
    'saSubscriptions.plan_option_pro': 'Pro ({{price}})',
    'saSubscriptions.plan_option_super': 'Super ({{price}})',
    'saSubscriptions.cancel': 'Cancelar',
    'saSubscriptions.save': 'Salvar',
    'saSubscriptions.prompt_extend_days': 'Número de dias a adicionar:',
    'saSubscriptions.error': 'Erro',
    'saUsers.title': 'Usuários',
    'saUsers.totalUsers': '{{count}} usuários',
    'saUsers.newUser': 'Novo usuário',
    'saUsers.searchPlaceholder': 'Pesquisar...',
    'saUsers.filterAllRoles': 'Todas as funções',
    'saUsers.roleSuperAdmin': 'Super Admin',
    'saUsers.roleAdmin': 'Admin',
    'saUsers.roleUser': 'Funcionário',
    'saUsers.roleTechnicien': 'Técnico',
    'saUsers.roleClient': 'Cliente',
    'saUsers.roleB2b': 'B2B',
    'saUsers.emptyState': 'Nenhum usuário encontrado',
    'saUsers.colUser': 'Usuário',
    'saUsers.colRole': 'Função',
    'saUsers.colCompany': 'Empresa',
    'saUsers.colCreatedAt': 'Criado em',
    'saUsers.colActions': 'Ações',
    'saUsers.resetPassword': 'Redefinir senha',
    'saUsers.delete': 'Excluir',
    'saUsers.labelUsername': 'Nome de usuário',
    'saUsers.labelEmail': 'E-mail',
    'saUsers.labelPassword': 'Senha',
    'saUsers.companyNone': 'Nenhuma',
    'saUsers.cancel': 'Cancelar',
    'saUsers.create': 'Criar',
    'saUsers.labelNewPassword': 'Nova senha',
    'saUsers.reset': 'Redefinir',
    'saUsers.error': 'Erro',
    'saUsers.resetSuccess': 'Senha redefinida com sucesso',
    'saUsers.confirmDelete': 'Excluir o usuário {{username}}?',
    'saCompanies.status_active': 'Ativo',
    'saCompanies.status_suspended': 'Suspenso',
    'saCompanies.status_overdue': 'Atrasado',
    'saCompanies.status_archived': 'Arquivado',
    'saCompanies.error': 'Erro',
    'saCompanies.confirm_suspend': 'Suspender esta empresa?',
    'saCompanies.suspend_reason_manual': 'Suspenso manualmente',
    'saCompanies.confirm_archive': 'Arquivar esta empresa? Esta ação é irreversível.',
    'saCompanies.reminder_sent': 'E-mail de lembrete enviado',
    'saCompanies.reminder_error': 'Erro ao enviar',
    'saCompanies.title': 'Empresas',
    'saCompanies.total_companies': '{{count}} empresas no total',
    'saCompanies.new_company': 'Nova empresa',
    'saCompanies.search_placeholder': 'Buscar...',
    'saCompanies.filter_all_status': 'Todos os status',
    'saCompanies.filter_overdue': 'Atrasado',
    'saCompanies.filter_all_plans': 'Todos os planos',
    'saCompanies.empty': 'Nenhuma empresa encontrada',
    'saCompanies.col_company': 'Empresa',
    'saCompanies.col_plan': 'Plano',
    'saCompanies.col_status': 'Status',
    'saCompanies.col_users': 'Usuários',
    'saCompanies.col_registered': 'Registrado em',
    'saCompanies.col_actions': 'Ações',
    'saCompanies.action_view': 'Ver',
    'saCompanies.action_reminder': 'Enviar um lembrete de pagamento',
    'saCompanies.action_suspend': 'Suspender',
    'saCompanies.action_reactivate': 'Reativar',
    'saCompanies.action_archive': 'Arquivar',
    'saCompanies.field_company_name': 'Nome da empresa',
    'saCompanies.field_contact': 'Contato principal',
    'saCompanies.field_email': 'E-mail',
    'saCompanies.field_phone': 'Telefone',
    'saCompanies.field_address': 'Endereço',
    'saCompanies.field_plan': 'Plano de assinatura',
    'saCompanies.plan_option_start': 'Start ({{price}}/mês)',
    'saCompanies.plan_option_pro': 'Pro ({{price}}/mês)',
    'saCompanies.plan_option_super': 'Super ({{price}}/mês)',
    'saCompanies.field_shop_count': 'Número de lojas',
    'saCompanies.admin_account': 'Conta de administrador da empresa',
    'saCompanies.field_admin_email': 'E-mail do administrador',
    'saCompanies.field_password': 'Senha',
    'saCompanies.field_notes': 'Notas internas',
    'saCompanies.cancel': 'Cancelar',
    'saCompanies.create_company': 'Criar a empresa',
    'saCompanies.users_count': '{{count}} usuários',
    'saCompanies.subscription': 'Assinatura',
    'saCompanies.monthly_price': 'Preço mensal',
    'saCompanies.next_billing': 'Próxima cobrança',
    'saCompanies.no_users': 'Nenhum usuário',
    'qrRouter.redirecting': 'Redirecionando...',
    'subscriptionPages.verifyingPayment': 'Verificando o pagamento...',
    'subscriptionPages.successTitle': 'Pagamento aprovado!',
    'subscriptionPages.successBody': 'Sua assinatura agora está ativa.',
    'subscriptionPages.goToDashboard': 'Ir para o painel',
    'subscriptionPages.processingPayment': 'Processando o pagamento...',
    'subscriptionPages.errorTitle': 'Erro',
    'subscriptionPages.errorBody': 'Não foi possível verificar o pagamento.',
    'subscriptionPages.backToDashboard': 'Voltar ao painel',
    'subscriptionPages.cancelTitle': 'Pagamento cancelado',
    'subscriptionPages.cancelBody': 'O pagamento foi cancelado. Você pode tentar novamente quando quiser.',
    'common.error': 'Erro',
    'notes.uploadError': 'Erro ao enviar o arquivo',
    'notes.downloadError': 'Erro ao baixar',
    'notes.confirmDeleteFile': 'Excluir este arquivo?',
    'notes.uploading': 'Enviando...',
    'notes.attach': 'Anexar',
    'notes.addedBy': 'Adicionado por {{author}} — {{date}}',
    'notes.sizeBytes': '{{size}} B',
    'notes.sizeKb': '{{size}} KB',
    'notes.sizeMb': '{{size}} MB',
    'historique.subtitle': 'Vendas, tickets e sinais',
    'historique.centreActivite': 'Central de atividade',
    'historique.filtresRecherche': 'Filtros e busca',
    'historique.rechercher': 'Buscar',
    'historique.searchPlaceholder': 'Artigo, referência…',
    'historique.vendeur': 'Vendedor',
    'historique.tous': 'Todos',
    'historique.dateDebut': 'Data de início',
    'historique.dateFin': 'Data de término',
    'historique.magasin': 'Loja',
    'historique.filtrer': 'Filtrar',
    'historique.reinitialiser': 'Redefinir',
    'historique.totalVentes': 'Total de vendas',
    'historique.totalAcomptes': 'Total de sinais',
    'historique.totalRetraits': 'Total de retiradas',
    'historique.totalGlobal': 'Total geral',
    'historique.commVentes': 'Com. vendas ({{pct}}%)',
    'historique.commReparations': 'Com. reparos ({{pct}}%)',
    'historique.commCommandes': 'Com. pedidos ({{pct}}%)',
    'historique.totalCommissions': 'Total de comissões',
    'historique.popupsAutoriser': 'Permita os pop-ups para imprimir.',
    'historique.erreurTelechargement': 'Erro no download',
    'historique.vendeurDatesRequis': 'Informe vendedor e datas',
    'historique.erreurImpressionRapport': 'Erro ao imprimir o relatório',
    'historique.erreurConfirmationSumup': 'Erro ao confirmar o SumUp',
    'historique.confirmRefusPaiement': 'Marcar este pagamento como recusado / cancelado?',
    'historique.erreurRefusSumup': 'Erro ao recusar o SumUp',
    'dash.forceOpen': 'Abertura forçada',
    'dash.force': 'Forçar',
    'dash.forceOpenTitle': 'Forçar abertura do caixa {{magasin}}',
    'dash.forceOpenWarning': 'Qualquer caixa aberto será fechado automaticamente. Um novo caixa será criado com o valor informado.',
    'dash.noOpenCaisseToForce': 'Nenhum caixa aberto para fechar à força em {{magasin}}.',
    'dash.thisMagasin': 'esta loja',
    'dash.statusOpenF': 'Aberto',
    'dash.statusClosedF': 'Fechado',
    'dash.openMagasin': 'Abrir {{magasin}}',
    'dash.forceOpenShort': 'Forçar abertura',
    'dash.closeMagasin': 'Fechar {{magasin}}',
    'dash.forceCloseShort': 'Forçar fechamento',
    'dash.subtitleNetwork': 'Visão da rede · caixa · KPIs',
    'dash.subtitleWorkshop': 'Oficina · reparos',
    'dash.subtitleDefault': 'Painel · vendas e atividade',
    'dash.caisseActionsByStore': 'Ações de caixa por loja',
    'devisFactures.printPopupBlocked': 'Permita os pop-ups para imprimir.',
    'devisFactures.errorPrintTicket': 'Erro ao imprimir o tíquete',
    'devisFactures.errorPrintA4': 'Erro ao imprimir em A4',
    'devisFactures.errorConvert': 'Erro ao converter em pedido',
    'devisFactures.errorDelete': 'Erro ao excluir',
    'devisFactures.errorInvalidEmail': 'Endereço de e-mail inválido',
    'devisFactures.emailSent': '{{type}} enviado para {{email}}',
    'devisFactures.errorSendEmail': 'Erro ao enviar o e-mail',
    'devisFactures.linkedTo': 'Vinculado a {{ref}}',
    'devisFactures.sendByEmail': 'Enviar por e-mail',
    'devisFactures.detachConfirm': 'Desvincular este orçamento de {{ref}}?',
    'devisFactures.error': 'Erro',
    'devisFactures.attachToRepair': 'Vincular a um reparo',
    'devisFactures.emailModalTitle': 'Enviar {{type}} por e-mail',
    'devisFactures.refLabel': 'Ref.:',
    'devisFactures.a4PdfNote': 'O documento será enviado em formato PDF A4',
    'devisFactures.clientEmailLabel': 'Endereço de e-mail do cliente',
    'devisFactures.emailPlaceholder': 'cliente@exemplo.com',
    'devisFactures.labelDevis': 'Orçamento',
    'devisFactures.labelFacture': 'Fatura',
    'devisFactures.labelCommande': 'Pedido',
    'devisFactures.labelAvoir': 'Nota de crédito',
    'devisFactures.labelPaye': 'Pago',
    'devisFactures.labelAnnule': 'Cancelado',
    'devisFactures.labelEnAttente': 'Pendente',
    'clients.tabPins': 'PINs / Senhas',
    'clients.pin': 'PIN',
    'clients.error': 'Erro',
    'clients.loadError': 'Erro ao carregar',
    'clients.saveError': 'Erro ao salvar',
    'clients.sendError': 'Erro no envio',
    'clients.noIdLegacy': 'Este cliente não tem ID (legado). Edite-o para atualizá-lo.',
    'clients.ficheAccessDenied': 'Acesso negado: somente o administrador pode ver a ficha do cliente.',
    'clients.pinGenerated': 'PIN {{pin}} gerado para {{nom}}',
    'clients.ficheClient': 'Ficha do cliente',
    'clients.optional': 'Opcional',
    'clients.genNewPin': 'Gerar novo PIN',
    'clients.sendPinEmail': 'Enviar PIN por e-mail',
    'clients.loyaltyLine': 'Fidelidade: {{level}} — {{points}} pts — {{purchases}} compras',
    'clients.repairs': 'Reparos',
    'clients.commandes': 'Pedidos',
    'clients.devis': 'Orçamentos',
    'clients.ventesPos': 'Vendas PDV',
    'clients.acomptes': 'Sinais',
    'clients.noneFem': 'Nenhuma',
    'clients.noneMasc': 'Nenhum',
    'cmd.clientPartsTitle': 'Pedidos de peças de clientes',
    'cmd.pageIntro': 'Adicione peças (em estoque ou a encomendar) como em um reparo. Os sinais são deduzidos do total.',
    'cmd.deposits': 'Sinais',
    'cmd.remainingShort': 'Restante',
    'cmd.statusConverting': 'Em conversão',
    'cmd.repairBadge': 'Reparo {{ref}}',
    'cmd.toOrderShort': 'a pedir',
    'cmd.stockOutShort': 'saído do estoque',
    'cmd.inStockShort': 'em estoque',
    'cmd.view': 'Ver',
    'cmd.addDeposit': '+ Sinal',
    'cmd.settled': 'Quitado',
    'cmd.convertToRepair': 'Converter em reparo',
    'cmd.trackingWith': 'Rastreamento: {{num}}',
    'cmd.trackingNumber': 'Número de rastreamento',
    'cmd.newClientParts': 'Novo pedido de peças',
    'cmd.partsSectionTitle': 'Peças (como em um reparo)',
    'cmd.searchStockPlaceholder': 'Buscar uma peça em estoque…',
    'cmd.noRef': 'sem ref.',
    'cmd.toOrder': 'a encomendar',
    'cmd.stock': 'estoque',
    'cmd.qtyShort': 'Qtd',
    'cmd.unitPriceLabel': 'Preço un. (€)',
    'cmd.stockSection': 'Estoque',
    'cmd.alreadyOut': 'Já retirada do estoque',
    'cmd.decrementOnSave': 'Baixa ao salvar',
    'cmd.stillInStock': 'Ainda em estoque',
    'cmd.outOnConvert': 'Baixa na conversão em reparo',
    'cmd.addPendingBtn': 'Peça a encomendar (fora de estoque)',
    'cmd.pendingTitle': 'Peça a encomendar',
    'cmd.designationPlaceholder': 'Designação *',
    'cmd.refOptPlaceholder': 'Ref. (opc.)',
    'cmd.salePricePlaceholder': 'Preço de venda €',
    'cmd.partsTotal': 'Total de peças',
    'cmd.depositsPaid': 'Sinais já pagos',
    'cmd.addDepositTitle': 'Adicionar um sinal',
    'cmd.orderLabel': 'Pedido',
    'cmd.alreadyPaid': 'Já pago',
    'cmd.depositAmount': 'Valor do sinal (€)',
    'cmd.paymentMode': 'Forma de pagamento',
    'cmd.payCash': 'Dinheiro',
    'cmd.payCard': 'Cartão',
    'cmd.payTransfer': 'Transferência',
    'cmd.payCheck': 'Cheque',
    'cmd.newRemainingAfter': 'Novo saldo após o sinal:',
    'cmd.depositsPaidTitle': 'Sinais pagos',
    'cmd.noDeposits': 'Nenhum sinal pago',
    'cmd.trackingPlaceholder': 'Ex. 8R123456789FR',
    'cmd.trackingEmailNote': 'Um e-mail será enviado ao cliente se houver um e-mail cadastrado.',
    'cmd.error': 'Erro',
    'cmd.errDesignationRequired': 'Designação obrigatória para a peça a encomendar',
    'cmd.errClientPhoneRequired': 'Cliente e telefone obrigatórios',
    'cmd.errAddPart': 'Adicione pelo menos uma peça (busca em estoque ou peça a encomendar)',
    'cmd.errDelete': 'Erro ao excluir',
    'cmd.cancelConfirm': 'Cancelar este pedido?',
    'cmd.errInvalidAmount': 'Valor inválido',
    'cmd.errDepositExceeds': 'O sinal não pode exceder o valor restante ({{reste}})',
    'cmd.errPrintTicket': 'Erro ao imprimir o comprovante',
    'cmd.errPrintDepositTicket': 'Erro ao imprimir o comprovante de sinal',
    'cmd.convertConfirm': 'Converter este pedido em reparo?',
    'cmd.errConvert': 'Erro na conversão em reparo',
    'cmd.promptClientEmail': 'E-mail do cliente:',
    'cmd.emailSent': 'Pedido enviado para {{email}}',
    'cmd.errSendEmail': 'Erro ao enviar e-mail',
    'cmd.errTracking': 'Erro de rastreamento',
    'pos.insufficientStock': 'Estoque insuficiente',
    'pos.partialPaymentConfirm': 'O valor pago ({{paid}}) é inferior ao total ({{total}}).\n\nRestante a pagar: {{remaining}}\n\nConfirmar como pagamento parcial?',
    'pos.loyaltyRewardEarned': '\n\nFIDELIDADE: Parabéns! Recompensa desbloqueada! 15% na próxima compra ou 10% no próximo reparo!',
    'pos.loyaltyRewardPending': '\n\nFIDELIDADE: Recompensa pendente (15% na próxima compra no PDV ou 10% em um reparo)',
    'pos.loyaltyProgress': '\n\nFIDELIDADE: {{points}}/10 compras. Faltam apenas {{remaining}} compra(s) para a recompensa!',
    'pos.partialPaymentLine': '\nPAGAMENTO PARCIAL - Restante a pagar: {{remaining}}',
    'pos.invoiceSentAuto': '\nNota fiscal enviada automaticamente para {{email}}',
    'pos.offlineSaleMsg': '\n\nMODO OFFLINE - Venda salva localmente.\nA sincronização será feita automaticamente assim que a Internet voltar.\n(O envio do e-mail e a atualização do estoque ocorrerão nesse momento.)',
    'pos.refLabel': 'Ref.: {{ref}}',
    'pos.totalLabel': 'Total: {{total}}',
    'pos.saleError': 'Erro durante a venda.\nCódigo HTTP: {{code}}\nA venda pode não ter sido salva. Verifique o histórico.',
    'pos.unknownStatus': 'desconhecido',
    'pos.invalidEmailEnter': 'Insira um endereço de e-mail válido',
    'pos.accountCreated': 'Conta de cliente criada! As credenciais foram enviadas por e-mail.',
    'pos.accountCreateError': 'Erro ao criar a conta',
    'pos.invalidAmount': 'Valor inválido',
    'pos.acompteDesignation': 'Sinal de reparo {{ref}}',
    'pos.designationPriceRequired': 'Descrição e preço obrigatórios',
    'pos.manualAddError': 'Erro ao adicionar manualmente',
    'pos.adminValidationFailed': 'Falha na validação de administrador',
    'pos.printTicketError': 'Erro ao imprimir o cupom',
    'pos.notAllTicketsPrintedConfirm': '⚠️ Você não imprimiu todos os cupons.\n\nO cliente deve receber cada cupom. Fechar mesmo assim?',
    'pos.invalidEmail': 'Endereço de e-mail inválido',
    'pos.invoiceSentTo': 'Nota fiscal enviada para {{email}}',
    'pos.sendEmailError': 'Erro ao enviar o e-mail',
    'pos.caisseClosedOffline': 'Caixa fechado. Conecte-se à Internet e abra o caixa no painel para realizar vendas.',
    'pos.caisseCachedHint': 'Status do caixa obtido do cache local (modo offline). A verificação final ocorrerá quando a Internet voltar.',
    'pos.catalog': 'Catálogo',
    'pos.available': '{{count}} disp.',
    'pos.outOfStockShort': 'Esgotado',
    'pos.acompteRepair': 'Sinal de reparo',
    'pos.rewardAvailable': 'Recompensa disponível!',
    'pos.rewardAutoApplied': '-15% aplicado automaticamente',
    'pos.purchases': 'compras',
    'pos.beforeReward': '({{count}} antes da recompensa)',
    'pos.searchClientPlaceholder': 'Buscar...',
    'pos.clientName': 'Nome do cliente',
    'pos.phone': 'Telefone',
    'pos.emailOptional': 'E-mail (opcional)',
    'pos.totalCaps': 'TOTAL',
    'pos.willGenerateTickets': 'Esta venda gerará {{count}} cupons separados:',
    'pos.neutralItems': 'neutros',
    'pos.attachedToSession': '(vinculados à sessão)',
    'pos.clientEmailPlaceholder': 'E-mail do cliente',
    'pos.sent': 'Enviado',
    'pos.send': 'Enviar',
    'pos.alsoAddToStock': 'Adicionar também ao estoque',
    'pos.offlineCbHint': 'Modo offline — pagamento com cartão desativado (o terminal precisa de rede).',
    'pos.whichMagasinTitle': 'Em qual loja registrar a venda?',
    'pos.close': 'Fechar',
    'pos.magasinChoiceHelp': 'Escolha a loja onde registrar esta venda. A loja selecionada será usada para a venda e para os itens sem loja explícita.',
    'pos.magasinLabel': 'Loja {{code}}',
    'pos.currentPosSessionFull': 'Sessão de PDV atual: {{code}}. Se você escolher outra loja, a sessão de PDV mudará para ela nesta venda.',
    'pos.validateFor': 'Confirmar para {{magasin}}',
    'pos.createClientAccount': 'Criar uma conta de cliente?',
    'pos.createAccountPrompt': 'Este cliente ainda não tem conta. Deseja criar uma conta para ele acessar suas notas fiscais online?',
    'pos.creating': 'Criando...',
    'pos.yesSendCredentials': 'Sim, enviar as credenciais',
    'pos.noThanks': 'Não, obrigado',
    'pos.searchRepair': 'Buscar o reparo',
    'pos.searchRepairPlaceholder': 'REP0047, nome do cliente, modelo...',
    'pos.priceLabel': 'Preço: {{price}}',
    'pos.alreadyPaid': 'Já pago: {{amount}}',
    'pos.remainingDue': 'Saldo devedor: {{amount}}',
    'pos.changeSelection': 'Alterar',
    'pos.totalPrice': 'Preço total',
    'pos.alreadyPaidShort': 'Já pago',
    'pos.remainingDueShort': 'Saldo devedor',
    'pos.acompteAmountLabel': 'Valor do sinal (EUR)',
    'pos.addToCart': 'Adicionar ao carrinho',
    'pos.saleRecordedTickets': 'Venda registrada — {{count}} cupons gerados',
    'pos.printAllForClient': 'Imprima os {{count}} cupons para o cliente.',
    'pos.printed': 'Impresso',
    'pos.scanToFind': 'Escaneie para encontrar {{ref}}',
    'pos.detailUnavailable': 'Detalhe indisponível (modo offline?)',
    'pos.payment': 'Pagamento',
    'pos.printing': 'Imprimindo...',
    'pos.printTicketFor': 'Imprimir cupom {{magasin}}',
    'pos.allTicketsSentToPrint': 'Todos os cupons foram enviados para impressão.',
    'pos.ticketsPrintedCount': '{{printed}} / {{total}} cupom(ns) impresso(s).',
    'pos.printAllTickets': 'Imprimir todos os cupons',
    'pos.articlesCount': '{{count}} item(ns)',
    'activite.pageTitle': 'Central de atividades',
    'activite.pageSubtitle': 'Linha do tempo unificada · vendas · pagamentos · caixa · estoque · reparos',
    'activite.historiqueDetaille': 'Histórico detalhado',
    'remcaches.err_connexion': 'Erro de conexão com o servidor',
    'remcaches.err_champs_requis': 'Nome de usuário e código PIN obrigatórios',
    'remcaches.err_pin_court': 'O código PIN deve ter pelo menos 4 dígitos',
    'remcaches.err_creation': 'Erro durante a criação',
    'remcaches.config_initiale': 'Configuração inicial',
    'remcaches.deja_config': 'Configuração já concluída',
    'remcaches.admin_existe': 'Já existe um administrador. Esta página está desativada.',
    'remcaches.aller_connexion': 'Ir para o login',
    'remcaches.admin_cree': 'Administrador criado com sucesso!',
    'remcaches.label_utilisateur': 'Usuário:',
    'remcaches.label_role': 'Função:',
    'remcaches.conserver_identifiants': 'Guarde estas credenciais em local seguro. Esta página não estará mais acessível.',
    'remcaches.se_connecter': 'Entrar',
    'remcaches.label_username': 'Nome de usuário *',
    'remcaches.ph_username': 'ex.: carlos',
    'remcaches.label_pin': 'Código PIN (senha) *',
    'remcaches.ph_pin': '4 a 6 dígitos',
    'remcaches.label_email': 'E-mail (opcional)',
    'remcaches.label_telephone': 'Telefone (opcional)',
    'remcaches.btn_creer_admin': 'Criar administrador',
    'remcaches.footer': 'R.E.Mobiles - Configuração segura',
    'blog.page_title': 'Blog de Reparo de Celulares',
    'blog.subtitle': 'Dicas, truques e novidades sobre o reparo de smartphones na Guiana Francesa.',
    'blog.cta_title': 'Precisa de um reparo?',
    'blog.cta_desc': 'Entre em contato com a Resurrection Mobile para um orçamento gratuito.',
    'blog.loading': 'Carregando...',
    'blog.article_not_found': 'Artigo não encontrado',
    'blog.back_to_blog': 'Voltar ao blog',
    'blog.home': 'Início',
    'blog.see_pricing': 'Ver nossos preços',
    'blog.footer_pricing': 'Nossos preços',
    'blog.empty_title': 'Nenhum artigo por enquanto',
    'blog.empty_subtitle': 'Volte em breve para conferir nossas dicas!',
    'brandsModels.error': 'Erro',
    'brandsModels.deleteBrandConfirm': 'Excluir a marca "{{name}}" e todos os seus modelos?',
    'brandsModels.noModels': 'Nenhum modelo.',
    'brandsModels.home': 'Início',
    'brandsModels.title': 'Marcas e modelos',
    'brandsModels.countBrands': '{{count}} marcas',
    'brandsModels.countSeries': '{{count}} séries',
    'brandsModels.countModels': '{{count}} modelos',
    'brandsModels.searchPlaceholder': 'Buscar uma marca, série ou modelo...',
    'brandsModels.newBrandPlaceholder': 'Nova marca...',
    'brandsModels.addBrand': 'Adicionar',
    'brandsModels.loading': 'Carregando...',
    'brandsModels.rename': 'Renomear',
    'brandsModels.delete': 'Excluir',
    'brandsModels.addModelPlaceholder': 'Adicionar um modelo {{brand}}...',
    'brandsModels.addModel': 'Modelo',
    'brandsModels.deleteModel': 'Excluir este modelo',
    'brandsModels.noResults': 'Nenhum resultado para esta busca',
    'brandsModels.empty': 'Nenhuma marca. Adicione uma acima.',
    'allDocs.title': 'Todos os documentos',
    'allDocs.docsCount': '{{count}} documentos',
    'allDocs.stat.devis': 'Orçamentos',
    'allDocs.stat.factures': 'Faturas',
    'allDocs.stat.bonsCmd': 'Pedidos',
    'allDocs.stat.tickets': 'Tickets',
    'allDocs.stat.total': 'Total',
    'allDocs.searchPlaceholder': 'Pesquisar por ref., cliente, telefone...',
    'allDocs.filter': 'Filtrar',
    'allDocs.filterAll': 'Todos',
    'allDocs.type.devis': 'Orçamento',
    'allDocs.type.facture': 'Fatura',
    'allDocs.type.bonCommande': 'Ordem de compra',
    'allDocs.type.ticket': 'Ticket',
    'allDocs.col.reference': 'Referência',
    'allDocs.col.type': 'Tipo',
    'allDocs.col.client': 'Cliente',
    'allDocs.col.telephone': 'Telefone',
    'allDocs.col.total': 'Total',
    'allDocs.col.statut': 'Status',
    'allDocs.col.liaisons': 'Vínculos',
    'allDocs.col.date': 'Data',
    'allDocs.col.actions': 'Ações',
    'allDocs.loading': 'Carregando...',
    'allDocs.empty': 'Nenhum documento encontrado',
    'allDocs.status.devis': 'Orçamento',
    'allDocs.status.enAttente': 'Em espera',
    'allDocs.status.accepte': 'Aceito',
    'allDocs.status.refuse': 'Recusado',
    'allDocs.status.payee': 'Paga',
    'allDocs.status.commande': 'Pedido',
    'allDocs.status.enCours': 'Em andamento',
    'allDocs.status.recu': 'Recebido',
    'allDocs.status.livre': 'Entregue',
    'allDocs.status.termine': 'Concluído',
    'allDocs.action.print': 'Imprimir / Ver PDF',
    'allDocs.action.download': 'Baixar PDF',
    'allDocs.action.email': 'Enviar por e-mail',
    'allDocs.footerCount': '{{count}} documento exibido',
    'allDocs.footerCountPlural': '{{count}} documentos exibidos',
    'allDocs.printUnavailable': 'Impressão de ticket de 80 mm indisponível para este documento (source={{source}}).',
    'allDocs.downloadUnavailable': 'Download indisponível para este tipo de documento (source={{source}}).',
    'allDocs.emailUnavailable': 'Envio por e-mail indisponível para este tipo de documento (source={{source}}).',
    'allDocs.emailPrompt': 'E-mail do destinatário:',
    'allDocs.emailSent': 'E-mail enviado!',
    'allDocs.error': 'Erro: {{msg}}',
    'themeSettings.title': 'Personalização de cores',
    'themeSettings.subtitle': 'Adapte a aparência da sua plataforma',
    'themeSettings.cancel': 'Cancelar',
    'themeSettings.saved': 'Salvo',
    'themeSettings.saving': 'Salvando...',
    'themeSettings.save': 'Salvar',
    'themeSettings.presetsTitle': 'Paletas predefinidas',
    'themeSettings.customTitle': 'Cores personalizadas',
    'themeSettings.previewTitle': 'Pré-visualização ao vivo',
    'themeSettings.previewCompany': 'Minha Empresa',
    'themeSettings.previewPrimaryBtn': 'Botão Principal',
    'themeSettings.previewSecondaryBtn': 'Botão Secundário',
    'themeSettings.previewNavDashboard': 'Painel',
    'themeSettings.previewNavRepairs': 'Reparos',
    'themeSettings.previewNavStock': 'Estoque',
    'themeSettings.previewNavClients': 'Clientes',
    'themeSettings.previewStatusInProgress': 'Em andamento',
    'themeSettings.previewStatusPending': 'Pendente',
    'themeSettings.fieldPrimaryLabel': 'Cor Principal',
    'themeSettings.fieldPrimaryDesc': 'Botões, links, destaques principais',
    'themeSettings.fieldSecondaryLabel': 'Cor Secundária',
    'themeSettings.fieldSecondaryDesc': 'Selos, indicadores, destaques secundários',
    'themeSettings.fieldAccentLabel': 'Cor de Destaque',
    'themeSettings.fieldAccentDesc': 'Fundo dos cabeçalhos, texto contrastante',
    'themeSettings.fieldSidebarBgLabel': 'Fundo da Barra Lateral',
    'themeSettings.fieldSidebarBgDesc': 'Plano de fundo do menu lateral',
    'themeSettings.fieldSidebarTextLabel': 'Texto da Barra Lateral',
    'themeSettings.fieldSidebarTextDesc': 'Cor do texto no menu',
    'themeSettings.fieldHeaderBgLabel': 'Fundo do Cabeçalho',
    'themeSettings.fieldHeaderBgDesc': 'Plano de fundo da barra superior',
    'themeSettings.presetRougeJaune': 'Vermelho e Amarelo',
    'themeSettings.presetGuyane': 'Guyane',
    'themeSettings.presetOceanBleu': 'Oceano Azul',
    'themeSettings.presetRoyalViolet': 'Violeta Real',
    'themeSettings.presetEmeraude': 'Esmeralda',
    'themeSettings.presetSunset': 'Pôr do sol',
    'boutiqueCmd.pageTitle': 'Pedidos E-shop',
    'boutiqueCmd.deleteSelection': 'Excluir seleção ({{count}})',
    'boutiqueCmd.confirmDelete': 'Excluir {{count}} pedido(s)?',
    'boutiqueCmd.errUpdate': 'Erro ao atualizar',
    'boutiqueCmd.errDelete': 'Erro ao excluir',
    'boutiqueCmd.noteSent': '✅ Nota enviada ao cliente com sucesso',
    'boutiqueCmd.errSendNote': 'Erro ao enviar a nota',
    'boutiqueCmd.trackingSavedEmail': '✅ Número de rastreamento salvo e e-mail enviado ao cliente!',
    'boutiqueCmd.trackingSaved': '✅ Número de rastreamento salvo!',
    'boutiqueCmd.errSaveTracking': 'Erro ao salvar',
    'boutiqueCmd.confirmValidateProof': 'Validar este comprovante de pagamento?',
    'boutiqueCmd.confirmRejectProof': 'Recusar este comprovante de pagamento?',
    'boutiqueCmd.errGeneric': 'Erro',
    'boutiqueCmd.errDownload': 'Erro ao baixar',
    'boutiqueCmd.statutEnAttente': 'Pendente',
    'boutiqueCmd.statutProofUploaded': 'Comprovante enviado',
    'boutiqueCmd.statutPayee': 'Pago',
    'boutiqueCmd.statutConfirmee': 'Confirmado',
    'boutiqueCmd.statutPreparee': 'Preparado',
    'boutiqueCmd.statutExpediee': 'Enviado',
    'boutiqueCmd.statutLivree': 'Entregue',
    'boutiqueCmd.statutAnnulee': 'Cancelado',
    'boutiqueCmd.colReference': 'Referência',
    'boutiqueCmd.colClient': 'Cliente',
    'boutiqueCmd.colArticles': 'Itens',
    'boutiqueCmd.colTotal': 'Total',
    'boutiqueCmd.colAdresse': 'Endereço',
    'boutiqueCmd.colStatut': 'Status',
    'boutiqueCmd.colSuivi': 'Rastreamento',
    'boutiqueCmd.colPaiement': 'Pagamento',
    'boutiqueCmd.colDate': 'Data',
    'boutiqueCmd.colActions': 'Ações',
    'boutiqueCmd.noOrders': 'Nenhum pedido',
    'boutiqueCmd.editTracking': 'Editar',
    'boutiqueCmd.addTrackingTitle': 'Adicionar número de rastreamento',
    'boutiqueCmd.addTrackingBtn': '+ Rastreamento',
    'boutiqueCmd.viewProof': 'Ver comprovante',
    'boutiqueCmd.validatePayment': 'Validar pagamento',
    'boutiqueCmd.rejectProof': 'Recusar comprovante',
    'boutiqueCmd.validated': 'Validado',
    'boutiqueCmd.notesMessages': 'Notas/Mensagens',
    'boutiqueCmd.notesModalTitle': 'Notas e mensagens - Pedido {{ref}}',
    'boutiqueCmd.clientLabel': 'Cliente:',
    'boutiqueCmd.phoneLabel': 'Telefone:',
    'boutiqueCmd.deliveryAddressLabel': 'Endereço de entrega:',
    'boutiqueCmd.notSpecified': 'Não especificado',
    'boutiqueCmd.exchangeHistory': 'Histórico de conversas',
    'boutiqueCmd.noNote': 'Nenhuma nota para este pedido',
    'boutiqueCmd.staff': '👤 Equipe',
    'boutiqueCmd.client': '👥 Cliente',
    'boutiqueCmd.clientResponse': 'Resposta do cliente:',
    'boutiqueCmd.sendMessageTitle': '✉️ Enviar uma mensagem ao cliente',
    'boutiqueCmd.notePlaceholder': 'Ex.: Olá, pode confirmar seu endereço de entrega? Obrigado.',
    'boutiqueCmd.noteHint': '💡 O cliente receberá esta mensagem e poderá responder pela área do cliente',
    'boutiqueCmd.close': 'Fechar',
    'boutiqueCmd.sending': 'Enviando...',
    'boutiqueCmd.sendToClient': 'Enviar ao cliente',
    'boutiqueCmd.trackingNumber': 'Número de rastreamento',
    'boutiqueCmd.orderShortLabel': 'Pedido:',
    'boutiqueCmd.clientShortLabel': 'Cliente:',
    'boutiqueCmd.trackingPlaceholder': 'Ex.: LA123456789FR',
    'boutiqueCmd.trackingHint': 'O cliente verá este número na área dele',
    'boutiqueCmd.cancel': 'Cancelar',
    'boutiqueCmd.saving': 'Salvando...',
    'boutiqueCmd.save': 'Salvar',
    'blogAdmin.confirmDelete': 'Excluir este artigo?',
    'blogAdmin.pageTitle': 'Blog e artigos SEO',
    'blogAdmin.pageSubtitle': 'Publique artigos e gerencie o conteúdo do blog',
    'blogAdmin.viewBlog': 'Ver o blog',
    'blogAdmin.newArticle': 'Novo artigo',
    'blogAdmin.tabArticles': 'Artigos',
    'blogAdmin.tabContent': 'Conteúdo da página',
    'blogAdmin.editArticle': 'Editar artigo',
    'blogAdmin.fieldTitle': 'Título *',
    'blogAdmin.titlePlaceholder': 'ex.: Reparo de tela de iPhone em Cayenne: preços e prazos',
    'blogAdmin.fieldExcerpt': 'Resumo (prévia)',
    'blogAdmin.excerptPlaceholder': 'Descrição curta para a lista...',
    'blogAdmin.fieldContent': 'Conteúdo * (Markdown suportado)',
    'blogAdmin.contentPlaceholder': 'Escreva seu artigo aqui...',
    'blogAdmin.fieldTags': 'Tags (separadas por vírgula)',
    'blogAdmin.tagsPlaceholder': 'reparo, iphone, cayenne',
    'blogAdmin.fieldMeta': 'Meta descrição SEO',
    'blogAdmin.metaPlaceholder': 'Descrição para o Google (160 car. máx.)',
    'blogAdmin.publishNow': 'Publicar imediatamente',
    'blogAdmin.update': 'Atualizar',
    'blogAdmin.save': 'Salvar',
    'blogAdmin.loading': 'Carregando...',
    'blogAdmin.noArticles': 'Nenhum artigo',
    'blogAdmin.noArticlesHint': 'Crie seu primeiro artigo para melhorar o SEO',
    'blogAdmin.statusPublished': 'PUBLICADO',
    'blogAdmin.statusDraft': 'RASCUNHO',
    'blogAdmin.byAuthor': 'Por {{author}}',
    'blogAdmin.unpublish': 'Despublicar',
    'blogAdmin.publish': 'Publicar',
    'blogAdmin.loadingContent': 'Carregando conteúdo...',
    'blogAdmin.contentNotice1': 'Edite aqui o conteúdo exibido na página pública ',
    'blogAdmin.contentNotice2': '. As alterações ficarão visíveis imediatamente.',
    'blogAdmin.blogHeader': 'Cabeçalho do blog',
    'blogAdmin.mainTitle': 'Título principal',
    'blogAdmin.accentWord': 'Palavra colorida (destaque)',
    'blogAdmin.description': 'Descrição',
    'blogAdmin.ctaSection': 'Chamada para ação (CTA nos artigos)',
    'blogAdmin.ctaTitle': 'Título do CTA',
    'blogAdmin.ctaDescription': 'Descrição do CTA',
    'blogAdmin.footerSection': 'Rodapé',
    'blogAdmin.footerText': 'Texto do rodapé',
    'blogAdmin.hidePreview': 'Ocultar prévia',
    'blogAdmin.livePreview': 'Prévia ao vivo',
    'blogAdmin.savedSuccess': 'Salvo com sucesso!',
    'blogAdmin.saving': 'Salvando...',
    'blogAdmin.saveContent': 'Salvar conteúdo',
    'blogAdmin.previewLabel': 'Prévia da página do blog',
    'businessCard.title': 'Cartões de visita',
    'businessCard.subtitle': 'Modelos, edição e impressão A4 (10 cartões)',
    'businessCard.previewBtn': 'Pré-visualizar',
    'businessCard.edit': 'Editar',
    'businessCard.printA4': 'Imprimir A4 (10 cartões)',
    'businessCard.chooseTemplate': 'Escolher um modelo ({{count}} disponíveis)',
    'businessCard.tplName.classic': 'Clássico',
    'businessCard.tplName.modern': 'Moderno',
    'businessCard.tplName.gradient': 'Degradê',
    'businessCard.tplName.minimal': 'Minimalista',
    'businessCard.tplName.gold': 'Ouro Premium',
    'businessCard.tplName.ocean': 'Oceano',
    'businessCard.tplName.forest': 'Floresta',
    'businessCard.tplName.sunset': 'Pôr do sol',
    'businessCard.tplName.corporate': 'Corporativo',
    'businessCard.tplName.pastel': 'Rosa Pastel',
    'businessCard.tplDesc.classic': 'Sóbrio e profissional',
    'businessCard.tplDesc.modern': 'Clean com detalhe ciano',
    'businessCard.tplDesc.gradient': 'Fundo degradê vibrante',
    'businessCard.tplDesc.minimal': 'Branco e nítido',
    'businessCard.tplDesc.gold': 'Preto e ouro luxuoso',
    'businessCard.tplDesc.ocean': 'Azul profundo relaxante',
    'businessCard.tplDesc.forest': 'Verde natural elegante',
    'businessCard.tplDesc.sunset': 'Laranja aconchegante',
    'businessCard.tplDesc.corporate': 'Azul-marinho profissional',
    'businessCard.tplDesc.pastel': 'Suave e feminino',
    'businessCard.logoTransparent': 'Logotipo com fundo transparente',
    'businessCard.cardInfo': 'Informações do cartão',
    'businessCard.field.companyName': 'Nome da empresa',
    'businessCard.field.subtitle': 'Subtítulo / Atividade',
    'businessCard.field.ownerName': 'Nome do responsável',
    'businessCard.field.ownerTitle': 'Cargo / Função',
    'businessCard.field.phone': 'Telefone',
    'businessCard.field.email': 'E-mail',
    'businessCard.field.address': 'Endereço',
    'businessCard.field.city': 'Cidade / CEP',
    'businessCard.field.website': 'Site',
    'businessCard.field.siret': 'SIRET',
    'businessCard.reset': 'Redefinir',
    'businessCard.previewTitle': 'Pré-visualização — {{name}}',
    'businessCard.viewFront': 'Ver frente',
    'businessCard.viewBack': 'Ver verso',
    'businessCard.standardFormat': 'Formato padrão: 85 x 55 mm',
    'businessCard.allTemplates': 'Todos os modelos',
    'businessCard.printTitle': 'Cartões de Visita',
    'businessCard.recto': 'FRENTE',
    'businessCard.verso': 'VERSO',
    'hub.title': 'Central',
    'hub.refresh': 'Atualizar',
    'hub.kpiTicketsOpen': '{{n}} tickets abertos',
    'hub.kpiFacturesToday': '{{n}} notas do dia ({{total}})',
    'hub.kpiDevisOpen': '{{n}} orçamentos abertos',
    'hub.magasinDefaultName': 'Loja 1',
    'hub.magasinBadgeTitle': 'Loja atual (PDV) — {{name}}',
    'hub.counterViewDetailed': 'Visão detalhada',
    'hub.counterViewCompact': 'Visão compacta',
    'hub.counterMagasinTitle': '{{name}} — {{tickets}} tickets · {{devis}} orçamentos · {{total}}',
    'hub.counterCompact': '{{tickets}}T·{{devis}}O·{{total}}',
    'hub.counterTickets': 'tickets',
    'hub.counterDevis': 'orçamentos',
    'hub.counterPerDay': '€/dia',
    'hub.searchPlaceholder': 'Pesquisar uma REF (REM0143, POS-..., DEV-00002), um cliente, um telefone…',
    'hub.filterAll': 'Todos',
    'hub.filterToday': 'Hoje',
    'hub.filterOverdue': 'Atrasados',
    'hub.filterPaid': 'Pagos',
    'hub.filterUnpaid': 'Não pagos',
    'hub.columnReparations': 'Reparos',
    'hub.columnFactures': 'Notas fiscais',
    'hub.columnDevis': 'Orçamentos',
    'hub.seeAll': 'Ver tudo',
    'hub.empty': 'Nenhum item',
    'hub.actionView': 'Ver',
    'hub.actionPrint': 'Imprimir',
    'hub.actionMail': 'Enviar por e-mail',
    'hub.actionMarkReady': 'Marcar como pronto',
    'hub.walkinClient': 'Cliente de balcão',
    'hub.invoicedAs': '→ Faturado: {{ref}}',
    'hub.errorPrint': 'Erro ao imprimir',
    'hub.errorPopupBlocked': 'Permita os pop-ups para imprimir.',
    'hub.statusWaiting': 'Aguardando',
    'hub.statusInProgress': 'Em andamento',
    'hub.statusReady': 'Pronto',
    'hub.statusDelivered': 'Entregue',
    'hub.statusPaid': 'Paga',
    'hub.statusInvoiced': 'Faturado',
    'hub.statusSent': 'Enviado',
    'hub.statusAccepted': 'Aceito',
    'hub.statusCancelled': 'Cancelado',
    'hub.statusDone': 'Concluído',
    'subscription.title': 'Minha assinatura',
    'subscription.subtitle': 'Gerencie seu plano e sua cobrança',
    'subscription.currentPlan': 'Plano atual',
    'subscription.status': 'Status',
    'subscription.statusActive': 'Ativo',
    'subscription.statusTrial': 'Teste gratuito',
    'subscription.monthlyPrice': 'Preço mensal',
    'subscription.perMonth': '/mês',
    'subscription.nextBilling': 'Próximo pagamento',
    'subscription.changePlan': 'Alterar plano',
    'subscription.redirecting': 'Redirecionando...',
    'subscription.upgrade': 'Fazer upgrade',
    'subscription.downgrade': 'Fazer downgrade',
    'subscription.upgradeTitle': 'Upgrade de plano',
    'subscription.downgradeTitle': 'Downgrade de plano',
    'subscription.newPlan': 'Novo plano',
    'subscription.newMonthlyPrice': 'Novo preço mensal',
    'subscription.upgradeDiffNow': 'Diferença a pagar agora',
    'subscription.changeFee': 'Taxa de alteração',
    'subscription.downgradeFeeNotice': 'Uma taxa fixa de {{amount}} se aplica a qualquer downgrade de plano.',
    'subscription.cancel': 'Cancelar',
    'subscription.confirmWithAmount': 'Confirmar ({{amount}})',
    'subscription.toastChanged': 'Seu plano foi alterado com sucesso!',
    'subscription.toastCancelled': 'A alteração de plano foi cancelada.',
    'subscription.errorPreview': 'Erro durante a pré-visualização',
    'subscription.errorChange': 'Erro ao alterar o plano',
    'subscription.featStartRepairs': 'Gestão de reparos',
    'subscription.featStartClients': 'Acompanhamento de clientes',
    'subscription.featStartQuotesInvoices': 'Orçamentos e faturas',
    'subscription.featStartOnePos': '1 ponto de venda',
    'subscription.featProAllStart': 'Tudo do plano Start',
    'subscription.featProMultiUsers': 'Multiusuário',
    'subscription.featProAdvancedStats': 'Estatísticas avançadas',
    'subscription.featProThreePos': '3 pontos de venda',
    'subscription.featProPrioritySupport': 'Suporte prioritário',
    'subscription.featSuperAllPro': 'Tudo do plano Pro',
    'subscription.featSuperUnlimitedPos': 'Pontos de venda ilimitados',
    'subscription.featSuperCustomApi': 'API personalizada',
    'subscription.featSuperDedicatedSupport': 'Suporte dedicado 24/7',
    'subscription.featSuperWhiteLabel': 'Marca branca',
    'terms.title': 'Termos gerais de uso',
    'terms.edition': 'Junho de 2026',
    'terms.introBefore': 'Os presentes termos regem o uso do site',
    'terms.introMiddle': ', da área do cliente, do chat de suporte e dos serviços de reparo oferecidos por',
    'terms.introAfter': ', SASU, Caiena, Guiana Francesa.',
    'terms.acceptIntro': 'Ao criar uma conta ou ao entrar em contato conosco (site, chat, WhatsApp), você aceita estes termos, bem como a nossa',
    'terms.privacyPolicy': 'política de privacidade',
    'terms.servicesTitle': 'Serviços',
    'terms.servicesBody': 'Reparo e venda de telefones, acompanhamento de pós-venda, orçamentos, pagamentos on-line quando ativados, atendimento por chat ou WhatsApp Business.',
    'terms.pricingTitle': 'Preços',
    'terms.pricingBody': 'Os orçamentos e preços informados (loja, chat, WhatsApp) são indicativos até a validação no ponto de venda.',
    'terms.dataTitle': 'Dados pessoais',
    'terms.dataBefore': 'Seus dados são tratados em conformidade com o RGPD (GDPR). Solicitação de exclusão:',
    'terms.dataAfter': 'ou consulte a seção “Seus direitos” da política de privacidade.',
    'terms.contactTitle': 'Contato',
    'notifSettings.title': 'Notificações push',
    'notifSettings.intro': 'Receba um alerta nativo (Windows / macOS / Android) assim que um evento importante acontece na loja. Reservado à equipe da R.E.Mobiles.',
    'notifSettings.statusUnsupported': 'Não suportado (requer iOS 16.4+)',
    'notifSettings.statusBlocked': 'Bloqueadas (permissão negada)',
    'notifSettings.statusEnabled': 'Ativadas neste navegador',
    'notifSettings.statusDisabled': 'Não ativadas',
    'notifSettings.activeCount': '{{count}} assinatura(s) ativa(s)',
    'notifSettings.enableBtn': 'Ativar notificações',
    'notifSettings.testBtn': 'Enviar notif. de teste',
    'notifSettings.disableBtn': 'Desativar',
    'notifSettings.iosHintPre': 'No iPhone, as notificações push da web exigem',
    'notifSettings.iosHintPost': 'e o app instalado na tela inicial (PWA). Atualize seu iPhone e reinstale o app.',
    'notifSettings.blockedHint': 'Permissão negada. Abra as configurações do site no navegador, permita as notificações para este domínio e recarregue a página.',
    'notifSettings.categoriesTitle': 'Categorias',
    'notifSettings.categoriesHint': 'Desative o que você não quer receber. Aplicado imediatamente, para esta conta.',
    'notifSettings.catNewTicketLabel': 'Novo ticket de reparo',
    'notifSettings.catNewTicketDesc': 'Um registro de entrega é criado na loja.',
    'notifSettings.catTicketReadyLabel': 'Ticket marcado como "Pronto"',
    'notifSettings.catTicketReadyDesc': 'O técnico marca o reparo como pronto. Lembre-se de avisar o cliente.',
    'notifSettings.catNewInvoiceLabel': 'Nova fatura POS',
    'notifSettings.catNewInvoiceDesc': 'Uma venda acaba de ser recebida.',
    'notifSettings.catNewChatLabel': 'Nova mensagem no chat',
    'notifSettings.catNewChatDesc': 'DM de equipe, cliente ou B2B.',
    'notifSettings.catDevisLabel': 'Orçamento criado ou aceito',
    'notifSettings.catDevisDesc': 'Um novo orçamento é gerado ou um cliente clica em Aceitar.',
    'notifSettings.accountLabel': 'Conta',
    'notifSettings.roleLabel': 'Função',
    'notifSettings.totalSubsLabel': 'Total de assinaturas',
    'notifSettings.errPermDenied': 'Permissão negada. Ative as notificações nas configurações do navegador.',
    'notifSettings.errPermNotGranted': 'Permissão não concedida.',
    'notifSettings.errVapidUnavailable': 'Chave VAPID indisponível no servidor.',
    'notifSettings.infoEnabled': 'Notificações ativadas neste navegador.',
    'notifSettings.errEnableFailed': 'Falha na ativação.',
    'notifSettings.infoDisabled': 'Notificações desativadas neste navegador.',
    'notifSettings.errDisableFailed': 'Falha na desativação.',
    'notifSettings.errPrefsUpdate': 'Falha ao atualizar as preferências.',
    'notifSettings.infoTestSent': 'Notificação de teste enviada ({{sent}}/{{subs}}). Verifique a central de notificações do seu SO.',
    'notifSettings.errNoneSent': 'Nenhuma notificação enviada. Verifique se as notificações estão ativadas neste navegador.',
    'notifSettings.errTestFailed': 'Falha no teste.',
    'guyarepairLogin.subscriberSpace': 'Área do assinante',
    'guyarepairLogin.businessLoginTitle': 'Login da empresa',
    'guyarepairLogin.businessLoginSubtitle': 'Acesse seu painel GUYAREPAIR',
    'guyarepairLogin.emailLabel': 'E-mail',
    'guyarepairLogin.emailPlaceholder': 'seu@email.com',
    'guyarepairLogin.passwordLabel': 'Senha',
    'guyarepairLogin.passwordPlaceholder': 'Sua senha',
    'guyarepairLogin.loggingIn': 'Entrando...',
    'guyarepairLogin.loginButton': 'Entrar',
    'guyarepairLogin.twoFATitle': 'Verificação 2FA',
    'guyarepairLogin.twoFASubtitle': 'Digite o código do seu aplicativo de autenticação',
    'guyarepairLogin.otpLabel': 'Código de 6 dígitos',
    'guyarepairLogin.verifying': 'Verificando...',
    'guyarepairLogin.verifyButton': 'Verificar',
    'guyarepairLogin.backToLogin': 'Voltar ao login',
    'guyarepairLogin.notSubscribedYet': 'Ainda não é assinante?',
    'guyarepairLogin.freeTrial': 'Teste grátis',
    'guyarepairLogin.secureConnection': 'Conexão segura',
    'guyarepairLogin.guyarepairHome': 'Início GUYAREPAIR',
    'guyarepairLogin.errInvalidCredentials': 'Credenciais incorretas',
    'guyarepairLogin.err2FAInvalid': 'Código 2FA inválido',
    'analytics.period_today': 'Hoje',
    'analytics.period_7d': '7 dias',
    'analytics.period_30d': '30 dias',
    'analytics.period_90d': '90 dias',
    'analytics.period_365d': '1 ano',
    'analytics.alert_suspicious_found': '{{count}} IP(s) suspeito(s) detectado(s)!',
    'analytics.alert_no_suspicious': 'Nenhum IP suspeito detectado.',
    'analytics.page_title': 'Análises — Visitas',
    'analytics.page_subtitle': 'Acompanhamento de visitas em todos os seus sites',
    'analytics.refresh': 'Atualizar',
    'analytics.tab_dashboard': 'Painel',
    'analytics.tab_visits': 'Visitas',
    'analytics.tab_blocked': 'IPs bloqueados',
    'analytics.tab_alerts': 'Alertas de IP',
    'analytics.all_sites': 'Todos os sites',
    'analytics.kpi_total_visits': 'Visitas totais',
    'analytics.kpi_unique_visitors': 'Visitantes únicos',
    'analytics.kpi_active_sites': 'Sites ativos',
    'analytics.kpi_countries': 'Países',
    'analytics.visits_per_day': 'Visitas por dia',
    'analytics.by_site': 'Por site',
    'analytics.by_country': 'Por país',
    'analytics.top_pages': 'Páginas mais visitadas',
    'analytics.visits_per_hour': 'Visitas por hora',
    'analytics.empty_no_visits': 'Nenhuma visita registrada para este período',
    'analytics.empty_install_script': 'O script de rastreamento deve ser instalado em seus sites',
    'analytics.search_placeholder': 'Pesquisar por IP, página, país...',
    'analytics.col_date': 'Data',
    'analytics.col_site': 'Site',
    'analytics.col_page': 'Página',
    'analytics.col_country_city': 'País / Cidade',
    'analytics.col_screen': 'Tela',
    'analytics.col_action': 'Ação',
    'analytics.no_visits': 'Nenhuma visita',
    'analytics.blocked_inline': '(BLOQUEADO)',
    'analytics.unblock': 'Desbloquear',
    'analytics.block': 'Bloquear',
    'analytics.visits_count': '{{count}} visitas',
    'analytics.blocked_ips_title': 'Endereços IP bloqueados',
    'analytics.active_count': '{{count}} ativa(s)',
    'analytics.col_status': 'Status',
    'analytics.col_reason': 'Motivo',
    'analytics.col_blocked_by': 'Bloqueado por',
    'analytics.no_blocked_ips': 'Nenhum IP bloqueado',
    'analytics.status_blocked': 'BLOQUEADO',
    'analytics.status_inactive': 'INATIVO',
    'analytics.reblock': 'Bloquear novamente',
    'analytics.alert_config_title': 'Configuração de alertas',
    'analytics.checking': 'Verificando...',
    'analytics.check_now': 'Verificar agora',
    'analytics.saving': 'Salvando...',
    'analytics.save': 'Salvar',
    'analytics.alerts_enabled': 'Alertas ativados',
    'analytics.alerts_enabled_desc': 'Monitora IPs suspeitos a cada 15 min',
    'analytics.threshold_label': 'Limite (visitas/hora)',
    'analytics.alert_email_label': 'E-mail de alerta',
    'analytics.autoblock': 'Bloqueio automático',
    'analytics.autoblock_desc': 'Bloquear automaticamente os IPs que ultrapassarem o limite',
    'analytics.alert_history_title': 'Histórico de alertas',
    'analytics.alerts_count': '{{count}} alerta(s)',
    'analytics.no_alerts': 'Nenhum alerta acionado',
    'analytics.col_visits_per_hour': 'Visitas/h',
    'analytics.col_sites': 'Sites',
    'analytics.col_autoblocked': 'Bloqueado automaticamente',
    'analytics.col_email': 'E-mail',
    'analytics.yes': 'SIM',
    'analytics.no': 'NÃO',
    'analytics.sent': 'ENVIADO',
    'analytics.confirm_block_title': 'Bloquear este IP?',
    'analytics.confirm_block_ip_prefix': 'O IP ',
    'analytics.confirm_block_ip_suffix': ' será bloqueado em todos os sites',
    'analytics.block_reason_placeholder': 'Motivo do bloqueio (opcional)...',
    'analytics.cancel': 'Cancelar',
    'analytics.blocking': 'Bloqueando...',
    'analytics.confirm_block': 'Confirmar bloqueio',
    'guyarepairLanding.navTarifs': 'Preços',
    'guyarepairLanding.navAnnuaire': 'Diretório',
    'guyarepairLanding.navMaReparation': 'Meu reparo',
    'guyarepairLanding.navConnexion': 'Entrar',
    'guyarepairLanding.navEssaiGratuit': 'Teste grátis',
    'guyarepairLanding.heroBadge': 'Plataforma SaaS de gestão de reparos',
    'guyarepairLanding.heroTitleLine1': 'Gerencie sua oficina de',
    'guyarepairLanding.heroTitleLine2': 'reparo',
    'guyarepairLanding.heroTitleHighlight': 'facilmente',
    'guyarepairLanding.heroSubtitle': 'O GUYAREPAIR é a solução completa para oficinas de reparo. PDV, acompanhamento de reparos, gestão de estoque, faturamento e fidelidade do cliente — tudo em uma única plataforma.',
    'guyarepairLanding.heroCtaStart': 'Começar gratuitamente',
    'guyarepairLanding.heroCtaPricing': 'Ver preços',
    'guyarepairLanding.repairLookupTitle': 'Localizar meu reparo',
    'guyarepairLanding.repairLookupSubtitle': 'Informe a referência do seu reparo para acompanhar o andamento',
    'guyarepairLanding.repairLookupPlaceholder': 'Ex.: TFX0001, MBR0012...',
    'guyarepairLanding.rechercher': 'Buscar',
    'guyarepairLanding.repairErrorDefault': 'Erro durante a busca',
    'guyarepairLanding.repairFoundAt': 'Reparo encontrado em',
    'guyarepairLanding.statutTermine': 'Concluído',
    'guyarepairLanding.statutEnCours': 'Em andamento',
    'guyarepairLanding.statutEnAttente': 'Pendente',
    'guyarepairLanding.labelReference': 'Referência',
    'guyarepairLanding.labelAppareil': 'Aparelho',
    'guyarepairLanding.labelProbleme': 'Problema',
    'guyarepairLanding.voirPageDe': 'Ver a página de {{nom}}',
    'guyarepairLanding.directoryTitle': 'Encontre seu reparador',
    'guyarepairLanding.directorySubtitle': 'Busque uma loja de reparo parceira GUYAREPAIR',
    'guyarepairLanding.searchPlaceholder': 'Nome da loja, cidade...',
    'guyarepairLanding.resultats': '{{count}} resultado(s)',
    'guyarepairLanding.featuresTitle': 'Tudo o que você precisa',
    'guyarepairLanding.featuresSubtitle': 'Um conjunto completo de ferramentas para sua oficina',
    'guyarepairLanding.feature1Title': 'Gestão de reparos',
    'guyarepairLanding.feature1Desc': 'Acompanhamento completo de cada reparo, do diagnóstico à entrega',
    'guyarepairLanding.feature2Title': 'Ponto de Venda (PDV)',
    'guyarepairLanding.feature2Desc': 'Recebimentos, cálculo de preços, gestão de caixa integrada',
    'guyarepairLanding.feature3Title': 'Estoque e inventário',
    'guyarepairLanding.feature3Desc': 'Movimentações de estoque, alertas, fornecedores e pedidos',
    'guyarepairLanding.feature4Title': 'Clientes e fidelidade',
    'guyarepairLanding.feature4Desc': 'Base de clientes, programa de fidelidade com recompensas',
    'guyarepairLanding.feature5Title': 'Orçamentos e faturas',
    'guyarepairLanding.feature5Desc': 'Criação rápida de orçamentos, conversão em fatura, envio por e-mail',
    'guyarepairLanding.feature6Title': 'Multilojas',
    'guyarepairLanding.feature6Desc': 'Gerencie várias lojas a partir de um único painel',
    'guyarepairLanding.pricingTitle': 'Preços simples e transparentes',
    'guyarepairLanding.pricingSubtitle': 'Escolha o plano ideal para o seu negócio',
    'guyarepairLanding.popular': 'POPULAR',
    'guyarepairLanding.perMonth': 'EUR/mês',
    'guyarepairLanding.commencer': 'Começar',
    'guyarepairLanding.copyright': '© {{year}} REMCOMPANY. Todos os direitos reservados.',
    'guyarepairLanding.trademarkNotice': 'GUYAREPAIR é a marca comercial do serviço.',
    'guyarepairLanding.passwordTooShort': 'A senha deve ter pelo menos 6 caracteres',
    'guyarepairLanding.registerErrorDefault': 'Erro durante o cadastro',
    'guyarepairLanding.registerSuccessTitle': 'Cadastro concluído!',
    'guyarepairLanding.successAccountCreated': 'Sua conta foi criada com um',
    'guyarepairLanding.successTrial': 'teste grátis de 5 dias',
    'guyarepairLanding.successLoginHint': 'Entre para configurar seu espaço. Um e-mail de boas-vindas foi enviado.',
    'guyarepairLanding.seConnecter': 'Entrar',
    'guyarepairLanding.createAccountTitle': 'Crie sua conta',
    'guyarepairLanding.planLine': 'Plano {{nom}} — {{prix}} EUR/mês',
    'guyarepairLanding.planLabel': 'Plano',
    'guyarepairLanding.companyNameLabel': 'Nome da empresa',
    'guyarepairLanding.contactNameLabel': 'Nome do contato',
    'guyarepairLanding.phoneLabel': 'Telefone',
    'guyarepairLanding.emailLabel': 'E-mail',
    'guyarepairLanding.passwordLabel': 'Senha',
    'guyarepairLanding.cityLabel': 'Cidade',
    'guyarepairLanding.addressLabel': 'Endereço',
    'guyarepairLanding.directoryToggle': 'Aparecer no diretório público GUYAREPAIR',
    'guyarepairLanding.creating': 'Criando...',
    'guyarepairLanding.createMyAccount': 'Criar minha conta',
    'guyarepairLanding.alreadyRegistered': 'Já tem cadastro?',
    'alertsConfig.saved': 'Configuração de alertas salva',
    'alertsConfig.error': 'Erro',
    'alertsConfig.title': 'Alertas automáticos',
    'alertsConfig.subtitle': 'Configure os alertas automáticos para a sua empresa. Você receberá um e-mail diário se as condições forem atendidas.',
    'alertsConfig.emailAlertsLabel': 'Alertas por e-mail',
    'alertsConfig.emailAlertsDesc': 'Ativar os alertas automáticos por e-mail (reparos pendentes, falta de estoque)',
    'alertsConfig.repairAlertsTitle': 'Alertas de reparos pendentes',
    'alertsConfig.repairAlertsDesc': 'Receba um e-mail quando um reparo estiver pendente há mais de X dias.',
    'alertsConfig.delayLabel': 'Prazo (dias)',
    'alertsConfig.daysShort': '{{n}}d',
    'alertsConfig.stockAlertsTitle': 'Alertas de estoque',
    'alertsConfig.stockAlertsDesc': 'Receba um e-mail quando os artigos estiverem em falta ou abaixo de um limite.',
    'alertsConfig.lowStockThresholdLabel': 'Limite de estoque baixo',
    'alertsConfig.clientNotifLabel': 'Notificações a clientes',
    'alertsConfig.clientNotifDesc': 'Enviar um e-mail ao cliente quando o status do reparo mudar (concluído, em andamento, etc.)',
    'alertsConfig.emailSenderInfo': 'O e-mail será enviado a partir do endereço que você configurou, ou do GUYAREPAIR por padrão.',
    'alertsConfig.saving': 'Salvando...',
    'alertsConfig.save': 'Salvar',
    'companyAnalytics.title': 'Análises',
    'companyAnalytics.subtitle': 'Visão geral do desempenho da sua empresa',
    'companyAnalytics.loadError': 'Erro ao carregar',
    'companyAnalytics.kpiRepairsToday': 'Reparos hoje',
    'companyAnalytics.kpiThisWeek': '{{count}} esta semana',
    'companyAnalytics.kpiRevenueToday': 'Receita hoje',
    'companyAnalytics.kpiThisMonthAmount': '{{amount}} este mês',
    'companyAnalytics.kpiClients': 'Clientes',
    'companyAnalytics.kpiNewThisMonth': '{{count}} novos este mês',
    'companyAnalytics.kpiAvgTime': 'Tempo médio',
    'companyAnalytics.daysShort': '{{count}}d',
    'companyAnalytics.kpiPerRepair': 'por reparo',
    'companyAnalytics.statTotalRepairs': 'Total de reparos',
    'companyAnalytics.statActive': 'Ativas',
    'companyAnalytics.statCompleted': 'Concluídas',
    'companyAnalytics.statStockItems': 'Itens em estoque',
    'companyAnalytics.statOutOfStock': 'Sem estoque',
    'companyAnalytics.repairsByStore': 'Reparos em andamento por loja',
    'companyAnalytics.repairsM1Explicit': '{{count}} reparos M1 explícitos',
    'companyAnalytics.repairsLegacy': '{{count}} reparos legados (pré-M2)',
    'companyAnalytics.totalShown': 'Total exibido: {{count}}',
    'companyAnalytics.repairsM2': '{{count}} reparos M2',
    'companyAnalytics.repairsTrend14Days': 'Reparos (últimos 14 dias)',
    'companyAnalytics.statusDistribution': 'Distribuição de status',
    'companyAnalytics.noRepairs': 'Nenhum reparo',
    'companyAnalytics.revenue': 'Receita',
    'companyAnalytics.revToday': 'Hoje',
    'companyAnalytics.revThisWeek': 'Esta semana',
    'companyAnalytics.revThisMonth': 'Este mês',
    'companyAnalytics.revTotal': 'Total',
    'companyAnalytics.statusPending': 'Em espera',
    'companyAnalytics.statusInProgress': 'Em andamento',
    'companyAnalytics.statusCompleted': 'Concluído',
    'companyAnalytics.statusDelivered': 'Entregue',
    'companyAnalytics.statusCancelled': 'Cancelado',
    'staffCommissions.title': 'Minhas comissões',
    'staffCommissions.pdfDownloadError': 'Erro ao baixar o PDF',
    'staffCommissions.downloadMonthSheet': 'Baixar minha ficha do mês:',
    'staffCommissions.generating': 'Gerando…',
    'staffCommissions.downloadPdf': 'Baixar PDF',
    'staffCommissions.toReceive': 'A receber',
    'staffCommissions.alreadyReceived': 'Já recebido',
    'staffCommissions.totalCumulative': 'Total acumulado',
    'staffCommissions.detailByType': 'Detalhe por tipo',
    'staffCommissions.toPay': 'A pagar: {{amount}}',
    'staffCommissions.paidDetail': 'Pago: {{amount}}',
    'staffCommissions.noCommissionYet': 'Nenhuma comissão ainda',
    'staffCommissions.filterAll': 'Todas',
    'staffCommissions.filterPending': 'A pagar',
    'staffCommissions.filterPaid': 'Pagas',
    'staffCommissions.filterCancelled': 'Canceladas',
    'staffCommissions.colDate': 'Data',
    'staffCommissions.colType': 'Tipo',
    'staffCommissions.colTransaction': 'Transação',
    'staffCommissions.colAmountTtc': 'Valor com impostos',
    'staffCommissions.colCommission': 'Comissão',
    'staffCommissions.colStatus': 'Status',
    'staffCommissions.noCommission': 'Nenhuma comissão',
    'staffCommissions.month1': 'Janeiro',
    'staffCommissions.month2': 'Fevereiro',
    'staffCommissions.month3': 'Março',
    'staffCommissions.month4': 'Abril',
    'staffCommissions.month5': 'Maio',
    'staffCommissions.month6': 'Junho',
    'staffCommissions.month7': 'Julho',
    'staffCommissions.month8': 'Agosto',
    'staffCommissions.month9': 'Setembro',
    'staffCommissions.month10': 'Outubro',
    'staffCommissions.month11': 'Novembro',
    'staffCommissions.month12': 'Dezembro',
    'staffCommissions.typeVentes': 'Venda PDV',
    'staffCommissions.typeCommandes': 'Pedido',
    'staffCommissions.typeAcomptes': 'Sinal',
    'staffCommissions.typeReparations': 'Reparo',
    'staffCommissions.typeFactures': 'Fatura',
    'staffCommissions.typeDevis': 'Orçamento',
    'staffCommissions.typeB2b': 'B2B',
    'staffCommissions.typeDeplacement': 'Deslocamento',
    'labelConfig.title': 'Configuração de etiquetas',
    'labelConfig.subtitle': 'Ajuste as margens e dimensões para sua impressora',
    'labelConfig.reset': 'Valores padrão',
    'labelConfig.save': 'Salvar',
    'labelConfig.saving': 'Salvando...',
    'labelConfig.saved': 'Salvo',
    'labelConfig.save_error': 'Erro ao salvar: {{error}}',
    'labelConfig.global_dimensions': 'Dimensões gerais',
    'labelConfig.label_width': 'Largura da etiqueta',
    'labelConfig.label_height': 'Altura da etiqueta',
    'labelConfig.cols': 'Colunas',
    'labelConfig.rows': 'Linhas',
    'labelConfig.margins_spacing': 'Margens e espaçamento',
    'labelConfig.left_margin': 'Margem esquerda',
    'labelConfig.top_margin': 'Margem superior',
    'labelConfig.h_spacing': 'Espaçamento H',
    'labelConfig.v_spacing': 'Espaçamento V',
    'labelConfig.col_offset_title': 'Deslocamento por coluna',
    'labelConfig.cols_count': '({{count}} colunas)',
    'labelConfig.col_n': 'Col {{n}}',
    'labelConfig.col_offset_hint': 'Valores positivos = deslocamento para a direita. Negativos = para a esquerda.',
    'labelConfig.row_offset_title': 'Deslocamento por linha',
    'labelConfig.rows_count': '({{count}} linhas)',
    'labelConfig.row_n': 'Linha {{n}}',
    'labelConfig.row_offset_hint': 'Valores positivos = deslocamento para cima. Negativos = para baixo.',
    'labelConfig.preview_title': 'Pré-visualização folha A4',
    'labelConfig.preview_count': '{{cols}} x {{rows}} = {{total}} etiquetas/folha',
    'labelConfig.preview_dims': '{{width}} x {{height}} mm',
    'paymentConfig.title': 'Configuração de pagamentos',
    'paymentConfig.statusActiveTitle': 'Pagamentos on-line ativos',
    'paymentConfig.providerLabel': 'Provedor: {{name}}',
    'paymentConfig.statusInactiveTitle': 'Pagamentos on-line desativados',
    'paymentConfig.statusInactiveDesc': 'Configure um provedor para aceitar pagamentos on-line. Somente pagamentos off-line (dinheiro, cartão na loja) estão disponíveis.',
    'paymentConfig.chooseProvider': 'Escolha seu provedor de pagamento:',
    'paymentConfig.apiKeysTitle': 'Chaves de API {{name}}',
    'paymentConfig.savedPlaceholder': 'Salva: {{value}}',
    'paymentConfig.save': 'Salvar',
    'paymentConfig.testConnection': 'Testar conexão',
    'paymentConfig.infoTitle': 'Informações importantes',
    'paymentConfig.info1': 'Os pagamentos on-line são depositados diretamente na sua conta de comerciante.',
    'paymentConfig.info2': 'Suas chaves de API são criptografadas e armazenadas com segurança.',
    'paymentConfig.info3': 'Sem uma configuração válida, somente pagamentos off-line estão disponíveis.',
    'paymentConfig.info4': 'Cada empresa gerencia suas próprias chaves de forma independente.',
    'paymentConfig.saveError': 'Erro ao salvar',
    'paymentConfig.testError': 'Erro no teste',
    'paymentConfig.disableConfirm': 'Desativar os pagamentos on-line?',
    'paymentConfig.stripeDesc': 'Pagamentos com cartão, Apple Pay, Google Pay',
    'paymentConfig.sumupDesc': 'Terminal de cartão POS V2 + pagamentos on-line (merchant_code, client_id/secret)',
    'paymentConfig.fieldPublicKey': 'Chave pública (pk_...)',
    'paymentConfig.fieldSecretKey': 'Chave secreta (sk_...)',
    'paymentConfig.fieldWebhookSecret': 'Segredo do webhook (whsec_...)',
    'paymentConfig.fieldApiKey': 'Chave de API',
    'paymentConfig.fieldMerchantCode': 'Código de comerciante',
    'paymentConfig.fieldClientId': 'Client ID',
    'paymentConfig.fieldClientSecret': 'Client Secret',
    'loyaltyAdmin.title': 'Programa de Fidelidade',
    'loyaltyAdmin.subtitle': 'Acompanhamento de pontos e recompensas dos clientes',
    'loyaltyAdmin.refresh': 'Atualizar',
    'loyaltyAdmin.kpiMembers': 'Membros',
    'loyaltyAdmin.kpiPendingRewards': 'Recompensas pendentes',
    'loyaltyAdmin.kpiRedeemed': 'Recompensas resgatadas',
    'loyaltyAdmin.kpiThreshold': 'Limite para recompensa',
    'loyaltyAdmin.purchasesSuffix': 'compras',
    'loyaltyAdmin.rewardRule': '-{{pos}}% POS / -{{repair}}% reparo',
    'loyaltyAdmin.topClients': 'Principais clientes fiéis',
    'loyaltyAdmin.clientFallback': 'Cliente',
    'loyaltyAdmin.flashOffers': 'Ofertas Relâmpago',
    'loyaltyAdmin.newOffer': 'Nova oferta',
    'loyaltyAdmin.createFlashOffer': 'Criar uma oferta relâmpago',
    'loyaltyAdmin.offerTitlePlaceholder': 'Título da oferta (ex.: Weekend Special)',
    'loyaltyAdmin.offerDescPlaceholder': 'Descrição (ex.: Reparo de tela com preço reduzido)',
    'loyaltyAdmin.discountLabel': 'Desconto (%)',
    'loyaltyAdmin.endDateLabel': 'Data de término',
    'loyaltyAdmin.targetLevelsLabel': 'Níveis alvo',
    'loyaltyAdmin.creating': 'Criando...',
    'loyaltyAdmin.createOffer': 'Criar oferta',
    'loyaltyAdmin.noOffers': 'Nenhuma oferta relâmpago criada',
    'loyaltyAdmin.offerMeta': 'Alvos: {{levels}} | E-mails: {{emails}}',
    'loyaltyAdmin.offerEnd': ' | Término: {{date}}',
    'loyaltyAdmin.deactivate': 'Desativar',
    'loyaltyAdmin.activate': 'Ativar',
    'loyaltyAdmin.sendByEmail': 'Enviar por e-mail',
    'loyaltyAdmin.delete': 'Excluir',
    'loyaltyAdmin.allMembers': 'Todos os membros ({{count}})',
    'loyaltyAdmin.searchPlaceholder': 'Pesquisar...',
    'loyaltyAdmin.colClient': 'Cliente',
    'loyaltyAdmin.colPhone': 'Telefone',
    'loyaltyAdmin.colPurchases': 'Compras',
    'loyaltyAdmin.colPoints': 'Pontos',
    'loyaltyAdmin.colTotalSpent': 'Total gasto',
    'loyaltyAdmin.colStatus': 'Status',
    'loyaltyAdmin.colRewards': 'Recompensas',
    'loyaltyAdmin.noMembers': 'Nenhum membro',
    'loyaltyAdmin.rewardAvailable': 'Recompensa disponível',
    'loyaltyAdmin.purchasesRemaining': '{{count}} compras restantes',
    'loyaltyAdmin.pageOf': 'Página {{page}} / {{total}}',
    'loyaltyAdmin.confirmDeleteOffer': 'Excluir esta oferta?',
    'loyaltyAdmin.emailsSent': 'E-mails enviados',
    'loyaltyAdmin.levelBronze': 'Bronze',
    'loyaltyAdmin.levelArgent': 'Prata',
    'loyaltyAdmin.levelOr': 'Ouro',
    'emailConfig.pageTitle': 'Configuração de e-mail',
    'emailConfig.pageSubtitle': 'Configure o servidor SMTP para o envio de faturas, orçamentos e notificações por e-mail.',
    'emailConfig.smtpSection': 'Servidor SMTP',
    'emailConfig.fieldHost': 'Host SMTP',
    'emailConfig.fieldPort': 'Porta',
    'emailConfig.fieldUser': 'Usuário SMTP (e-mail)',
    'emailConfig.fieldPassword': 'Senha do e-mail',
    'emailConfig.passwordPlaceholderExisting': '•••••••• (deixe vazio para manter)',
    'emailConfig.passwordPlaceholderNew': 'Senha do e-mail Hostinger',
    'emailConfig.useSsl': 'Usar SSL/TLS (recomendado na porta 465)',
    'emailConfig.enableEmails': 'Ativar o envio de e-mails',
    'emailConfig.tipTitle': 'Dica da Hostinger:',
    'emailConfig.tipBody': 'a senha do e-mail é diferente da senha do hPanel. Você pode verificá-la ou redefini-la em hPanel → E-mails → Contas de e-mail → Gerenciar.',
    'emailConfig.senderSection': 'Remetente',
    'emailConfig.fieldSenderName': 'Nome do remetente',
    'emailConfig.fieldSenderEmail': 'E-mail do remetente',
    'emailConfig.saving': 'Salvando…',
    'emailConfig.save': 'Salvar',
    'emailConfig.testing': 'Enviando…',
    'emailConfig.testConnection': 'Testar a conexão',
    'emailConfig.disable': 'Desativar',
    'emailConfig.loadError': 'Erro ao carregar (HTTP {{status}})',
    'emailConfig.saveSuccess': 'Configuração salva. Agora você pode clicar em «Testar a conexão».',
    'emailConfig.saveErrorFallback': 'Erro ao salvar',
    'emailConfig.testSuccess': 'E-mail de teste enviado. Verifique sua caixa de entrada.',
    'emailConfig.testErrorFallback': 'Falha no teste SMTP. Verifique a senha do e-mail Hostinger (diferente da senha do hPanel).',
    'emailConfig.disableConfirm': 'Desativar a configuração personalizada? O servidor voltará à configuração .env padrão.',
    'emailConfig.disableSuccess': 'Configuração personalizada desativada.',
    'emailConfig.disableErrorFallback': 'Erro ao desativar',
    'promosCalendar.title': 'Calendário de promoções',
    'promosCalendar.subtitle': 'Promoções programadas por dia',
    'promosCalendar.empty': 'Nenhuma promoção programada para este mês.',
    'adminIntegrations.supplierCredentials': 'Credenciais de fornecedores (Mobilax · Jens · LCD-Phone)',
    'adminIntegrations.generateStockPhotos': 'Gerar fotos de estoque (IA) — M1 / M2',
    'adminIntegrations.stockCategoryAudit': 'Auditoria de categorias de estoque — telefone / IMEI / acessórios',
    'printerTokens.title': 'Tokens do agente de impressão',
    'printerTokens.desc': 'Gestão dos tokens usados pelo agente do Windows para se autenticar no backend. Um token por estação (recomendado) ou um token compartilhado para instalações pequenas.',
    'printerTokens.newBtn': 'Novo token',
    'printerTokens.includeRevoked': 'Incluir tokens revogados',
    'printerTokens.refresh': 'Atualizar',
    'printerTokens.loading': 'Carregando…',
    'printerTokens.emptyPre': 'Nenhum token. Clique em',
    'printerTokens.emptyPost': 'para criar um.',
    'printerTokens.colLabel': 'Rótulo',
    'printerTokens.colType': 'Tipo',
    'printerTokens.colPreview': 'Prévia',
    'printerTokens.colCreated': 'Criado em',
    'printerTokens.colLastUsed': 'Último uso',
    'printerTokens.colStatus': 'Status',
    'printerTokens.colActions': 'Ações',
    'printerTokens.typeShared': 'Compartilhado',
    'printerTokens.typePersonal': 'Pessoal',
    'printerTokens.createdBy': 'por {{user}}',
    'printerTokens.statusRevoked': 'Revogado',
    'printerTokens.statusActive': 'Ativo',
    'printerTokens.revoke': 'Revogar',
    'printerTokens.securityTitle': 'Segurança',
    'printerTokens.securityHashPre': 'Os tokens são armazenados como hash (SHA-256). O token completo',
    'printerTokens.securityHashEmph': 'nunca é exibido novamente',
    'printerTokens.securityHashPost': 'após sua criação. Se você esquecê-lo, revogue-o e crie um novo.',
    'printerTokens.securityAudit': 'Toda criação e revogação é registrada no log de auditoria do administrador.',
    'printerTokens.createTitle': 'Novo token de agente',
    'printerTokens.createLabelField': 'Rótulo (ex.: PC Caixa, Notebook do Carlos)',
    'printerTokens.createLabelPlaceholder': 'PC Caixa',
    'printerTokens.createSharedLabel': 'Token compartilhado (utilizável por várias estações)',
    'printerTokens.createSharedHint': 'Apenas um token compartilhado ativo por vez. Por segurança, prefira um token por estação.',
    'printerTokens.cancel': 'Cancelar',
    'printerTokens.create': 'Criar',
    'printerTokens.revealTitle': 'Token criado — copie-o agora',
    'printerTokens.revealLabelPrefix': 'Rótulo:',
    'printerTokens.revealConfigPre': 'Configure seu agente do Windows com este token no cabeçalho',
    'printerTokens.revealConfigPost': '.',
    'printerTokens.copied': 'Copiado',
    'printerTokens.copy': 'Copiar',
    'printerTokens.revealClose': 'Anotei o token',
    'printerTokens.revokeTitle': 'Revogar este token?',
    'printerTokens.revokeMsgPre': 'O token',
    'printerTokens.revokeMsgPost': 'não poderá mais autenticar nenhum agente. Esta operação fica registrada no log e não exclui o token (você pode exibi-lo marcando “Incluir tokens revogados”).',
    'printerTokens.actionError': 'Erro: {{detail}}',
    'servicePrices.pageTitle': 'Preços de reparo',
    'servicePrices.pageSubtitle': 'Gerencie os preços e o conteúdo da página pública',
    'servicePrices.viewPublicPage': 'Ver página pública',
    'servicePrices.add': 'Adicionar',
    'servicePrices.tabPrices': 'Preços',
    'servicePrices.tabContent': 'Conteúdo da página',
    'servicePrices.editPriceTitle': 'Editar preço',
    'servicePrices.newPriceTitle': 'Novo preço',
    'servicePrices.brand': 'Marca *',
    'servicePrices.choose': 'Escolher...',
    'servicePrices.model': 'Modelo',
    'servicePrices.modelPlaceholder': 'ex.: iPhone 14 Pro',
    'servicePrices.repairType': 'Tipo de reparo *',
    'servicePrices.delay': 'Prazo',
    'servicePrices.delayPlaceholder': 'ex.: 30 min',
    'servicePrices.priceMin': 'Preço mín. (EUR)',
    'servicePrices.priceMax': 'Preço máx. (EUR)',
    'servicePrices.order': 'Ordem',
    'servicePrices.visiblePublic': 'Visível ao público',
    'servicePrices.btnUpdate': 'Modificar',
    'servicePrices.btnSave': 'Salvar',
    'servicePrices.loading': 'Carregando...',
    'servicePrices.noPrices': 'Nenhum preço registrado',
    'servicePrices.noPricesHint': 'Adicione seus primeiros preços para exibi-los na página pública',
    'servicePrices.colRepair': 'Reparo',
    'servicePrices.colPrice': 'Preço',
    'servicePrices.colVisible': 'Visível',
    'servicePrices.colActions': 'Ações',
    'servicePrices.allModels': 'Todos os modelos',
    'servicePrices.contentLoading': 'Carregando o conteúdo...',
    'servicePrices.contentBannerPre': 'Edite aqui o conteúdo exibido na página pública',
    'servicePrices.contentBannerPost': '. As alterações aparecem imediatamente após salvar.',
    'servicePrices.headerSection': 'Cabeçalho da página',
    'servicePrices.mainTitle': 'Título principal',
    'servicePrices.accentWord': 'Palavra em destaque (acento)',
    'servicePrices.seoDescription': 'Descrição SEO',
    'servicePrices.contactInfo': 'Informações de contato',
    'servicePrices.phone': 'Telefone',
    'servicePrices.phoneDisplay': 'Tel. exibido',
    'servicePrices.whatsappLabel': 'WhatsApp (com código do país)',
    'servicePrices.address': 'Endereço',
    'servicePrices.hours': 'Horário',
    'servicePrices.trustBadges': 'Selos de confiança',
    'servicePrices.addShort': '+ Adicionar',
    'servicePrices.titleField': 'Título',
    'servicePrices.description': 'Descrição',
    'servicePrices.faqTitle': 'Perguntas frequentes (FAQ)',
    'servicePrices.question': 'Pergunta',
    'servicePrices.answer': 'Resposta',
    'servicePrices.ctaSection': 'Seção de chamada para ação (CTA)',
    'servicePrices.ctaTitle': 'Título do CTA',
    'servicePrices.ctaDescription': 'Descrição do CTA',
    'servicePrices.footer': 'Rodapé',
    'servicePrices.line1': 'Linha 1',
    'servicePrices.line2': 'Linha 2',
    'servicePrices.hidePreview': 'Ocultar prévia',
    'servicePrices.livePreview': 'Prévia ao vivo',
    'servicePrices.savedSuccess': 'Salvo com sucesso!',
    'servicePrices.saving': 'Salvando...',
    'servicePrices.saveContent': 'Salvar conteúdo',
    'servicePrices.previewLabel': 'Prévia da página pública',
    'servicePrices.faqShort': 'FAQ',
    'servicePrices.confirmDelete': 'Excluir este preço?',
    'servicePrices.repairTypes.ecran': 'Tela',
    'servicePrices.repairTypes.batterie': 'Bateria',
    'servicePrices.repairTypes.connecteurCharge': 'Conector de carga',
    'servicePrices.repairTypes.cameraArriere': 'Câmera traseira',
    'servicePrices.repairTypes.cameraAvant': 'Câmera frontal',
    'servicePrices.repairTypes.hautParleur': 'Alto-falante',
    'servicePrices.repairTypes.micro': 'Microfone',
    'servicePrices.repairTypes.boutonPower': 'Botão power',
    'servicePrices.repairTypes.boutonVolume': 'Botão de volume',
    'servicePrices.repairTypes.vitreArriere': 'Vidro traseiro',
    'servicePrices.repairTypes.nappeFaceId': 'Flex Face ID',
    'servicePrices.repairTypes.carteMere': 'Placa-mãe',
    'servicePrices.repairTypes.diagnostique': 'Diagnóstico',
    'servicePrices.repairTypes.desoxydation': 'Desoxidação',
    'servicePrices.repairTypes.autre': 'Outro',
    'companySettings.toast.loadError': 'Erro ao carregar as configurações',
    'companySettings.toast.saveSuccess': 'Configurações salvas com sucesso',
    'companySettings.toast.saveError': 'Erro ao salvar',
    'companySettings.toast.notImage': 'O arquivo deve ser uma imagem',
    'companySettings.toast.tooLarge': 'O arquivo não deve exceder 5 MB',
    'companySettings.toast.logoSuccess': 'Logotipo atualizado com sucesso',
    'companySettings.toast.logoError': 'Erro ao enviar o logotipo',
    'companySettings.toast.previewError': 'Erro ao gerar a pré-visualização',
    'companySettings.tabs.info': 'Informações',
    'companySettings.tabs.documents': 'Documentos (Faturas, Orçamentos, Pedidos)',
    'companySettings.tabs.payment': 'Pagamento',
    'companySettings.tabs.logo': 'Logotipo',
    'companySettings.tabs.preview': 'Pré-visualização PDF',
    'companySettings.tabs.security': 'Segurança',
    'companySettings.title': 'Configurações da empresa',
    'companySettings.subtitle': 'Configure as informações da sua empresa e seus documentos',
    'companySettings.save': 'Salvar',
    'companySettings.info.sectionTitle': 'Informações da empresa',
    'companySettings.info.companyNameLabel': 'Nome da empresa',
    'companySettings.info.companyNamePlaceholder': 'Ex.: Minha Empresa Ltda',
    'companySettings.info.legalFormLabel': 'Forma jurídica',
    'companySettings.info.legalFormPlaceholder': 'Ex.: S.A., Ltda, MEI...',
    'companySettings.info.capitalLabel': 'Capital social',
    'companySettings.info.capitalPlaceholder': 'Ex.: 1.000 EUR',
    'companySettings.info.siretLabel': 'SIRET',
    'companySettings.info.siretPlaceholder': 'Ex.: 123 456 789 00014',
    'companySettings.info.rcsLabel': 'RCS',
    'companySettings.info.rcsPlaceholder': 'Ex.: Paris B 123 456 789',
    'companySettings.info.phoneLabel': 'Telefone',
    'companySettings.info.phonePlaceholder': 'Ex.: +594 694 XX XX XX',
    'companySettings.info.emailLabel': 'E-mail',
    'companySettings.info.emailPlaceholder': 'Ex.: contato@minhaempresa.com',
    'companySettings.info.postalLabel': 'CEP',
    'companySettings.info.postalPlaceholder': 'Ex.: 97300',
    'companySettings.info.addressLabel': 'Endereço',
    'companySettings.info.addressPlaceholder': 'Ex.: Rua Principal, 10',
    'companySettings.info.cityLabel': 'Cidade',
    'companySettings.info.cityPlaceholder': 'Ex.: Caiena',
    'companySettings.info.tvaLabel': 'Menção de IVA',
    'companySettings.info.tvaPlaceholder': 'Menção fiscal nos documentos',
    'companySettings.documents.devisSectionTitle': 'Configurações de orçamentos',
    'companySettings.documents.devisValidityLabel': 'Validade do orçamento',
    'companySettings.documents.devisValidityPlaceholder': 'Período de validade do orçamento',
    'companySettings.documents.devisConditionsLabel': 'Condições gerais (orçamento)',
    'companySettings.documents.devisConditionsPlaceholder': 'Condições gerais exibidas nos orçamentos',
    'companySettings.documents.bcSectionTitle': 'Configurações de pedidos de compra',
    'companySettings.documents.bcConditionsLabel': 'Condições do pedido de compra',
    'companySettings.documents.bcConditionsPlaceholder': 'Condições de execução dos serviços',
    'companySettings.documents.factureSectionTitle': 'Configurações de faturas',
    'companySettings.documents.facturePaymentLabel': 'Condições de pagamento',
    'companySettings.documents.facturePaymentPlaceholder': 'Ex.: Pagamento no recebimento...',
    'companySettings.documents.facturePenaltiesLabel': 'Multas por atraso',
    'companySettings.documents.facturePenaltiesPlaceholder': 'Cláusula de multa por atraso',
    'companySettings.documents.factureRecoveryLabel': 'Indenização de cobrança',
    'companySettings.documents.factureRecoveryPlaceholder': 'Cláusula de indenização fixa',
    'companySettings.documents.factureReserveLabel': 'Reserva de domínio',
    'companySettings.documents.factureReservePlaceholder': 'Cláusula de reserva de domínio',
    'companySettings.documents.warrantySectionTitle': 'Garantia',
    'companySettings.documents.warrantyLabel': 'Menção de garantia',
    'companySettings.documents.warrantyPlaceholder': 'Ex.: Garantia de 6 meses sobre peças e mão de obra a partir da data do reparo.',
    'companySettings.documents.warrantyHint': 'Esta menção será exibida no rodapé das faturas se preenchida.',
    'companySettings.payment.sectionTitle': 'Pagamento online',
    'companySettings.payment.disableTitle': 'Desativar o pagamento online',
    'companySettings.payment.disableDesc': 'Quando ativado, as opções de pagamento online (Stripe) ficam ocultas em todos os orçamentos. Os clientes só poderão solicitar um link de pagamento SumUp.',
    'companySettings.payment.statusDisabled': 'Pagamento online DESATIVADO - Os clientes verão apenas o formulário de solicitação SumUp',
    'companySettings.payment.statusEnabled': 'Pagamento online ATIVADO - Os clientes podem pagar diretamente online',
    'companySettings.payment.howTitle': 'Como funciona?',
    'companySettings.payment.step1': '1. O cliente recebe o orçamento por e-mail e o aceita',
    'companySettings.payment.step2': '2. Em vez de pagar online, ele preenche um formulário com seu e-mail/telefone',
    'companySettings.payment.step3': '3. Você recebe uma notificação com a solicitação de pagamento',
    'companySettings.payment.step4': '4. Você envia manualmente o link de pagamento SumUp ao cliente',
    'companySettings.logo.sectionTitle': 'Logotipo da empresa',
    'companySettings.logo.description': 'Este logotipo será exibido em suas faturas, orçamentos e pedidos de compra (formatos PNG, JPG, máx. 5 MB).',
    'companySettings.logo.alt': 'Logotipo',
    'companySettings.logo.none': 'Nenhum logotipo',
    'companySettings.logo.uploading': 'Enviando...',
    'companySettings.logo.choose': 'Escolher um logotipo',
    'companySettings.logo.hint': 'O logotipo será redimensionado automaticamente nos documentos PDF.',
    'companySettings.preview.sectionTitle': 'Pré-visualização dos seus documentos',
    'companySettings.preview.description': 'Visualize um exemplo de fatura ou orçamento com suas configurações atuais (logotipo, informações, menções legais).',
    'companySettings.preview.saveReminder': 'Lembre-se de salvar suas alterações antes de gerar a pré-visualização.',
    'companySettings.preview.facture': 'Fatura',
    'companySettings.preview.devis': 'Orçamento',
    'companySettings.preview.generating': 'Gerando...',
    'companySettings.preview.generate': 'Gerar pré-visualização',
    'companySettings.preview.iframeTitle': 'Pré-visualização PDF',
    'companySettings.security.genericError': 'Erro',
    'companySettings.security.invalidCode': 'Código inválido',
    'companySettings.security.enabledToast': '2FA ativado com sucesso!',
    'companySettings.security.disabledToast': '2FA desativado',
    'companySettings.security.sectionTitle': 'Segurança da conta',
    'companySettings.security.twoFaTitle': 'Autenticação de dois fatores (2FA)',
    'companySettings.security.statusActive': 'Ativado',
    'companySettings.security.statusInactive': 'Desativado',
    'companySettings.security.intro': 'Proteja sua conta com uma verificação em duas etapas. A cada login, será solicitado um código de 6 dígitos além da sua senha.',
    'companySettings.security.configureBtn': 'Configurar 2FA',
    'companySettings.security.step1ScanPrefix': '1. Escaneie este QR code com',
    'companySettings.security.step1ScanSuffix': ':',
    'companySettings.security.qrAlt': 'QR Code 2FA',
    'companySettings.security.manualKeyLabel': 'Ou insira esta chave manualmente:',
    'companySettings.security.step2Enter': '2. Insira o código exibido no aplicativo:',
    'companySettings.security.activate': 'Ativar',
    'companySettings.security.protectedMsg': 'Sua conta está protegida por 2FA',
    'companySettings.security.disablePrompt': 'Para desativar, insira seu código atual:',
    'companySettings.security.disable': 'Desativar',
    'docTimezone.title': 'Horários dos documentos',
    'docTimezone.intro': 'Configure o fuso horário usado para datas e horas nos seus documentos (tickets, faturas, orçamentos, pedidos de compra).',
    'docTimezone.sectionTimezone': 'Fuso horário',
    'docTimezone.selectLabel': 'Selecione seu fuso horário',
    'docTimezone.currentLabel': 'Fuso atual:',
    'docTimezone.selectHint': 'Este fuso horário será aplicado a todas as datas exibidas nos seus documentos. A hora de registro dos tickets nunca mudará depois de salva.',
    'docTimezone.save': 'Salvar',
    'docTimezone.importantTitle': 'Importante',
    'docTimezone.importantBody': 'Por padrão, todos os documentos usam o fuso horário da Guiana Francesa (Caiena, UTC-3). Se você alterar essa configuração, os documentos futuros usarão o novo fuso horário. Os documentos já criados manterão sua hora de registro original.',
    'docTimezone.toastUpdated': 'Fuso horário atualizado',
    'docTimezone.errUpdate': 'Erro ao atualizar',
    'docTimezone.errNetwork': 'Erro de rede',
    'docTimezone.tzCayenne': 'Guiana Francesa (Caiena)',
    'docTimezone.tzMartinique': 'Martinica / Guadalupe',
    'docTimezone.tzGuadeloupe': 'Guadalupe',
    'docTimezone.tzParis': 'França metropolitana (Paris)',
    'docTimezone.tzReunion': 'Reunião',
    'docTimezone.tzNoumea': 'Nova Caledônia',
    'docTimezone.tzTahiti': 'Polinésia Francesa (Taiti)',
    'flashOffers.confirmDelete': 'Excluir esta oferta?',
    'flashOffers.emailsSentFallback': 'E-mails enviados',
    'flashOffers.pageTitle': 'Ofertas relâmpago e promoções',
    'flashOffers.pageSubtitle': 'Gerencie suas promoções temporárias e envie-as aos clientes fiéis',
    'flashOffers.newOffer': 'Nova oferta',
    'flashOffers.createTitle': 'Criar uma oferta relâmpago',
    'flashOffers.labelTitle': 'Título *',
    'flashOffers.placeholderTitle': 'Ex.: Especial de fim de semana',
    'flashOffers.labelDiscount': 'Desconto (%)',
    'flashOffers.labelDescription': 'Descrição',
    'flashOffers.placeholderDescription': 'Ex.: Reparo de tela com preço reduzido',
    'flashOffers.labelEndDate': 'Data de término',
    'flashOffers.labelTargetLevels': 'Níveis-alvo',
    'flashOffers.levelBronze': 'Bronze',
    'flashOffers.levelSilver': 'Prata',
    'flashOffers.levelGold': 'Ouro',
    'flashOffers.creating': 'Criando...',
    'flashOffers.createOffer': 'Criar oferta',
    'flashOffers.emptyTitle': 'Nenhuma oferta relâmpago criada',
    'flashOffers.emptyHint': 'Clique em "{{btn}}" para começar',
    'flashOffers.badgeExpired': 'Expirada',
    'flashOffers.badgeDisabled': 'Desativada',
    'flashOffers.endLabel': 'Término: {{date}}',
    'flashOffers.emailsCount': 'E-mails: {{count}}',
    'flashOffers.lastSent': 'Último envio: {{date}}',
    'flashOffers.deactivate': 'Desativar',
    'flashOffers.activate': 'Ativar',
    'flashOffers.sendByEmail': 'Enviar por e-mail',
    'flashOffers.delete': 'Excluir',
    'mailsAi.oauthDenied': 'Autorização do Google recusada.',
    'mailsAi.sessionExpired': 'Sessão expirada, tente novamente.',
    'mailsAi.tokenExchangeFailed': 'Erro de conexão com o Google, tente novamente.',
    'mailsAi.missingParams': 'Parâmetros ausentes.',
    'mailsAi.googleConnectError': 'Erro de conexão com o Google.',
    'mailsAi.errorWith': 'Erro: {{msg}}',
    'mailsAi.aiAnalysisError': 'Erro de análise de IA: {{msg}}',
    'mailsAi.confirmDeleteAccount': 'Excluir esta conta de e-mail e todas as suas mensagens armazenadas?',
    'mailsAi.confirmRefetch': 'Isto vai excluir todos os e-mails em cache e baixá-los novamente com a renderização HTML completa. Continuar?',
    'mailsAi.confirmBulkAnalyze': 'Analisar {{count}} e-mails não analisados? (Usa créditos de IA)',
    'mailsAi.fetchAnalyzedHeader': '{{count}} novos e-mails recuperados e analisados.',
    'mailsAi.alertsDetected': '{{count}} alerta(s) detectado(s):',
    'mailsAi.fetchAnalyzedNoThreat': '{{count}} novos e-mails recuperados e analisados automaticamente. Nenhuma ameaça detectada.',
    'mailsAi.fetchRetrieved': '{{count}} novos e-mails recuperados.',
    'mailsAi.noNewEmail': 'Nenhum e-mail novo.',
    'mailsAi.refetchDone': 'Ressincronização concluída! {{count}} e-mails recuperados com renderização HTML.',
    'mailsAi.allVisibleAnalyzed': 'Todos os e-mails visíveis já foram analisados!',
    'mailsAi.bulkAnalyzeDone': 'Análise concluída! {{done}}/{{total}} e-mails analisados.',
    'mailsAi.emailSent': 'E-mail enviado com sucesso!',
    'mailsAi.subtitle': 'Gestão inteligente dos seus e-mails profissionais',
    'mailsAi.autoRefresh': 'Atualização automática',
    'mailsAi.refresh': 'Atualizar',
    'mailsAi.analyzeAll': 'Analisar tudo',
    'mailsAi.compose': 'Novo e-mail',
    'mailsAi.addAccount': 'Adicionar uma conta',
    'mailsAi.loadingAccounts': 'Carregando contas...',
    'mailsAi.noAccountTitle': 'Nenhuma conta de e-mail conectada',
    'mailsAi.noAccountDesc': 'Conecte sua primeira conta de e-mail para começar.',
    'mailsAi.fetchingAll': 'Recuperando todos os e-mails...',
    'mailsAi.fetchingAllHint': 'Isto pode levar alguns minutos',
    'mailsAi.noEmail': 'Nenhum e-mail.',
    'mailsAi.noSubject': '(sem assunto)',
    'mailsAi.prev': 'Ant.',
    'mailsAi.next': 'Próx.',
    'mailsAi.pageOf': '{{page}} / {{total}}',
    'sumupTerminal.title': 'Terminal SumUp (maquininha)',
    'sumupTerminal.subtitle': 'Uma maquininha por loja — M1 e M2 são independentes. O POS V2 usa a maquininha da loja selecionada.',
    'sumupTerminal.hintM1': 'Maquininha Resurrection Mobile (SOLO)',
    'sumupTerminal.hintM2': 'A configurar quando a 2ª maquininha estiver pareada com a SumUp',
    'sumupTerminal.m2NotConfigured': 'M2 ainda não está configurada — é normal se a 2ª maquininha ainda não estiver pareada. Quando estiver, preencha os campos abaixo (conta SumUp M2 separada).',
    'sumupTerminal.step1Lead': 'No SumUp Cloud → Terminais → copie o',
    'sumupTerminal.step1Merchant': 'código do comerciante',
    'sumupTerminal.step1And': ' e o ',
    'sumupTerminal.step1Reader': 'ID do leitor',
    'sumupTerminal.step2Lead': 'Cole a',
    'sumupTerminal.step2Secret': 'chave SECRETA',
    'sumupTerminal.step2Mid': '(sup_sk_…) —',
    'sumupTerminal.step2Public': 'não a chave pública sup_pk_',
    'sumupTerminal.step3Lead': 'Clique em',
    'sumupTerminal.step3Verify': 'Verificar a chave API',
    'sumupTerminal.step3Rest': '→ o código do comerciante é preenchido automaticamente',
    'sumupTerminal.step4Lead': 'Selecione a maquininha na lista e depois',
    'sumupTerminal.step4Save': 'Salvar',
    'sumupTerminal.labelName': 'Nome da maquininha (opcional)',
    'sumupTerminal.namePlaceholder': 'Ex.: MINHA MAQUININHA M1',
    'sumupTerminal.labelApiKey': 'Chave API secreta da SumUp (sup_sk_…) *',
    'sumupTerminal.savedKeyPlaceholder': 'Salva: {{masked}}',
    'sumupTerminal.apiKeyHint': 'Apenas a chave secreta sup_sk_. A SumUp só a mostra uma vez, na criação.',
    'sumupTerminal.verifyKeyBtn': '1. Verificar a chave API',
    'sumupTerminal.keyConfirmed': '✓ Chave confirmada pela SumUp',
    'sumupTerminal.labelMerchantCode': 'Código do comerciante *',
    'sumupTerminal.labelReaderId': 'ID do leitor (reader) *',
    'sumupTerminal.discoverBtn': 'Encontrar minhas maquininhas',
    'sumupTerminal.readerFallback': 'Maquininha SumUp',
    'sumupTerminal.labelDeviceId': 'Identificador do dispositivo (opcional)',
    'sumupTerminal.saveBtn': 'Salvar {{mag}}',
    'sumupTerminal.testBtn': 'Teste de {{amount}} na maquininha',
    'sumupTerminal.checklistTitle': 'Checklist da maquininha',
    'sumupTerminal.checklistWifi': 'Terminal ligado e conectado ao Wi‑Fi',
    'sumupTerminal.checklistPaired': 'Status "Pareado" no SumUp Cloud',
    'sumupTerminal.checklistSolo': 'Software Solo ≥ 3.3.24',
    'sumupTerminal.checklistBluetooth': 'Bluetooth e API não funcionam juntos — desligue o Bluetooth no SOLO se usar o POS',
    'sumupTerminal.checklistCancel': 'Se o valor aparece e depois cancela sozinho: reconecte a API na maquininha (não é um bug do POS)',
    'sumupTerminal.openCloud': 'Abrir SumUp Cloud',
    'sumupTerminal.errLoad': 'Não foi possível carregar a configuração',
    'sumupTerminal.msgMerchantChanged': 'Conta do comerciante alterada — verifique a chave API e depois selecione a maquininha.',
    'sumupTerminal.errPasteSecret': 'Primeiro cole a chave secreta da SumUp (sup_sk_…), não a chave pública sup_pk_.',
    'sumupTerminal.keyOkReaders': 'Chave OK — conta {{mc}} · {{count}} maquininha(s) encontrada(s).',
    'sumupTerminal.keyOkNone': 'Chave OK — conta {{mc}} · nenhuma maquininha pareada no SumUp Cloud.',
    'sumupTerminal.errKeyRejected': 'Chave API recusada pela SumUp',
    'sumupTerminal.msgNoReaders': 'Nenhuma maquininha encontrada — verifique se o terminal está pareado no SumUp Cloud.',
    'sumupTerminal.errDiscover': 'Erro na busca da maquininha',
    'sumupTerminal.readerSelected': 'Maquininha selecionada: {{name}}',
    'sumupTerminal.errMerchantChangeKey': 'Mudança de conta SumUp: digite a nova chave API (sup_sk_…) antes de salvar.',
    'sumupTerminal.errVerifyFirst': 'Primeiro clique em "Verificar a chave API" — a SumUp precisa confirmar a chave antes de salvar.',
    'sumupTerminal.errReaderRequired': 'ID do leitor obrigatório — clique em "Encontrar minhas maquininhas" e selecione o terminal.',
    'sumupTerminal.savedWithNotice': 'Configuração {{mag}} salva. {{notice}}',
    'sumupTerminal.saved': 'Configuração {{mag}} salva.',
    'sumupTerminal.errSave': 'Erro ao salvar',
    'sumupTerminal.testOk': 'Teste OK — olhe a maquininha',
    'sumupTerminal.errTest': 'Teste falhou',
    'adminB2B.accessDenied': 'Acesso negado',
    'adminB2B.reservedAdmins': 'Restrito aos administradores.',
    'adminB2B.backToDashboard': 'Voltar ao painel',
    'adminB2B.back': 'Voltar',
    'adminB2B.title': 'Clientes B2B',
    'adminB2B.accountsSingular': 'Empresas cadastradas no portal B2B — {{count}} conta',
    'adminB2B.accountsPlural': 'Empresas cadastradas no portal B2B — {{count}} contas',
    'adminB2B.colCompany': 'Empresa',
    'adminB2B.colManager': 'Gerente',
    'adminB2B.colEmail': 'E-mail',
    'adminB2B.colPhone': 'Telefone',
    'adminB2B.colStatus': 'Status',
    'adminB2B.colRegistered': 'Cadastro',
    'adminB2B.empty': 'Nenhum cliente B2B',
    'adminB2B.statusValide': 'Validado',
    'adminB2B.statusEnAttente': 'Pendente',
    'adminB2B.statusRefuse': 'Recusado',
    'adminCache.statusCompleted': 'Concluído',
    'adminCache.statusRunning': 'Em andamento...',
    'adminCache.statusUpdating': 'Atualizando',
    'adminCache.statusError': 'Erro',
    'adminCache.never': 'Nunca',
    'adminCache.title': 'Dados dos fornecedores',
    'adminCache.refreshing': 'Atualizando...',
    'adminCache.refreshData': 'Atualizar os dados',
    'adminCache.step1Title': 'Etapa 1 — Credenciais dos fornecedores.',
    'adminCache.step1Intro': 'Insira o e-mail e a senha de Mobilax, JensMobiles e LCD-Phone na página',
    'adminCache.step1LinkText': 'Credenciais dos fornecedores',
    'adminCache.step1Outro': 'Depois volte aqui e clique em « {{action}} » para alimentar o Auto-Orçamento IA.',
    'adminCache.configurePasswords': 'Configurar senhas',
    'adminCache.totalCached': 'Total de produtos em cache',
    'adminCache.spareParts': 'Peças de reposição',
    'adminCache.accessories': 'Acessórios',
    'adminCache.phones': 'Telefones',
    'adminCache.syncState': 'Status da sincronização',
    'adminCache.noSync': 'Nenhuma sincronização realizada',
    'adminCache.exploreCache': 'Explorar o cache',
    'adminCache.searchPlaceholder': 'Pesquisar (ex.: capa iPhone 14, Galaxy A06 novo)...',
    'adminCache.allTypes': 'Todos os tipos',
    'adminCache.filterParts': 'Peças',
    'adminCache.filterAccessories': 'Acessórios',
    'adminCache.filterPhones': 'Telefones',
    'adminCache.colType': 'Tipo',
    'adminCache.colSupplier': 'Fornecedor',
    'adminCache.colPart': 'Peça',
    'adminCache.colBrand': 'Marca',
    'adminCache.colPrice': 'Preço',
    'adminCache.colStock': 'Estoque',
    'adminCache.colRef': 'Ref.',
    'adminCache.catPart': 'Peça',
    'adminCache.catAccessory': 'Acessório',
    'adminCache.catPhone': 'Telefone',
    'adminCache.inStock': 'Em estoque',
    'adminCache.outOfStock': 'Sem estoque',
    'adminCache.noResults': 'Nenhum resultado para "{{query}}"',
    'adminDownloads.artifactDesktopLabel': 'Aplicativo Windows da equipe',
    'adminDownloads.artifactDesktopDesc': 'Arquivo ZIP distribuído aos usuários do Windows.',
    'adminDownloads.artifactPackLabel': 'Pacote do agente de impressora',
    'adminDownloads.artifactPackDesc': 'Arquivo ZIP de origem para recompilar o agente de impressão.',
    'adminDownloads.artifactExeLabel': 'Agente do Windows',
    'adminDownloads.artifactExeDesc': 'Executável pronto para rodar na estação do técnico.',
    'adminDownloads.available': 'Disponível',
    'adminDownloads.missing': 'Ausente',
    'adminDownloads.download': 'Baixar',
    'adminDownloads.activeFile': 'Arquivo ativo',
    'adminDownloads.size': 'Tamanho',
    'adminDownloads.lastUpdate': 'Última atualização',
    'adminDownloads.uploadedBy': 'Enviado por',
    'adminDownloads.replaceLiveFile': 'Substituir o arquivo ativo',
    'adminDownloads.uploading': 'Enviando...',
    'adminDownloads.replace': 'Substituir',
    'adminDownloads.replaceHint': 'O arquivo escolhido substitui diretamente o que é fornecido aos usuários em remobiles.com.',
    'adminDownloads.selectedFile': 'Arquivo selecionado: {{name}}',
    'adminDownloads.loadError': 'Erro ao carregar os arquivos',
    'adminDownloads.downloadLinkUnavailable': 'Link de download indisponível',
    'adminDownloads.downloadFailed': 'Não foi possível baixar',
    'adminDownloads.selectFilePrompt': 'Selecione um arquivo para {{label}}.',
    'adminDownloads.confirmReplace': 'Substituir agora {{label}} por {{name}}?',
    'adminDownloads.replaceSuccess': '{{label}} substituído com sucesso.',
    'adminDownloads.uploadError': 'Erro durante o envio',
    'adminDownloads.title': 'Instaladores e downloads',
    'adminDownloads.subtitle': 'Downloads diretos dos pacotes Windows e substituição ao vivo para o superadministrador.',
    'adminDownloads.printerConfig': 'Configuração da impressora',
    'adminDownloads.refresh': 'Atualizar',
    'adminDownloads.availableArtifacts': 'Artefatos disponíveis',
    'adminDownloads.totalSize': 'Tamanho total',
    'adminDownloads.alert': 'Alerta',
    'adminDownloads.alertText': 'As substituições sobrescrevem o arquivo ativo. Não há exclusão separada.',
    'adminDownloads.accessTitle': 'Acesso de admin e superadmin',
    'adminDownloads.accessText': 'Esta página centraliza os downloads visíveis em remobiles.com. A substituição ao vivo dos arquivos só aparece para o superadministrador.',
    'adminDownloads.signedLinksNote': 'Os links de download permanecem assinados pelo backend para evitar blobs no navegador.',
    'adminCachePurge.accessDenied': 'Acesso restrito ao Carlos.',
    'adminCachePurge.title': 'Purga de documentos comerciais',
    'adminCachePurge.descIntro': 'Página oculta — apenas Carlos. Exclui vendas, registros, pedidos, sinais e orçamentos/faturas',
    'adminCachePurge.descBefore': 'antes de',
    'adminCachePurge.descOutro': 'a data escolhida. Os reparos não são afetados.',
    'adminCachePurge.warnBackupBefore': 'Ação destrutiva e irreversível. Faça uma exportação de backup em',
    'adminCachePurge.warnBackupLink': 'Banco de dados',
    'adminCachePurge.warnBackupAfter': 'antes de qualquer purga real.',
    'adminCachePurge.resultDryRunLine': 'Simulação concluída — {{count}} documento(s) seriam excluídos antes de {{before}}.',
    'adminCachePurge.resultPurgeLine': 'Purga executada — {{count}} documento(s) excluídos antes de {{before}}.',
    'adminCachePurge.sectionParams': 'Parâmetros',
    'adminCachePurge.labelBeforeDate': 'Excluir tudo antes de',
    'adminCachePurge.hintStrictlyBefore': 'Estritamente antes das 00:00 desse dia.',
    'adminCachePurge.labelConfirm': 'Confirmação (obrigatória)',
    'adminCachePurge.hintTypeToken': 'Digite: {{token}}',
    'adminCachePurge.dryRunLabel': 'Modo simulação (dry-run) — não exclui nada',
    'adminCachePurge.previewBtn': 'Pré-visualização',
    'adminCachePurge.simulateBtn': 'Simular a purga',
    'adminCachePurge.executeBtn': 'Executar a purga',
    'adminCachePurge.previewHeading': 'Pré-visualização — {{count}} documento(s)',
    'adminCachePurge.beforeLabel': 'antes de {{before}}',
    'adminCachePurge.previewEmpty': 'Nenhum dado para exibir.',
    'adminCachePurge.colCollection': 'Coleção',
    'adminCachePurge.colCount': 'Quantidade',
    'adminCachePurge.colExamples': 'Exemplos',
    'adminCachePurge.sectionExcluded': 'Não excluído',
    'adminCachePurge.excludedReparations': 'Reparos (dispositivos)',
    'adminCachePurge.excludedStock': 'Estoque',
    'adminCachePurge.excludedClients': 'Clientes',
    'adminCachePurge.excludedUtilisateurs': 'Usuários',
    'adminCachePurge.confirmDryRun': 'Simular purga antes de {{before}} ({{count}} documentos)?',
    'adminCachePurge.confirmDelete': '⚠️ IRREVERSÍVEL — Excluir {{count}} documentos comerciais antes de {{before}}?',
    'adminCachePurge.errorPreview': 'Erro na pré-visualização',
    'adminCachePurge.errorLoad': 'Erro de carregamento',
    'adminCachePurge.errorPurge': 'Erro na purga',
    'adminSupplierCreds.title': 'Credenciais de fornecedores',
    'adminSupplierCreds.subtitle': '{{providers}} — para o Auto-Devis e o cache do catálogo',
    'adminSupplierCreds.supplierData': 'Dados de fornecedores',
    'adminMagasins.statusActive': 'Ativo',
    'adminMagasins.statusArchived': 'Arquivado',
    'adminMagasins.newStore': 'Nova loja',
    'adminMagasins.fieldCode': 'Código (gerado automaticamente, editável)',
    'adminMagasins.fieldName': 'Nome *',
    'adminMagasins.namePlaceholder': 'ex.: Loja Cayenne Centro',
    'adminMagasins.fieldAddress': 'Endereço',
    'adminMagasins.fieldPhone': 'Telefone',
    'adminMagasins.fieldPrinterIp': 'Impressora (IP)',
    'adminMagasins.printerIpPlaceholder': 'ex.: 192.168.1.50  — deixe vazio se não houver impressora dedicada',
    'adminMagasins.printerIpHint': 'Se vazio → usa a impressora da sessão POS.',
    'adminMagasins.fieldBadgeColor': 'Cor do selo',
    'adminMagasins.setAsDefault': 'Definir como loja padrão',
    'adminMagasins.defaultWillBeDemoted': 'A loja {{code}} ({{name}}) é atualmente a padrão. Ela será rebaixada automaticamente.',
    'adminMagasins.cancel': 'Cancelar',
    'adminMagasins.createStore': 'Criar loja',
    'adminMagasins.nameRequired': 'Nome obrigatório',
    'adminMagasins.createError': 'Erro ao criar',
    'adminMagasins.confirmOverrideDefault': 'A loja "{{code}} — {{name}}" é atualmente a loja padrão.\n\nAo marcar "Definir como padrão", ela será rebaixada automaticamente.\n\nConfirmar?',
    'adminMagasins.loadError': 'Erro ao carregar',
    'adminMagasins.confirmArchive': 'Arquivar a loja {{code}}? Os itens e as vendas NÃO serão excluídos.',
    'adminMagasins.genericError': 'Erro',
    'adminMagasins.back': 'Voltar',
    'adminMagasins.title': 'Lojas',
    'adminMagasins.subtitle': 'Gerenciar as lojas (lojas físicas)',
    'adminMagasins.filterActive': 'Ativas',
    'adminMagasins.filterArchived': 'Arquivadas',
    'adminMagasins.filterAll': 'Todas',
    'adminMagasins.colCode': 'Código',
    'adminMagasins.colName': 'Nome',
    'adminMagasins.colAddress': 'Endereço',
    'adminMagasins.colPhone': 'Telefone',
    'adminMagasins.colPrinterIp': 'IP da impressora',
    'adminMagasins.colColor': 'Cor',
    'adminMagasins.colStatus': 'Status',
    'adminMagasins.colActions': 'Ações',
    'adminMagasins.loading': 'Carregando…',
    'adminMagasins.emptyArchived': 'Nenhuma loja arquivada.',
    'adminMagasins.emptyActive': 'Nenhuma loja ativa.',
    'adminMagasins.defaultBadge': 'PADRÃO',
    'adminMagasins.edit': 'Editar',
    'adminMagasins.cannotArchiveDefault': 'Impossível — loja padrão',
    'adminMagasins.archive': 'Arquivar',
    'adminMagasins.restore': 'Restaurar',
    'adminMagasins.footerNote': 'As lojas arquivadas mantêm seus itens e vendas (R1 — apenas soft delete). A loja marcada "{{badge}}" não pode ser arquivada.',
    'adminPromos.title': 'Promoções automatizadas',
    'adminPromos.subtitle': 'Promoções ativas, calendário e configurações',
    'adminPromos.tabCurrent': 'Promoções ativas',
    'adminPromos.tabCalendar': 'Calendário mensal',
    'adminPromos.tabSettings': 'Configurações',
    'adminPromos.forceDailyDraw': 'Forçar um novo sorteio diário',
    'adminPromos.ref': 'Ref.: {{ref}}',
    'adminPromos.statusActive': '🟢 Ativa',
    'adminPromos.statusInactive': '⚫ Inativa',
    'adminPromos.endLabel': 'fim: {{date}}',
    'adminPromos.emptyPromos': 'Nenhuma promoção',
    'adminPromos.regenThisMonth': 'Regenerar este mês',
    'adminPromos.productsCount': '{{count}} produtos',
    'adminPromos.emptyCalendar': 'Sem calendário — Regenerar?',
    'adminPromos.configDaily': 'Auto-bot diário',
    'adminPromos.excludedCategories': 'Categorias excluídas (separadas por vírgula)',
    'adminPromos.excludedKeywords': 'Palavras-chave excluídas (regex OR, opcional — vazio = usa os padrões)',
    'adminPromos.save': 'Salvar',
    'adminPromos.minPct': 'Mín %',
    'adminPromos.maxPct': 'Máx %',
    'adminPromos.confirmRegenDaily': 'Sortear uma nova promoção diária agora?',
    'adminPromos.drawResult': 'Novo sorteio: {{name}}',
    'adminPromos.statusResult': 'Status: {{status}}',
    'adminPromos.confirmRegenCalendar': 'Regenerar o calendário de {{month}}? Isso sobrescreve o existente.',
    'adminPromos.calendarRegenResult': '{{status}} — {{count}} produtos utilizados',
    'adminPromos.settingsSaved': 'Configurações salvas',
    'adminCadbotPrix.source.ventePos': 'Venda PDV',
    'adminCadbotPrix.source.reparation': 'Reparo',
    'adminCadbotPrix.source.devisValide': 'Orçamento validado',
    'adminCadbotPrix.refSource.prixValide': 'preço validado',
    'adminCadbotPrix.refSource.tarifPublic': 'preço público',
    'adminCadbotPrix.refSource.calculFournisseur': 'cálculo do fornecedor',
    'adminCadbotPrix.refSource.aucune': 'sem referência',
    'adminCadbotPrix.loadError': 'Erro de carregamento',
    'adminCadbotPrix.genericError': 'Erro',
    'adminCadbotPrix.toastCollected': '{{ventes}} vendas + {{reparations}} reparos registrados',
    'adminCadbotPrix.toastAnalyzed': '{{creees}} nova(s) proposta(s), {{maj}} atualização(ões)',
    'adminCadbotPrix.priceInvalid': 'Preço inválido',
    'adminCadbotPrix.toastApproved': 'Preço validado: {{price}} — {{detail}}',
    'adminCadbotPrix.toastApprovedLocked': 'preço manual bloqueado, proposta pendente',
    'adminCadbotPrix.toastApprovedPublished': 'página de Preços atualizada',
    'adminCadbotPrix.rejectReasonPrompt': 'Motivo da recusa (opcional):',
    'adminCadbotPrix.proposalRejected': 'Proposta recusada',
    'adminCadbotPrix.settingsSaved': 'Configurações salvas',
    'adminCadbotPrix.confirmRemoveValidated': 'Remover o preço validado {{model}} · {{part}} · {{quality}}?',
    'adminCadbotPrix.validatedRemoved': 'Preço validado removido',
    'adminCadbotPrix.pageTitle': 'Validação de preços CADBOT',
    'adminCadbotPrix.pageSubtitle': 'O CADBOT registra os preços realmente cobrados e propõe ajustes. Cada preço validado alimenta a página de Preços e tem prioridade nos orçamentos.',
    'adminCadbotPrix.rules': 'Regras',
    'adminCadbotPrix.collecting': 'Coletando…',
    'adminCadbotPrix.memorizeSales': 'Registrar vendas',
    'adminCadbotPrix.analyzing': 'Analisando…',
    'adminCadbotPrix.analyze': 'Analisar',
    'adminCadbotPrix.minSales': 'Vendas mínimas',
    'adminCadbotPrix.tolerancePct': 'Diferença mínima (%)',
    'adminCadbotPrix.toleranceEur': 'Diferença mínima (€)',
    'adminCadbotPrix.windowDays': 'Janela (dias)',
    'adminCadbotPrix.publishOnApprove': 'Publicar na página de Preços ao validar',
    'adminCadbotPrix.countDevisValides': 'Contar também os orçamentos de IA aprovados (além das vendas faturadas)',
    'adminCadbotPrix.filterPending': 'A validar',
    'adminCadbotPrix.filterApproved': 'Validadas',
    'adminCadbotPrix.filterRejected': 'Recusadas',
    'adminCadbotPrix.filterAll': 'Todas',
    'adminCadbotPrix.refresh': 'Atualizar',
    'adminCadbotPrix.loading': 'Carregando…',
    'adminCadbotPrix.emptyProposals': 'Nenhuma proposta {{scope}}. Clique em “{{collect}}” e depois em “{{analyze}}”.',
    'adminCadbotPrix.emptyScopePending': 'a validar',
    'adminCadbotPrix.tier': 'Categoria',
    'adminCadbotPrix.realSales': '{{count}} venda(s) real(is) (de {{min}} a {{max}})',
    'adminCadbotPrix.lastSaleOn': 'última em {{date}}',
    'adminCadbotPrix.statusBadgePending': 'A VALIDAR',
    'adminCadbotPrix.statusBadgeApproved': 'VALIDADA',
    'adminCadbotPrix.statusBadgeRejected': 'RECUSADA',
    'adminCadbotPrix.referencePrice': 'Preço de referência',
    'adminCadbotPrix.medianRealSales': 'Mediana das vendas reais',
    'adminCadbotPrix.priceToValidate': 'Preço a validar (editável)',
    'adminCadbotPrix.priceRetained': 'Preço adotado',
    'adminCadbotPrix.evidenceSales': 'Vendas comprovativas ({{count}})',
    'adminCadbotPrix.thDate': 'Data',
    'adminCadbotPrix.thSource': 'Origem',
    'adminCadbotPrix.thRef': 'Ref.',
    'adminCadbotPrix.thDesignation': 'Descrição',
    'adminCadbotPrix.thPriceTtc': 'Preço c/ imposto',
    'adminCadbotPrix.validate': 'Validar',
    'adminCadbotPrix.validateAt': 'a {{price}} €',
    'adminCadbotPrix.reject': 'Recusar',
    'adminCadbotPrix.reviewApproved': 'Validada por {{by}} em {{date}}',
    'adminCadbotPrix.reviewRejected': 'Recusada por {{by}} em {{date}}',
    'adminCadbotPrix.lockedPendingNote': '(preço editado manualmente: bloqueado, preço pendente)',
    'adminCadbotPrix.validatedPrices': 'Preços validados ({{count}})',
    'adminCadbotPrix.noValidatedPrices': 'Nenhum preço validado por enquanto.',
    'adminCadbotPrix.thDevice': 'Aparelho',
    'adminCadbotPrix.thPart': 'Peça',
    'adminCadbotPrix.thTier': 'Categoria',
    'adminCadbotPrix.thPrice': 'Preço',
    'adminCadbotPrix.thValidated': 'Validado',
    'adminCadbotPrix.salesCountShort': '{{count}} venda(s)',
    'adminCadbotPrix.remove': 'Remover',
    'adminCommissions.typeVentes': 'Vendas',
    'adminCommissions.typeCommandes': 'Pedidos',
    'adminCommissions.typeAcomptes': 'Adiantamentos',
    'adminCommissions.typeReparations': 'Reparos',
    'adminCommissions.typeFactures': 'Faturas',
    'adminCommissions.typeDevis': 'Orçamentos',
    'adminCommissions.typeB2b': 'B2B',
    'adminCommissions.typeDeplacement': 'Deslocamento',
    'adminCommissions.tagBackfill': 'Backfill',
    'adminCommissions.tagDoublonPotentiel': 'Duplicado potencial',
    'adminCommissions.tagSuspectReparation': 'Reparo suspeito',
    'adminCommissions.tagSuspectCommande': 'Pedido suspeito',
    'adminCommissions.confirmCancel': 'Cancelar esta comissão?',
    'adminCommissions.noSelection': 'Nenhuma linha selecionada',
    'adminCommissions.confirmBulkMarkPaid': 'Marcar {{count}} comissão(ões) como paga(s)?',
    'adminCommissions.confirmRecompute30d': 'Recalcular as comissões dos últimos 30 dias para as vendas existentes?\nIdempotente: não cria duplicados.',
    'adminCommissions.recomputeResult': 'Varredura: {{scanned}} vendas — {{created}} comissões criadas',
    'adminCommissions.error': 'Erro: {{detail}}',
    'adminCommissions.title': 'Comissões',
    'adminCommissions.totalToPay': 'Total a pagar',
    'adminCommissions.alreadyPaid': 'Já pago',
    'adminCommissions.recompute30d': 'Recalcular últimos 30 dias',
    'adminCommissions.recompute30dHint': 'Backfill retroativo das vendas existentes',
    'adminCommissions.configPerStaff': 'Configuração por funcionário',
    'adminCommissions.configure': 'Configurar',
    'adminCommissions.noStaffFound': 'Nenhum funcionário encontrado',
    'adminCommissions.filters': 'Filtros',
    'adminCommissions.allStatuses': 'Todos os status',
    'adminCommissions.statusToPay': 'A pagar',
    'adminCommissions.statusPaid': 'Pagas',
    'adminCommissions.statusCancelled': 'Canceladas',
    'adminCommissions.allStaff': 'Todos os funcionários',
    'adminCommissions.allTypes': 'Todos os tipos',
    'adminCommissions.auditHeuristic': 'Auditoria heurística',
    'adminCommissions.auditAdvanced': 'Auditoria avançada multissinal',
    'adminCommissions.metierAuditReadOnly': 'Auditoria avançada — somente leitura · ledger Mongo intacto · apenas analisador multissinal',
    'adminCommissions.metierAuditLoading': 'Análise de negócio em andamento…',
    'adminCommissions.ledgerCommissionStored': 'Comissão ledger (armazenada)',
    'adminCommissions.metierCommissionTheoretical': 'Comissão de negócio teórica',
    'adminCommissions.totalGapPeriod': 'Diferença total do período',
    'adminCommissions.rowsAnalyzed': 'Linhas analisadas',
    'adminCommissions.typeMismatchDetected': 'Divergências de tipo detectadas',
    'adminCommissions.auditHeuristicLegend': 'Auditoria heurística: classificação por referência de transação. Nenhuma gravação no banco de dados.',
    'adminCommissions.legendRecompute30d': 'recálculo 30d',
    'adminCommissions.combinedAuditNote': 'Colunas Ledger = valores armazenados no Mongo (tipo, taxa snapshot, commission_amount). Colunas Métier = análise multissinal + configuração atual do funcionário para o tipo detectado.',
    'adminCommissions.bulkMarkPaid': 'Marcar como pagas ({{count}})',
    'adminCommissions.clearSelection': 'Cancelar a seleção',
    'adminCommissions.colDate': 'Data',
    'adminCommissions.colStaff': 'Funcionário',
    'adminCommissions.colType': 'Tipo',
    'adminCommissions.colTransaction': 'Transação',
    'adminCommissions.colAmount': 'Valor',
    'adminCommissions.colRateApplied': 'Taxa aplicada',
    'adminCommissions.colCommission': 'Comissão',
    'adminCommissions.colStatus': 'Status',
    'adminCommissions.colLedgerType': 'L. tipo',
    'adminCommissions.colLedgerRate': 'L. taxa',
    'adminCommissions.colLedgerCommission': 'L. comissão',
    'adminCommissions.colMetierType': 'M. tipo',
    'adminCommissions.colMetierRate': 'M. taxa',
    'adminCommissions.colMetierCommission': 'M. comissão',
    'adminCommissions.colGap': 'Diferença',
    'adminCommissions.colAuditSignals': 'Sinais de auditoria',
    'adminCommissions.colRealType': 'Tipo real (auditoria)',
    'adminCommissions.colAppliedType': 'Tipo aplicado',
    'adminCommissions.colSource': 'Origem',
    'adminCommissions.loading': 'Carregando…',
    'adminCommissions.mixed': 'misto',
    'adminCommissions.pairLabel': 'Par: {{id}}',
    'adminCommissions.expectedLabel': 'Esperado: {{type}}',
    'adminCommissions.markPaidShort': 'Pago',
    'adminCommissions.noCommissionInFilter': 'Nenhuma comissão neste filtro',
    'adminCommissions.noCommissionHint': 'Se uma comissão acabou de ser ativada, use o botão "Recalcular últimos 30 dias" acima.',
    'adminCommissions.modalTitle': 'Comissões de {{name}}',
    'adminCommissions.cancel': 'Cancelar',
    'adminCommissions.save': 'Salvar',
    'adminCloud.status.ok': 'OK',
    'adminCloud.status.ko': 'Falhou',
    'adminCloud.status.skipped': 'Ignorado',
    'adminCloud.docType.ticket': 'Ticket de reparo',
    'adminCloud.docType.facture': 'Fatura',
    'adminCloud.docType.acompte': 'Sinal',
    'adminCloud.docType.devis': 'Orçamento',
    'adminCloud.docType.bonCommande': 'Ordem de compra',
    'adminCloud.errors.load': 'Erro de carregamento',
    'adminCloud.errors.save': 'Erro ao salvar',
    'adminCloud.errors.test': 'Erro de teste',
    'adminCloud.errors.rebuild': 'Erro de reconstrução',
    'adminCloud.errors.syncToggle': 'Erro ao alternar a sincronização.',
    'adminCloud.save.success': 'Parâmetros salvos (a chave em texto puro nunca é retornada).',
    'adminCloud.test.ok': '✓ Conexão OK — {{name}} (proprietário: {{owner}}, expira: {{expires}})',
    'adminCloud.test.ko': 'Conexão falhou: {{error}}',
    'adminCloud.test.unknownError': 'desconhecido',
    'adminCloud.hierarchy.ok': '✓ Hierarquia OK — {{path}} (folder_id: {{folderId}}...)',
    'adminCloud.hierarchy.ko': 'Hierarquia falhou — {{message}}',
    'adminCloud.access.adminRequired': 'Acesso de administrador necessário.',
    'adminCloud.sync.resumed': 'Sincronização na nuvem RETOMADA.',
    'adminCloud.sync.paused': 'Sincronização na nuvem PAUSADA.',
    'adminCloud.title': 'Sincronização na nuvem — remobiles.fr',
    'adminCloud.subtitlePre': 'Seus PDFs (tickets, faturas, orçamentos, sinais) são arquivados automaticamente no seu espaço privado',
    'adminCloud.refresh': 'Atualizar',
    'adminCloud.sync.active': 'Sincronização na nuvem ATIVA',
    'adminCloud.sync.pausedLabel': 'Sincronização na nuvem EM PAUSA',
    'adminCloud.sync.pausedAt': 'Pausado em {{date}}',
    'adminCloud.sync.pausedBy': ' por {{by}}',
    'adminCloud.sync.activeHint': 'Todos os novos documentos PDF são enviados automaticamente para remobiles.fr.',
    'adminCloud.sync.pauseBtn': 'Pausar',
    'adminCloud.sync.resumeBtn': 'Retomar',
    'adminCloud.confirm.resumeTitle': 'Retomar a sincronização?',
    'adminCloud.confirm.pauseTitle': 'Pausar a sincronização?',
    'adminCloud.confirm.resumeBody': 'Os novos documentos voltarão a ser enviados automaticamente para remobiles.fr.',
    'adminCloud.confirm.pauseBody': 'Nenhum novo documento será enviado até você retomar a sincronização. Os documentos existentes não são afetados.',
    'adminCloud.cancel': 'Cancelar',
    'adminCloud.stats.globalStatus': 'Status global',
    'adminCloud.stats.enabled': 'Ativado',
    'adminCloud.stats.disabled': 'Desativado',
    'adminCloud.stats.uploadsOk': 'Uploads OK',
    'adminCloud.stats.uploadsKo': 'Uploads com falha',
    'adminCloud.stats.total': 'Total',
    'adminCloud.structure.title': 'Estrutura de destino na nuvem (hierarquia real)',
    'adminCloud.structure.cachedTotal': '{{count}} pastas em cache',
    'adminCloud.structure.createdThisMonth': '{{count}} criadas este mês',
    'adminCloud.structure.retryHierarchy': 'Tentar novamente criar a hierarquia',
    'adminCloud.structure.noUploadToday': '(nenhum upload hoje)',
    'adminCloud.structure.flat': '(plano)',
    'adminCloud.structure.recentFolders': 'Pastas criadas recentemente',
    'adminCloud.structure.noFolderCache': '(nenhuma pasta em cache)',
    'adminCloud.structure.policyLabel': 'Política',
    'adminCloud.structure.policyBody': ': nenhuma exclusão de pasta ou arquivo é enviada a remobiles.fr. Os arquivos de teste permanecem visíveis no lado da nuvem.',
    'adminCloud.loading': 'Carregando...',
    'adminCloud.connection.title': 'Configurações de conexão',
    'adminCloud.connection.uploadUrl': 'URL de upload',
    'adminCloud.connection.status': 'Status',
    'adminCloud.connection.enableAuto': 'Ativar a sincronização automática',
    'adminCloud.connection.currentKey': 'Chave de API atual: {{masked}}',
    'adminCloud.connection.noKey': '<nenhuma>',
    'adminCloud.connection.keyPlaceholder': 'Cole aqui uma nova chave para substituir (rcsk_...)',
    'adminCloud.connection.keyHint': 'A chave é criptografada (Fernet) no banco de dados. Deixe em branco para não alterá-la.',
    'adminCloud.save.btn': 'Salvar',
    'adminCloud.test.btn': 'Testar a conexão (whoami)',
    'adminCloud.test.lastTest': 'Último teste: {{mark}} {{date}}',
    'adminCloud.logs.title': 'Registro de uploads',
    'adminCloud.logs.allStatuses': 'Todos os status',
    'adminCloud.logs.filterOk': 'OK',
    'adminCloud.logs.filterKo': 'Falha',
    'adminCloud.logs.filterSkipped': 'Ignorada',
    'adminCloud.logs.allTypes': 'Todos os tipos',
    'adminCloud.logs.typeTickets': 'Tickets',
    'adminCloud.logs.typeFactures': 'Faturas',
    'adminCloud.logs.typeAcomptes': 'Sinais',
    'adminCloud.logs.typeDevis': 'Orçamentos',
    'adminCloud.logs.typeBonsCommande': 'Ordens de compra',
    'adminCloud.logs.colDate': 'Data',
    'adminCloud.logs.colType': 'Tipo',
    'adminCloud.logs.colRef': 'Referência',
    'adminCloud.logs.colStatus': 'Status',
    'adminCloud.logs.colFolder': 'Pasta',
    'adminCloud.logs.colError': 'Erro',
    'adminCloud.logs.empty': 'Nenhum upload por enquanto.',
    'size50x30': '50 x 30 mm (padrão Bixolon)',
    'protocolZpl': 'ZPL (recomendado para Bixolon recente)',
    'protocolBpl': 'BPL (legado / série SLP)',
    'fieldClientName': 'Nome do cliente',
    'fieldClientPhone': 'Telefone do cliente',
    'fieldDeviceLock': 'Código / bloqueio',
    'fieldModel': 'Modelo',
    'fieldParts': 'Peças / defeito',
    'fieldDate': 'Data',
    'fieldPrice': 'Preço',
    'fieldRef': 'Referência REM-XXX',
    'errLoad': 'Erro ao carregar a configuração',
    'saved': 'Configuração salva.',
    'errSave': 'Erro ao salvar',
    'previewNeedRef': 'Informe uma referência REM-XXX para a pré-visualização.',
    'errPreview': 'Erro ao gerar a pré-visualização',
    'testQueued': 'Teste enviado para a fila. O agente local irá processá-lo assim que estiver conectado.',
    'errTest': 'Erro no teste da impressora',
    'confirmRotate': 'Regenerar o token invalidará o anterior. Continuar?',
    'tokenGenerated': 'Novo token gerado. Copie-o e cole-o na configuração do agente local.',
    'errRotate': 'Erro ao regenerar o token',
    'tokenCopied': 'Token copiado para a área de transferência.',
    'copyFailed': 'Não foi possível copiar.',
    'errDownloadPack': 'Não foi possível baixar{{http}}: {{detail}}',
    'downloadLinkUnavailable': 'Link de download indisponível',
    'downloadStartedHint': 'Download iniciado. Se nada acontecer, permita downloads no navegador.',
    'errDownloadApp': 'Não foi possível baixar o aplicativo{{http}}: {{detail}}',
    'agentExeDownloaded': 'Agente Windows baixado com sucesso.',
    'errDownloadAgent': 'Não foi possível baixar o agente{{http}}: {{detail}}',
    'packDownloaded': 'Pacote do agente baixado com sucesso.',
    'securityTitle': 'Segurança da impressora de rede',
    'securityBody': 'Lembre-se de alterar a senha de administrador padrão (admin/admin) e desativar TELNET e FTP pela interface web da impressora',
    'securityNoInternet': 'Nunca exponha a porta 9100 à Internet.',
    'downloadsTitle': 'Downloads e instaladores',
    'downloadsDesc': 'Acesso direto aos ZIP do Windows, ao agente de impressão e à página de substituição ao vivo.',
    'openInstallers': 'Abrir instaladores',
    'loading': 'Carregando...',
    'bixolonSection': 'Bixolon - etiquetas QR',
    'fieldPrinterName': 'Nome da impressora',
    'fieldIp': 'Endereço IP',
    'fieldPortRaw': 'Porta (socket RAW)',
    'fieldIpMethod': 'Método IP',
    'ipMethodManual': 'Manual (IP fixo)',
    'ipMethodDhcp': 'DHCP',
    'fieldSubnet': 'Sub-rede',
    'fieldGateway': 'Gateway',
    'fieldDns': 'DNS',
    'fieldProtocol': 'Protocolo de impressão',
    'fieldDefaultLabelFormat': 'Formato de etiqueta padrão',
    'printerActive': 'Impressora ativa',
    'testConnection': 'Testar conexão',
    'lastTest': 'Último teste: {{date}}',
    'epsonSection': 'Epson - tickets de caixa',
    'epsonDesc': 'Estes valores são usados para os tickets de 80 mm. O agente Windows lê esta configuração e então envia o ticket para a impressora Epson da loja.',
    'fieldTicketIp': 'Endereço IP da Epson',
    'fieldTicketPort': 'Porta da Epson',
    'fieldTicketProtocol': 'Protocolo de ticket',
    'ticketProtoEscpos': 'ESC/POS (Epson)',
    'ticketProtoZplFallback': 'ZPL (alternativa)',
    'agentSection': 'Agente local',
    'agentDesc': 'O agente local é executado em uma estação da LAN, recebe os trabalhos via polling e envia as etiquetas Bixolon ou os tickets Epson para as impressoras configuradas. O token de API é usado para autenticar como agente.',
    'tokenCopyNow': 'Token (copie agora - não será mais exibido):',
    'agentTokenLabel': 'Token do agente',
    'tokenCreated': '(criado)',
    'tokenNotGenerated': '(não gerado)',
    'noToken': '— nenhum token —',
    'hide': 'Ocultar',
    'show': 'Mostrar',
    'copy': 'Copiar',
    'regenerateToken': 'Regenerar token',
    'generateToken': 'Gerar token',
    'agentWinTitle': 'Agente local do Windows',
    'agentWinDesc': 'Baixe o agente pronto para executar, ou o pacote zip se você precisar recompilar o agente em uma estação Windows.',
    'directLinks': 'Links diretos',
    'dlDesktopApp': 'Aplicativo Windows para equipe',
    'dlAgentExe': 'Agente Windows (.exe)',
    'dlAgentPack': 'Pacote do agente (.zip)',
    'tempLinksNote': 'Links temporários assinados automaticamente. Eles expiram após alguns minutos.',
    'downloading': 'Baixando...',
    'dlAgentExeBtn': 'Baixar o agente Windows (.exe)',
    'dlAgentPackBtn': 'Baixar o pacote do agente (.zip)',
    'desktopAppDesc': 'Baixe o aplicativo desktop R.E.Mobiles já compilado. Ele inicia o frontend local, o backend local e o agente de impressão incluído.',
    'dlDesktopAppBtn': 'Baixar o aplicativo Windows (.zip)',
    'printedFields': 'Campos impressos',
    'fieldFontSize': 'Tamanho da fonte (6-16)',
    'fieldMargin': 'Margem (0-24 pt)',
    'previewPdf': 'Pré-visualização PDF',
    'previewDesc': 'Gerar uma etiqueta PDF de teste para um reparo existente.',
    'previewRefPlaceholder': 'Ref REM-XXX',
    'previewBtn': 'Pré-visualizar',
    'save': 'Salvar',
    'reload': 'Recarregar',
    'errUnknown': 'Erro desconhecido',
    'adminPertes.title': 'Perdas',
    'adminPertes.subtitle': 'Vendas fora do estoque cobradas abaixo do preço de catálogo e descontos acima do limite autorizado, por vendedor.',
    'adminPertes.exportCsv': 'Exportar CSV',
    'adminPertes.recalcul': 'Recalcular no histórico',
    'adminPertes.typeHorsStock': 'Fora de estoque abaixo do preço',
    'adminPertes.typeRemise': 'Desconto excessivo',
    'adminPertes.typeSousCatalogue': 'Preço abaixo do catálogo',
    'adminPertes.preset30j': '30 d',
    'adminPertes.preset3m': '3 meses',
    'adminPertes.preset12m': '12 meses',
    'adminPertes.presetCustom': 'Personalizado',
    'adminPertes.payCb': 'Cartão bancário',
    'adminPertes.payCash': 'Dinheiro',
    'adminPertes.payCheque': 'Cheque',
    'adminPertes.payVirement': 'Transferência',
    'adminPertes.payMixte': 'Misto',
    'adminPertes.payAvoir': 'Crédito',
    'adminPertes.payAcompte': 'Sinal',
    'adminPertes.periode': 'Período: {{debut}} → {{fin}}',
    'adminPertes.du': 'De',
    'adminPertes.au': 'Até',
    'adminPertes.vendeur': 'Vendedor',
    'adminPertes.type': 'Tipo',
    'adminPertes.magasin': 'Loja',
    'adminPertes.tous': 'Todos',
    'adminPertes.tileTotal': 'Perda total',
    'adminPertes.calculeLe': 'Calculado em {{date}}',
    'adminPertes.remisesExcessives': 'Descontos excessivos',
    'adminPertes.auDelaDe': 'Acima de {{pct}}',
    'adminPertes.tileNb': 'Vendas envolvidas',
    'adminPertes.parVendeur': 'Por vendedor',
    'adminPertes.loading': 'Carregando…',
    'adminPertes.aucunePerte': 'Nenhuma perda no período.',
    'adminPertes.colTotal': 'Total',
    'adminPertes.colNbVentes': 'Nº vendas',
    'adminPertes.filtrerVendeur': 'Filtrar o detalhe por este vendedor',
    'adminPertes.detailTitle': 'Detalhe das vendas',
    'adminPertes.pageRange': '{{from}}–{{to}} de {{total}}',
    'adminPertes.pageN': 'Página {{page}}',
    'adminPertes.aucuneLigne': 'Nenhuma linha para esses filtros.',
    'adminPertes.colDate': 'Data',
    'adminPertes.colTicket': 'Recibo',
    'adminPertes.colArticle': 'Item',
    'adminPertes.colQte': 'Qtd',
    'adminPertes.colPrixVendu': 'Preço vendido',
    'adminPertes.colPrixRef': 'Preço ref.',
    'adminPertes.colRemise': 'Desconto',
    'adminPertes.colPerte': 'Perda',
    'adminPertes.trierPerte': 'Ordenar por perda',
    'adminPertes.colStatut': 'Status',
    'adminPertes.colActions': 'Ações',
    'adminPertes.ticket': 'Recibo',
    'adminPertes.ouvrirTicket': 'Abrir o recibo do caixa (PDF) em uma nova aba',
    'adminPertes.voirVente': 'Ver a venda',
    'adminPertes.masquerVente': 'Ocultar o conteúdo da venda',
    'adminPertes.voirVenteTitle': 'Ver o que foi vendido neste recibo',
    'adminPertes.venteLabel': 'Venda',
    'adminPertes.paiement': 'Pagamento:',
    'adminPertes.contenuIndispo': 'Conteúdo da venda indisponível para este recibo (abra o recibo PDF).',
    'adminPertes.ligneEnPerte': '(linha em perda)',
    'adminPertes.totalVente': 'Total da venda:',
    'adminPertes.precedent': 'Anterior',
    'adminPertes.suivant': 'Próximo',
    'adminPertes.lignesParPage': '{{count}} linhas por página',
    'adminPertes.legendeTitle': 'Como as perdas são calculadas',
    'adminPertes.legendeHorsStockText': 'Venda «fora de estoque» cobrada abaixo do preço de catálogo embora o item existisse na base no momento da venda. Perda =',
    'adminPertes.legendeHorsStockFormula': '(preço de referência − preço vendido) × quantidade',
    'adminPertes.legendeRemiseText': 'Desconto superior a {{seuil}} em uma linha de venda. Apenas a parte acima de {{seuil}} é contada:',
    'adminPertes.legendeRemiseFormula': '(desconto − {{seuil}}) × preço de referência × quantidade',
    'adminPertes.legendeSousCatalogue': 'Item em estoque vendido abaixo do preço de catálogo sem desconto declarado: mesma fórmula que «fora de estoque abaixo do preço».',
    'adminPertes.legendeFooter': 'O preço de referência é o preço de catálogo do item na data da venda. «Recalcular no histórico» relê todas as vendas passadas; a exibição atual é armazenada em cache e atualizada automaticamente.',
    'adminPertes.confirmRecalcul': 'Recalcular as perdas sobre todo o histórico de vendas? Esta operação relê todas as vendas passadas e pode levar alguns instantes.',
    'adminPertes.recalculDone': 'Recálculo concluído — {{count}} venda(s) analisada(s)',
    'adminPertes.recalculDoneGeneric': 'Recálculo concluído sobre todo o histórico',
    'adminPertes.recalculFail': 'Falha no recálculo',
    'adminPertes.exportDone': 'Exportação CSV baixada',
    'adminPertes.exportUnavailable': 'Exportação indisponível (backend a atualizar)',
    'adminPertes.exportFail': 'Falha na exportação',
    'adminPertes.refManquante': 'Referência de venda ausente: recibo não encontrado',
    'adminPertes.ticketFail': 'Não foi possível abrir o recibo',
    'adminPertes.endpointIndispo': 'Endpoint «Perdas» indisponível (backend a atualizar).',
    'adminPertes.errLoad': 'Erro de carregamento',
    'adminPertes.ticketTooltipRef': 'Recibo {{ref}}',
    'adminPertes.lignes_one': '{{count}} linha',
    'adminPertes.lignes_other': '{{count}} linhas',
    'adminPertes.articles_one': '{{count}} item',
    'adminPertes.articles_other': '{{count}} itens',
    'adminPertes.autres_one': '(+{{count}} outro)',
    'adminPertes.autres_other': '(+{{count}} outros)',
    'adminTodo.cat.ventesHorsStock': 'Vendas sem estoque a confirmar',
    'adminTodo.cat.cadbotPrix': 'Preços CADBOT a validar',
    'adminTodo.cat.devisChat': 'Orçamentos do chat a tratar',
    'adminTodo.cat.acomptesACommander': 'Sinais → peças a encomendar',
    'adminTodo.cat.commandesSansSuivi': 'Pedidos sem código de rastreio',
    'adminTodo.cat.sumupAConfirmer': 'Pagamentos SumUp a confirmar',
    'adminTodo.cat.factureRequests': 'Solicitações de fatura',
    'adminTodo.groupFallback': 'Grupo',
    'adminTodo.time.now': 'agora mesmo',
    'adminTodo.time.minutesAgo': 'há {{n}} min',
    'adminTodo.time.hoursAgo': 'há {{n}} h',
    'adminTodo.error.endpointUnavailable': 'Endpoint "A fazer" indisponível (backend precisa ser atualizado).',
    'adminTodo.error.load': 'Erro ao carregar',
    'adminTodo.settings.unavailable': 'Configurações indisponíveis (backend precisa ser atualizado).',
    'adminTodo.settings.notLoaded': 'Configurações não carregadas',
    'adminTodo.settings.saved': 'Configurações salvas',
    'adminTodo.settings.saveError': 'Não foi possível salvar as configurações',
    'adminTodo.title': 'A fazer',
    'adminTodo.subtitleUpdated': 'Atualizado às {{time}} · atualização automática a cada 60 s',
    'adminTodo.subtitleDefault': 'Tudo que precisa de ação, num só lugar.',
    'adminTodo.notifications': 'Notificações',
    'adminTodo.refresh': 'Atualizar',
    'adminTodo.settings.saving': 'Salvando…',
    'adminTodo.settings.loading': 'Carregando configurações…',
    'adminTodo.settings.pushLabel': 'Notificação push no celular',
    'adminTodo.settings.pushHint': 'Um alerta assim que surge uma nova ação.',
    'adminTodo.settings.digestLabel': 'Resumo diário às 9h',
    'adminTodo.settings.digestHint': 'Uma única mensagem a cada manhã com tudo o que falta fazer.',
    'adminTodo.settings.categoriesTracked': 'Categorias monitoradas',
    'adminTodo.allClear': 'Nada pendente. Tudo em dia.',
    'adminTodo.groupNothingPending': 'Nada pendente',
    'adminTodo.open': 'Abrir',
    'adminTodo.seeAll': 'Ver os {{count}} itens',
    'adminTodo.openPage': 'Abrir a página',
    'adminTodo.pushOn': 'Push ativado',
    'adminTodo.pushOff': 'Push desativado',
    'adminTodo.digestOn': 'Resumo das 9h ativado',
    'adminTodo.digestOff': 'Resumo das 9h desativado',
    'adminUsers.role.super_admin.label': 'Superadministrador',
    'adminUsers.role.super_admin.desc': 'Acesso completo a todo o sistema (apenas carlos)',
    'adminUsers.role.admin_magasin.label': 'Administrador da loja',
    'adminUsers.role.admin_magasin.desc': 'Gerencia uma ou mais lojas atribuídas',
    'adminUsers.role.technicien.label': 'Técnico de assistência',
    'adminUsers.role.technicien.desc': 'Chamados de assistência das 2 lojas. Sem POS, sem contabilidade.',
    'adminUsers.role.vendeur.label': 'Vendedor',
    'adminUsers.role.vendeur.desc': 'POS em todas as lojas. Sem contabilidade, sem administração.',
    'adminUsers.roleUnknown': 'desconhecido',
    'adminUsers.modal.editTitle': 'Editar {{username}}',
    'adminUsers.createUser': 'Criar um usuário',
    'adminUsers.field.username': 'Nome de usuário',
    'adminUsers.field.passwordEdit': 'Nova senha (deixe em branco para manter)',
    'adminUsers.field.passwordCreate': 'Senha * (mín. {{min}} caract.)',
    'adminUsers.field.email': 'E-mail',
    'adminUsers.field.telephone': 'Telefone',
    'adminUsers.field.role': 'Função na loja',
    'adminUsers.field.assignedMagasins': 'Lojas atribuídas',
    'adminUsers.modal.minOneRequired': '(mín. 1 obrigatória)',
    'adminUsers.modal.ignoredForRole': '— Armazenado mas ignorado para esta função (escopo = todas as lojas)',
    'adminUsers.modal.loadingMagasins': 'Carregando lojas…',
    'adminUsers.modal.posOnlyTitle': 'Ausente / suspensão — somente POS',
    'adminUsers.modal.posOnlyDesc': 'Pode fazer login e receber pagamentos no POS, sem acesso às outras páginas (reparos, estoque, clientes, administração…).',
    'adminUsers.action.cancel': 'Cancelar',
    'adminUsers.action.save': 'Salvar',
    'adminUsers.action.create': 'Criar',
    'adminUsers.denied.title': 'Acesso negado',
    'adminUsers.denied.desc': 'Esta página é reservada ao superadministrador.',
    'adminUsers.denied.back': 'Voltar ao painel',
    'adminUsers.error.load': 'Erro ao carregar',
    'adminUsers.error.passwordMin': 'A senha deve conter pelo menos {{min}} caracteres.',
    'adminUsers.feedback.updated': 'Usuário {{username}} atualizado.',
    'adminUsers.feedback.created': 'Usuário {{username}} criado.',
    'adminUsers.error.operation': 'Erro durante a operação',
    'adminUsers.error.needsMagasinPick': 'Escolha primeiro uma loja de sessão (janela no centro da tela) e depois crie o usuário.',
    'adminUsers.feedback.disabled': '{{username}} desativado.',
    'adminUsers.feedback.enabled': '{{username}} reativado.',
    'adminUsers.error.generic': 'Erro',
    'adminUsers.action.back': 'Voltar',
    'adminUsers.title': 'Usuários internos',
    'adminUsers.subtitle': 'Criação / modificação / desativação (apenas superadministrador)',
    'adminUsers.limitInfo': '{{current}}/{{max}} usuários · Plano {{plan}}',
    'adminUsers.limitReachedTitle': 'Limite atingido (máx. {{max}} usuários)',
    'adminUsers.limitReached': 'Limite atingido ({{max}})',
    'adminUsers.includeDisabled': 'Incluir usuários desativados',
    'adminUsers.col.role': 'Função',
    'adminUsers.col.emailTel': 'E-mail / Tel.',
    'adminUsers.col.status': 'Status',
    'adminUsers.col.actions': 'Ações',
    'adminUsers.empty': 'Nenhum usuário.',
    'adminUsers.allMagasins': 'todas',
    'adminUsers.status.active': 'Ativo',
    'adminUsers.status.disabled': 'Desativado',
    'adminUsers.status.posOnly': 'Ausente · somente POS',
    'adminUsers.action.edit': 'Editar',
    'adminUsers.commissions': 'Comissões',
    'adminUsers.action.disable': 'Desativar',
    'adminUsers.action.enable': 'Reativar',
    'adminHorsStock.stockUnknown': 'estoque desconhecido',
    'adminHorsStock.stockCount': 'estoque {{count}}',
    'adminHorsStock.selected': 'Selecionado',
    'adminHorsStock.lineDefaultDesignation': 'Item',
    'adminHorsStock.loadError': 'Erro ao carregar',
    'adminHorsStock.lineStillUnresolved': 'Uma linha ainda está em “A verificar” ou sem referência vinculada.',
    'adminHorsStock.saleValidatedWithLoss': 'Venda {{ref}} validada — {{total}} no histórico. Perda registrada: {{loss}}.',
    'adminHorsStock.saleValidatedNoLoss': 'Venda {{ref}} validada — {{total}} no histórico, sem perda.',
    'adminHorsStock.validationFailed': 'Validação impossível',
    'adminHorsStock.catalogBadge': 'Catálogo',
    'adminHorsStock.cashedLineInfo': 'recebido {{qty}} × {{price}}',
    'adminHorsStock.horsStockBadge': 'Fora de estoque',
    'adminHorsStock.articleExistedQuestion': 'O item já existia?',
    'adminHorsStock.optionLoss': 'Perda — o item existia, vincular a referência',
    'adminHorsStock.optionNonExistent': 'Item inexistente — aceitar como está',
    'adminHorsStock.optionToVerify': 'A verificar',
    'adminHorsStock.attachedArticle': 'Item vinculado',
    'adminHorsStock.refLabel': 'Ref. {{ref}}',
    'adminHorsStock.catalogPriceLabel': 'Preço de catálogo',
    'adminHorsStock.unknown': 'desconhecido',
    'adminHorsStock.soldLabel': 'vendido',
    'adminHorsStock.estimatedLoss': 'Perda estimada',
    'adminHorsStock.selectCatalogRef': 'Selecione a referência do catálogo correspondente a este item.',
    'adminHorsStock.catalogSuggestions': 'Sugestões do catálogo',
    'adminHorsStock.noSuggestion': 'Nenhuma sugestão para esta linha — use a busca abaixo.',
    'adminHorsStock.otherCatalogArticle': 'Outro item do catálogo',
    'adminHorsStock.searchPlaceholder': 'Buscar referência / descrição / EAN…',
    'adminHorsStock.noArticleFound': 'Nenhum item encontrado.',
    'adminHorsStock.freeArticleInfo': 'Item livre: a linha é mantida como está, sem vinculação nem movimentação de estoque.',
    'adminHorsStock.toVerifyInfo': 'Bloqueia a validação enquanto a linha não for decidida (Sim / Não).',
    'adminHorsStock.toValidateBadge': 'A validar',
    'adminHorsStock.cashedBadge': 'Recebida',
    'adminHorsStock.cashedAmountLabel': 'Recebido',
    'adminHorsStock.subtotal': 'Subtotal',
    'adminHorsStock.discountLabel': 'Desconto',
    'adminHorsStock.historyTotal': 'Total do histórico',
    'adminHorsStock.amountLockedInfo': 'Valor efetivamente recebido: preço, quantidades e desconto não podem ser alterados aqui.',
    'adminHorsStock.lossesPreview': 'Prévia das perdas (visível apenas pela direção)',
    'adminHorsStock.remiseExcessiveLabel': 'Desconto acima de {{seuil}}% ({{pct}} concedidos)',
    'adminHorsStock.lossRecorded': 'Perda constatada',
    'adminHorsStock.lossSavedInfo': 'Registrada na página Perdas ao validar.',
    'adminHorsStock.noLossYet': 'Nenhuma perda constatada nesta etapa',
    'adminHorsStock.noLossYetSuffix': ' — o cálculo se completa assim que as referências forem vinculadas.',
    'adminHorsStock.noteLabel': 'Observação (opcional)',
    'adminHorsStock.notePlaceholder': 'Ex.: preço negociado, item recebido em…',
    'adminHorsStock.validateButton': 'Validar e gravar no histórico',
    'adminHorsStock.blockedTitle': 'Uma ou mais linhas fora de estoque ainda precisam ser decididas',
    'adminHorsStock.validationBlocked': 'Validação bloqueada:',
    'adminHorsStock.blockedVerifierCount': '{{n}} linha(s) “A verificar”',
    'adminHorsStock.blockedNoRefCount': '{{n}} linha(s) “Sim” sem referência vinculada',
    'adminHorsStock.legendTitle': 'O que acontece',
    'adminHorsStock.legendIntro': 'A venda já foi recebida: não pode ser cancelada e o estoque não é alterado. A validação vincula o item correto, registra a diferença de preço ou o desconto excessivo nas perdas e então grava a venda no histórico.',
    'adminHorsStock.legendYesWord': 'Sim',
    'adminHorsStock.legendYesDesc': '— o item existia: selecione a referência do catálogo (sugestões ou busca).',
    'adminHorsStock.legendNonWord': 'Não',
    'adminHorsStock.legendNonDesc': '— item livre, mantido como está.',
    'adminHorsStock.legendVerifierDesc': '— bloqueia a validação enquanto a linha não for decidida.',
    'adminHorsStock.legendPertesWord': 'Perdas',
    'adminHorsStock.legendPertesDesc': '— diferença entre o preço de catálogo e o preço vendido, mais a parcela de desconto acima de {{seuil}}% do subtotal; visível apenas aqui e registrada na página Perdas.',
    'adminHorsStock.pageTitle': 'Vendas fora de estoque a validar',
    'adminHorsStock.pageSubtitle': 'Já recebidas; ausentes do histórico até a validação pela direção.',
    'adminHorsStock.refresh': 'Atualizar',
    'adminHorsStock.emptyState': 'Nenhuma venda fora de estoque aguardando validação.',
    'adminHorsStock.processedThisSession': 'Processadas nesta sessão',
    'adminHorsStock.lossShortLabel': 'perda',
    'adminHorsStock.validatedBadge': 'Validada',
    'stockPhotoAi.title': 'Fotos de estoque · IA',
    'stockPhotoAi.subtitle': 'Super-administrador Carlos · geração OpenAI · loja isolada M1/M2',
    'stockPhotoAi.apiKeysLink': 'Chaves de API OpenAI',
    'stockPhotoAi.statsTotal': 'Itens {{mag}}',
    'stockPhotoAi.statsWithPhoto': 'Com foto',
    'stockPhotoAi.statsMissing': 'Sem foto',
    'stockPhotoAi.searchPlaceholder': 'Buscar ref ou designação…',
    'stockPhotoAi.filter': 'Filtrar',
    'stockPhotoAi.generateBatch': 'Gerar lote (máx. 10)',
    'stockPhotoAi.batchResult': 'Lote {{mag}}: {{ok}} OK · {{skipped}} ignorados · {{errors}} erros',
    'stockPhotoAi.loading': 'Carregando…',
    'stockPhotoAi.stockLabel': 'Estoque {{qty}}',
    'stockPhotoAi.generateOne': 'Gerar IA',
    'stockPhotoAi.empty': 'Nenhum item sem foto para {{mag}}',
    'stockPhotoAi.errorLoad': 'Não foi possível carregar',
    'stockPhotoAi.errorGenerate': 'Falha na geração',
    'stockPhotoAi.errorBatch': 'Falha no lote',
    'stockPhotoAi.confirmBatch': 'Gerar até {{max}} imagens IA para {{mag}}? (OpenAI · custo de API)',
    'stockCatAudit.title': 'Auditoria de categorias de estoque',
    'stockCatAudit.subtitle': 'Análise completa telefone vs peça/acessório · reservado para Carlos',
    'stockCatAudit.backToIntegrations': 'Integrações admin',
    'stockCatAudit.magasin': 'Loja',
    'stockCatAudit.allStores': 'Todas',
    'stockCatAudit.issuesOnly': 'Apenas linhas com problemas',
    'stockCatAudit.runAnalysis': 'Executar análise',
    'stockCatAudit.statTotal': 'Total',
    'stockCatAudit.statWithIssues': 'Com problemas',
    'stockCatAudit.statFalseImei': 'IMEI falso',
    'stockCatAudit.statNeedsImei': 'IMEI obrigatório',
    'stockCatAudit.statCategorieMismatch': 'Cat. diferente',
    'stockCatAudit.statCategorieMissing': 'Cat. vazia',
    'stockCatAudit.statAmbiguous': 'Ambíguo',
    'stockCatAudit.currentCategories': 'Categorias atuais',
    'stockCatAudit.suggestedCategories': 'Categorias sugeridas',
    'stockCatAudit.searchPlaceholder': 'Ref, descrição, categoria…',
    'stockCatAudit.allFilters': 'Todos os filtros',
    'stockCatAudit.applySuggested': 'Aplicar cat. sugerida ({{count}})',
    'stockCatAudit.colRef': 'Ref',
    'stockCatAudit.colDesignation': 'Descrição',
    'stockCatAudit.colMag': 'Loja',
    'stockCatAudit.colCurrentCat': 'Cat. atual',
    'stockCatAudit.colSuggestedCat': 'Cat. sugerida',
    'stockCatAudit.colType': 'Tipo',
    'stockCatAudit.colIssues': 'Problemas',
    'stockCatAudit.typePhone': 'Tel.',
    'stockCatAudit.typePiece': 'Peça',
    'stockCatAudit.analyzing': 'Analisando…',
    'stockCatAudit.emptyRows': 'Nenhuma linha — execute a análise ou amplie os filtros.',
    'stockCatAudit.hint': 'Ex.: «Suporte de telefone» agora é classificado como Acessório (sem IMEI). Os telefones completos reais continuam sujeitos ao IMEI no inventário.',
    'stockCatAudit.errorAnalyze': 'Análise impossível',
    'stockCatAudit.errorApply': 'Falha ao aplicar',
    'stockCatAudit.confirmApply': 'Aplicar a categoria sugerida a {{count}} artigo(s)?',
    'stockCatAudit.issueFalsePhoneImei': 'Falso telefone (IMEI indevido)',
    'stockCatAudit.issueNeedsImei': 'Telefone — IMEI obrigatório',
    'stockCatAudit.issueCategorieMismatch': 'Categoria diferente',
    'stockCatAudit.issueCategorieMissing': 'Categoria ausente',
    'stockCatAudit.issueAmbiguous': 'Ambíguo',
    'stockHist.periodToday': 'Hoje',
    'stockHist.periodYesterday': 'Ontem',
    'stockHist.periodWeek': 'Esta semana',
    'stockHist.periodMonth': 'Este mês',
    'stockHist.title': 'Histórico de estoque',
    'stockHist.subtitle': 'Movimentações de loja e depósito',
    'stockHist.statMovements': 'Movimentações',
    'stockHist.statPieces': 'Peças',
    'stockHist.locationShop': 'Loja',
    'stockHist.locationWarehouse': 'Depósito',
    'stockHist.empty': 'Nenhuma adição neste período',
    'stockHist.colDateTime': 'Data / Hora',
    'stockHist.colDesignation': 'Item',
    'stockHist.colStore': 'Filial',
    'stockHist.colLocation': 'Local',
    'stockHist.colQty': 'Qtd',
    'stockHist.colSalePrice': 'Preço venda',
    'stockHist.colBy': 'Por',
    'stockHist.statusNew': 'Novo',
    'stockHist.statusRestock': 'Reposição',
    'stockHist.selectedOne': 'selecionado',
    'stockHist.selectedMany': 'selecionados',
    'stockHist.labelOne': 'etiqueta',
    'stockHist.labelMany': 'etiquetas',
    'stockHist.printCount': 'Imprimir ({{count}})',
    'partsOrders.statusPending': 'Pendente',
    'partsOrders.statusPartial': 'Parcial',
    'partsOrders.statusReceived': 'Recebida',
    'partsOrders.statusCancelled': 'Cancelada',
    'partsOrders.filterAll': 'Todas',
    'partsOrders.filterReceived': 'Recebidas',
    'partsOrders.filterCancelled': 'Canceladas',
    'partsOrders.partTypeStandard': 'Padrão',
    'partsOrders.partTypeSpare': 'Peça de reposição',
    'partsOrders.partTypeSerialized': 'Serializado (nº de série/IMEI)',
    'partsOrders.createTitle': 'Novo pedido ao fornecedor',
    'partsOrders.supplier': 'Fornecedor',
    'partsOrders.supplierPlaceholder': 'Nome do fornecedor',
    'partsOrders.line': 'Linha {{num}}',
    'partsOrders.designationPlaceholder': 'Designação *',
    'partsOrders.referencePlaceholder': 'Referência (opcional)',
    'partsOrders.type': 'Tipo',
    'partsOrders.qty': 'Qtd',
    'partsOrders.purchasePriceUnit': 'Preço compra un.',
    'partsOrders.expectedSalePrice': 'Preço venda previsto',
    'partsOrders.category': 'Categoria',
    'partsOrders.categoryPlaceholder': 'Ex.: Tela, Bateria',
    'partsOrders.location': 'Localização',
    'partsOrders.locationShop': 'Loja',
    'partsOrders.locationWarehouse': 'Depósito',
    'partsOrders.addLine': 'Adicionar uma linha',
    'partsOrders.notes': 'Notas',
    'partsOrders.errorNeedLine': 'Adicione pelo menos uma linha com uma designação.',
    'partsOrders.errorCreate': 'Erro ao criar.',
    'partsOrders.cancel': 'Cancelar',
    'partsOrders.creating': 'Criando…',
    'partsOrders.create': 'Criar pedido',
    'partsOrders.receiveTitle': 'Recebimento — {{ref}}',
    'partsOrders.allReceived': 'Todas as linhas já foram recebidas.',
    'partsOrders.remaining': 'Restam {{count}}',
    'partsOrders.receivedQty': 'Qtd recebida',
    'partsOrders.serialsLabel': 'Nº de série / IMEI (um por linha ou separados por vírgula)',
    'partsOrders.errorNeedQty': 'Informe pelo menos uma quantidade recebida.',
    'partsOrders.errorReceive': 'Erro ao receber.',
    'partsOrders.close': 'Fechar',
    'partsOrders.validating': 'Validando…',
    'partsOrders.validateReceive': 'Confirmar recebimento',
    'partsOrders.linkTitle': 'Atribuir a um reparo',
    'partsOrders.linkDescription': 'A peça “{{designation}}” será incluída no preço do reparo sem ser descontada do estoque (ainda não recebida).',
    'partsOrders.linkRefPlaceholder': 'Ref. reparo (ex.: REP-000123)',
    'partsOrders.errorNeedRef': 'Informe a referência do reparo.',
    'partsOrders.errorRepairNotFound': 'Erro: reparo não encontrado?',
    'partsOrders.assign': 'Atribuir',
    'partsOrders.confirmCancel': 'Cancelar este pedido? As peças vinculadas a reparos serão desvinculadas.',
    'partsOrders.errorCancel': 'Erro ao cancelar.',
    'partsOrders.errorGeneric': 'Erro.',
    'partsOrders.supplierUnknown': 'Fornecedor?',
    'partsOrders.linesCount': '{{count}} linha(s)',
    'partsOrders.receivedCount': '{{received}}/{{total}} recebido',
    'partsOrders.purchaseCost': 'custo compra',
    'partsOrders.colDesignation': 'Designação',
    'partsOrders.colReceivedQty': 'Recebido/Qtd',
    'partsOrders.colPurchaseUnit': 'Compra un.',
    'partsOrders.colSalePlanned': 'Venda prevista',
    'partsOrders.colRepair': 'Reparo',
    'partsOrders.colAction': 'Ação',
    'partsOrders.typeSerialized': 'Serializado',
    'partsOrders.typeSpareShort': 'Peça',
    'partsOrders.typeStandardShort': 'Padr.',
    'partsOrders.detach': 'Desvincular',
    'partsOrders.receive': 'Receber',
    'partsOrders.pageTitle': 'Pedidos de peças',
    'partsOrders.pageSubtitle': 'Abastecimento de fornecedores — pré-atribuição a reparo e recebimento',
    'partsOrders.filterAllStores': 'Todos',
    'partsOrders.refresh': 'Atualizar',
    'partsOrders.newOrder': 'Novo pedido',
    'partsOrders.kpiOpenOrders': 'Pedidos em aberto',
    'partsOrders.kpiAssignedParts': 'Peças atribuídas a reparo',
    'partsOrders.kpiCostToReceive': 'Custo a receber',
    'partsOrders.loading': 'Carregando…',
    'partsOrders.empty': 'Nenhum pedido de peças.',
    'stockForm.editTitle': 'Editar item',
    'stockForm.addTitle': 'Adicionar item',
    'stockForm.productSheet': 'Ficha do produto',
    'stockForm.newStockProduct': 'Novo produto de estoque',
    'stockForm.analyzePhoto': 'Analisar foto',
    'stockForm.scan': 'Escanear',
    'stockForm.supplierSearch': 'Busca de fornecedor',
    'stockForm.supplierSearchPlaceholder': 'Referência, EAN ou nome da peça…',
    'stockForm.refShort': 'Ref.:',
    'stockForm.priceLabel': 'Preço:',
    'stockForm.sectionArticle': 'Seção do item',
    'stockForm.reference': 'Referência',
    'stockForm.ean': 'EAN',
    'stockForm.eanPlaceholder': 'Código de barras',
    'stockForm.category': 'Categoria',
    'stockForm.categoryPlaceholder': 'Telas, baterias…',
    'stockForm.designation': 'Descrição',
    'stockForm.supplier': 'Fornecedor',
    'stockForm.sectionStock': 'Seção de estoque',
    'stockForm.location': 'Localização',
    'stockForm.shop': 'Loja',
    'stockForm.depot': 'Depósito',
    'stockForm.both': 'Ambos',
    'stockForm.qtyShop': 'Qtd. loja',
    'stockForm.qtyDepot': 'Qtd. depósito',
    'stockForm.alertThreshold': 'Limite de alerta',
    'stockForm.sectionPricing': 'Seção de preços',
    'stockForm.purchasePrice': 'Preço de compra (sem impostos)',
    'stockForm.salePrice': 'Preço de venda (€)',
    'stockForm.margin': 'Margem',
    'stockForm.sectionShop': 'Seção da loja',
    'stockForm.visibleOnline': 'Visível na loja online',
    'stockForm.visibleOnlineHint': 'Os clientes poderão comprar este item',
    'stockForm.cancel': 'Cancelar',
    'stockForm.saving': 'Salvando…',
    'stockForm.edit': 'Modificar',
    'stockForm.addToStock': 'Adicionar ao estoque',
    'stockForm.save': 'Salvar',
    'stockForm.reviewTitle': 'Verificação do item',
    'stockForm.newArticle': 'Novo item',
    'stockForm.existingBanner': 'Existente — {{designation}} (L:{{qb}} D:{{qd}}). Quantidade adicionada ao estoque.',
    'stockForm.imeiRequired': 'IMEI obrigatório para registrar um telefone no estoque.',
    'stockForm.imeiInvalid': 'IMEI inválido (14 a 20 dígitos).',
    'stockForm.articleNotFound': 'Item não encontrado',
    'stockForm.imeiNotRegistered': 'IMEI não registrado — verifique o número ou Estoque avançado > IMEI.',
    'stockForm.imeiFirstRegistered': 'Primeiro IMEI registrado. {{count}} dispositivo(s) restante(s) — complete os IMEIs em Estoque avançado > aba IMEI (ref. {{ref}}).',
    'stockForm.saveError': 'Erro ao salvar',
    'clientChat.typeBoutiqueOrder': 'Pedido da loja',
    'clientChat.typeRepair': 'Reparo',
    'clientChat.typeClient': 'Conversa com o cliente',
    'clientChat.title': 'Chat de clientes',
    'clientChat.convCount': '{{count}} conversa',
    'clientChat.convCountPlural': '{{count}} conversas',
    'clientChat.searchPlaceholder': 'Buscar um cliente...',
    'clientChat.noConversations': 'Nenhuma conversa de cliente',
    'clientChat.clientFallback': 'Cliente',
    'clientChat.startConversation': 'Inicie a conversa',
    'clientChat.writePlaceholder': 'Escrever ao cliente...',
    'clientChat.selectConversation': 'Selecione uma conversa',
    'stockInvImport.errorAiAnalysis': 'Erro na análise por IA — verifique Admin > Integrações de API (OpenAI)',
    'stockInvImport.confirmMissingImei': '{{count}} linha(s) de telefone sem IMEI completo.\n\nContinuar a importação? Você poderá completar em Estoque avançado > IMEI.',
    'stockInvImport.errorImport': 'Erro na importação',
    'stockInvImport.locationDepot': 'Depósito',
    'stockInvImport.locationBoutique': 'Loja',
    'stockInvImport.pageTitle': 'Importação de nota com IA',
    'stockInvImport.pageSubtitle': 'Análise de PDF · cálculos alinhados com /calcul',
    'stockInvImport.visionHint': 'OpenAI Vision · arredondamento de preços idêntico ao módulo Cálculo de margem',
    'stockInvImport.invoiceLabel': 'Nota fiscal (PDF ou imagem)',
    'stockInvImport.fileSize': '{{size}} KB',
    'stockInvImport.clickToChoose': 'Clique para escolher um arquivo',
    'stockInvImport.shippingTotalLabel': 'Frete total (EUR)',
    'stockInvImport.autoIfEmpty': '— automático se vazio',
    'stockInvImport.shippingPlaceholder': 'Ex.: 29.90',
    'stockInvImport.customsPct': 'Alfândega %',
    'stockInvImport.marginPct': 'Margem %',
    'stockInvImport.analyzing': 'Analisando… (15–30 s)',
    'stockInvImport.analyzeInvoice': 'Analisar a nota fiscal',
    'stockInvImport.kpiProducts': 'Produtos',
    'stockInvImport.kpiSupplier': 'Fornecedor',
    'stockInvImport.kpiShippingTotal': 'Frete total',
    'stockInvImport.kpiShippingPerUnit': 'Frete / unidade',
    'stockInvImport.recalc': 'Recalculando…',
    'stockInvImport.phonesCompleteImei': '{{count}} telefone(s) — complete o IMEI abaixo (extraído automaticamente da nota fiscal, se presente).',
    'stockInvImport.colRef': 'Ref.',
    'stockInvImport.colDesignation': 'Descrição',
    'stockInvImport.colQty': 'Qtd.',
    'stockInvImport.colPurchase': 'Compra',
    'stockInvImport.colPlusShipping': '+Frete',
    'stockInvImport.colPlusCustoms': '+{{pct}}% Alfândega',
    'stockInvImport.colPlusMargin': '+{{pct}}% Margem',
    'stockInvImport.colLabor': 'M.O.',
    'stockInvImport.colFinalPrice': 'Preço final',
    'stockInvImport.remove': 'Remover',
    'stockInvImport.generateEan': 'Gerar EAN',
    'stockInvImport.imeiDevicePlaceholder': 'IMEI do aparelho {{n}}',
    'stockInvImport.back': 'Voltar',
    'stockInvImport.importing': 'Importando…',
    'stockInvImport.confirm': 'Confirmar',
    'stockInvImport.importDone': 'Importação concluída',
    'stockInvImport.created': 'Criados',
    'stockInvImport.updated': 'Atualizados',
    'stockInvImport.imeiRegistered': 'IMEIs registrados',
    'stockInvImport.errors': 'Erros',
    'stockInvImport.imeiMissingTitle': 'IMEIs faltando — completar em Estoque avançado',
    'stockInvImport.missingOfTotal': '{{missing}} faltando / {{total}}',
    'stockInvImport.newImport': 'Nova importação',
    'stockInvImport.backToStock': 'Voltar ao estoque',
    'clientPwd.pinGenerated': 'PIN gerado para {{nom}}: {{pin}}',
    'clientPwd.error': 'Erro',
    'clientPwd.errorSendEmail': 'Erro ao enviar e-mail',
    'clientPwd.errorSendBulk': 'Erro ao enviar em massa',
    'clientPwd.bulkResult': '{{sent}} e-mails enviados, {{errors}} erros',
    'clientPwd.totalClients': '{{total}} clientes no total',
    'clientPwd.sending': 'Enviando...',
    'clientPwd.sendToClients': 'Enviar para {{count}} clientes',
    'clientPwd.searchPlaceholder': 'Buscar por nome, telefone, e-mail...',
    'clientPwd.filterAll': 'Todos',
    'clientPwd.filterSent': 'Senha enviada',
    'clientPwd.filterNotSent': 'Senha não enviada',
    'clientPwd.colName': 'Nome',
    'clientPwd.colPhone': 'Telefone',
    'clientPwd.colEmail': 'E-mail',
    'clientPwd.colPin': 'PIN',
    'clientPwd.colStatus': 'Status',
    'clientPwd.colActions': 'Ações',
    'clientPwd.loading': 'Carregando...',
    'clientPwd.noEmail': 'Sem e-mail',
    'clientPwd.statusSent': 'Enviado',
    'clientPwd.statusPending': 'Pendente',
    'clientPwd.statusNotGenerated': 'Não gerado',
    'clientPwd.genPinTitle': 'Gerar PIN',
    'clientPwd.resend': 'Reenviar',
    'clientPwd.pageOf': 'Página {{page}} / {{total}}',
    'stockInv.error.pickMagasin': 'Primeiro escolha uma loja para este inventário.',
    'stockInv.error.analyzeFailed': 'Análise impossível — verifique a chave da OpenAI ou tente novamente.',
    'stockInv.error.server': 'Erro do servidor',
    'stockInv.dropdown.refLabel': 'Ref.:',
    'stockInv.short.boutique': 'L',
    'stockInv.short.depot': 'D',
    'stockInv.summary.title': 'Resumo do inventário',
    'stockInv.summary.subtitle': '{{count}} artigo(s) salvo(s)',
    'stockInv.summary.statusNew': 'Novo',
    'stockInv.summary.statusUpdated': 'Atualizado',
    'stockInv.summary.errorsTitle': 'Erros',
    'stockInv.summary.created': '{{count}} criado(s)',
    'stockInv.summary.updated': '{{count}} atualizado(s)',
    'stockInv.summary.pieces': '{{count}} peças',
    'stockInv.btn.printLabels': 'Imprimir etiquetas',
    'stockInv.btn.newInventory': 'Novo inventário',
    'stockInv.btn.printCount': 'Imprimir ({{count}})',
    'stockInv.btn.addRow': 'Linha',
    'stockInv.btn.scan': 'Escanear',
    'stockInv.btn.csvImport': 'Importar CSV',
    'stockInv.btn.csvExport': 'Exportar',
    'stockInv.btn.saving': 'Salvando…',
    'stockInv.btn.saveAll': 'Salvar tudo ({{count}})',
    'stockInv.col.status': 'Status',
    'stockInv.col.reference': 'Referência',
    'stockInv.col.designation': 'Descrição',
    'stockInv.col.pAchat': 'P. compra',
    'stockInv.col.pVente': 'P. venda',
    'stockInv.col.lieu': 'Local',
    'stockInv.col.qteAjoutee': 'Qtd adicionada',
    'stockInv.col.stockTotal': 'Estoque total',
    'stockInv.col.magasin': 'Loja',
    'stockInv.col.prixAchat': 'Preço compra (€)',
    'stockInv.col.prixVente': 'Preço venda (€)',
    'stockInv.col.emplacement': 'Local',
    'stockInv.col.qte': 'Qtd',
    'stockInv.col.fournisseur': 'Fornecedor',
    'stockInv.location.boutique': 'Loja',
    'stockInv.location.depot': 'Depósito',
    'stockInv.header.title': 'Inventário de estoque',
    'stockInv.header.subtitleMagasin': 'Entrada rápida · {{magasin}}',
    'stockInv.header.subtitleNoMagasin': 'Entrada rápida · escolha uma loja',
    'stockInv.warn.pickMagasin': 'Escolha uma loja antes de salvar o inventário.',
    'stockInv.cross.title': '{{count}} referência(s) já existe(m) em outra loja',
    'stockInv.cross.explain': 'Você criou uma nova linha na sua loja de destino. Se for intencional (estoque dedicado por loja), ignore esta mensagem. Se queria transferir, vá em',
    'stockInv.cross.explainTransfer': '→ Transferir.',
    'stockInv.cross.createdIn': 'criado em {{magasin}}',
    'stockInv.cross.existedIn': 'existia em',
    'stockInv.cross.noMagasin': '— sem loja —',
    'stockInv.cross.qty': 'qtd',
    'stockInv.badge.existing': 'existente',
    'stockInv.badge.new': 'novo',
    'stockInv.placeholder.refEan': 'Ref. / EAN',
    'stockInv.placeholder.ean13': 'Código EAN13',
    'stockInv.placeholder.productName': 'Nome do produto',
    'stockInv.placeholder.fournisseur': 'Fornecedor',
    'stockInv.footer.rows': 'linhas',
    'stockInv.footer.toSave': 'para salvar',
    'stockInv.footer.existingCount': '({{count}} existente(s))',
    'stockInv.footer.newCount': '({{count}} novo(s))',
    'stockInv.footer.piecesAndValue': '{{count}} peças · {{value}} compra',
    'stockInv.hint.enterBefore': 'Pressione',
    'stockInv.hint.enterKey': 'Enter',
    'stockInv.hint.enterAfter': 'para ir à próxima linha',
    'stockInv.review.title': 'Pré-análise do inventário',
    'stockInv.review.subtitle': '{{count}} linha(s) · loja {{magasin}}',
    'staffChat.statusOnline': 'Online',
    'staffChat.statusBusy': 'Ocupado',
    'staffChat.statusAway': 'Ausente',
    'staffChat.statusOffline': 'Offline',
    'staffChat.colorYellow': 'Amarelo',
    'staffChat.colorBlue': 'Azul',
    'staffChat.colorGreen': 'Verde',
    'staffChat.colorOrange': 'Laranja',
    'staffChat.colorPurple': 'Roxo',
    'staffChat.colorCyan': 'Ciano',
    'staffChat.colorRed': 'Vermelho',
    'staffChat.quickRepliesTitle': 'Respostas rápidas',
    'staffChat.quickRepliesSubtitle': 'Personalize as respostas do chat',
    'staffChat.qrLabelPlaceholder': 'Rótulo (ex.: Pronto!)',
    'staffChat.qrTextPlaceholder': 'Texto da mensagem...',
    'staffChat.qrSaveEdit': 'Salvar',
    'staffChat.cancel': 'Cancelar',
    'staffChat.add': 'Adicionar',
    'staffChat.filterAll': 'Todos',
    'staffChat.filterTeam': 'Equipe',
    'staffChat.filterClients': 'Clientes',
    'staffChat.filterTickets': 'Tickets',
    'staffChat.filterQuick': 'Rápidas',
    'staffChat.messaging': 'Mensagens',
    'staffChat.newConversation': 'Nova conversa',
    'staffChat.searchPlaceholder': 'Buscar uma conversa...',
    'staffChat.noStaffAvailable': 'Nenhum membro disponível',
    'staffChat.labelTeam': 'Equipe',
    'staffChat.labelOrder': 'Pedido',
    'staffChat.labelRepair': 'Reparo',
    'staffChat.labelClient': 'Cliente',
    'staffChat.priorityUrgent': 'Urgente',
    'staffChat.priorityMedium': 'Médio',
    'staffChat.priorityNormal': 'Normal',
    'staffChat.ticketsNone': 'Nenhum ticket pendente',
    'staffChat.ticketsAllHandled': 'Todas as mensagens foram tratadas',
    'staffChat.timeAgoLessThanHour': 'há menos de 1 h',
    'staffChat.timeAgoHours': 'há {{h}} h',
    'staffChat.viewConversation': 'Ver conversa',
    'staffChat.close': 'Fechar',
    'staffChat.recentlyClosed': 'Fechados recentemente',
    'staffChat.closedBy': 'por {{name}}',
    'staffChat.noConversations': 'Nenhuma conversa',
    'staffChat.conversation': 'Conversa',
    'staffChat.startConversation': 'Inicie a conversa',
    'staffChat.endToEndEncrypted': 'As mensagens são criptografadas de ponta a ponta',
    'staffChat.aiAssistant': 'Assistente de IA',
    'staffChat.autoBadge': 'auto',
    'staffChat.nudgeTitle': 'Enviar uma chamada de atenção!',
    'staffChat.sending': 'Enviando...',
    'staffChat.messagePlaceholder': 'Escreva uma mensagem...',
    'staffChat.selectConversation': 'Selecione uma conversa',
    'staffChat.chooseFromList': 'Escolha na lista à esquerda',
    'warnDuplicateReference': 'Já em estoque — +1 ao registrar',
    'warnDuplicateEan': 'EAN já em estoque — +1 ao registrar',
    'warnCrossMagasin': 'Referência em outra loja',
    'warnLowVision': 'Leitura de foto incerta',
    'warnPrixAchatManual': 'Preço de compra a inserir manualmente',
    'warnLlmUnavailable': 'Visão IA indisponível (chaves API)',
    'alertAddPhotoOrText': 'Adicione uma foto ou cole o texto da etiqueta.',
    'errAnalyzePhoto': 'Erro na análise da foto',
    'alertEnterPrixAchat': 'Informe um preço de compra para recalcular o preço de venda.',
    'errCalcPrice': 'Erro no cálculo do preço',
    'alertRefDesignationRequired': 'Referência e designação obrigatórias.',
    'alertPrixVenteRequired': 'Preço de venda obrigatório.',
    'noticeAddedToList': '+{{qty}} à lista: {{designation}} (total +{{total}})',
    'noticeStockUpdate': 'Atualização de estoque: {{designation}} (+{{qty}})',
    'noticeAdded': 'Adicionado: {{designation}} (×{{qty}})',
    'errServer': 'Erro do servidor',
    'alertChooseMagasin': 'Escolha uma loja.',
    'errAnalyzeImpossible': 'Análise impossível',
    'summaryTitle': 'Itens registrados',
    'summarySubtitle': '{{created}} criado(s) · {{updated}} atualizado(s) · {{labels}} etiqueta(s) a imprimir',
    'printLabels': 'Imprimir etiquetas ({{count}})',
    'newSession': 'Nova sessão',
    'colStatut': 'Status',
    'colReference': 'Referência',
    'colDesignation': 'Designação',
    'colPrixAchat': 'P. compra',
    'colPrixVente': 'P. venda',
    'colQtyAdded': 'Qtd. adicionada',
    'badgeNew': 'Novo',
    'badgeAddStock': '+estoque',
    'pageTitle': 'Analisar um produto',
    'pageSubtitle': 'Escaneie vários itens · valide cada linha · salve tudo de uma vez',
    'pendingList': 'Lista pendente — {{count}} item(ns) · {{pieces}} peça(s)',
    'saveAll': 'Salvar tudo ({{count}})',
    'badgeUpdate': 'Atualização',
    'depot': 'Depósito',
    'boutique': 'Loja',
    'stockAbbrev': 'estoque L:{{boutique}} D:{{depot}}',
    'remove': 'Remover',
    'photoSectionTitle': 'Foto do produto',
    'productAlt': 'Produto',
    'photoHint': 'Galeria ou câmera — embalagem ou etiqueta (EAN visível)',
    'gallery': 'Galeria',
    'camera': 'Câmera',
    'analyzing': 'Analisando…',
    'analyze': 'Analisar',
    'aiVisionOption': 'Visão IA se a etiqueta for ilegível (OpenAI / Gemini)',
    'labelTextLabel': 'Texto da etiqueta (opcional — se o código de barras estiver ilegível)',
    'labelTextPlaceholder': 'Tela iPhone 8 OLED\nEAN 3701234567890\nRef IP8-LCD-001',
    'emptyHint': 'Inicie a análise para preencher a ficha de estoque.',
    'analyzingHint': 'Lendo etiqueta e buscando fornecedor…',
    'alreadyInStockPrefix': 'Já em estoque ({{magasin}}) — registro =',
    'alreadyInStockSuffix': '(loja {{boutique}} · depósito {{depot}})',
    'alreadyInListPrefix': 'Já na lista (×{{qty}}) — aceitar =',
    'alreadyInListSuffix': 'à lista',
    'currentStockBoutique': '(estoque atual da loja: {{qty}})',
    'resultTitle': 'Resultado da análise',
    'readConfidence': 'Confiança da leitura: {{pct}}%',
    'aiVision': 'Visão IA',
    'matchLabel': 'correspondência',
    'fieldDesignation': 'Designação *',
    'fieldReference': 'Referência *',
    'fieldCategorie': 'Categoria',
    'fieldFournisseur': 'Fornecedor',
    'otherSupplierParts': 'Outras peças do fornecedor',
    'tarifsTitle': 'Preços',
    'fieldPrixAchat': 'Preço de compra (€)',
    'autoSupplierCache': 'Cache automático do fornecedor',
    'fieldPrixVente': 'Preço de venda (€)',
    'recalcVente': 'Recalcular venda',
    'laborLabel': 'MO: {{amount}}',
    'detailTitle': 'Detalhe do cálculo Auto-Orçamento',
    'detailAchat': 'Compra:',
    'detailPort': 'Frete:',
    'detailDouane': 'Alfândega:',
    'detailCoutPiece': 'Custo por peça:',
    'detailFinal': 'Final:',
    'qtyLocationTitle': 'Quantidade e local',
    'quantite': 'Quantidade',
    'quit': 'Sair',
    'acceptPlusOne': 'Aceitar (+1)',
    'acceptLine': 'Aceitar a linha',
    'acceptHelp': 'Duplicata na lista ou estoque = +1 automático · depois "Salvar tudo" · etiquetas no final.',
    'reviewTitleAccept': 'Esta linha está correta?',
    'reviewTitleBulk': 'Verificação antes de salvar',
    'reviewSubtitleAccept': 'Confirme para adicionar à lista e depois escaneie o próximo item',
    'reviewBulkSubtitle': '{{count}} item(ns) para salvar no estoque',
    'avoirs.title': 'Vales de crédito',
    'avoirs.subtitle': 'Crédito do cliente gerado por um recibo ou nota fiscal — utilizável no PDV',
    'avoirs.refresh': 'Atualizar',
    'avoirs.errorLoad': 'Erro ao carregar os vales de crédito',
    'avoirs.searchPlaceholder': 'Ref. do vale, cliente, recibo de origem…',
    'avoirs.allStatuses': 'Todos os status',
    'avoirs.empty': 'Nenhum vale de crédito',
    'avoirs.colRef': 'Referência',
    'avoirs.colClient': 'Cliente',
    'avoirs.colOrigin': 'Origem',
    'avoirs.colInitial': 'Inicial',
    'avoirs.colSolde': 'Saldo',
    'avoirs.colStatut': 'Status',
    'avoirs.colDate': 'Data',
    'avoirs.createdBy': 'Criado por',
    'avoirs.originLabel': 'Origem:',
    'avoirs.motifLabel': 'Motivo:',
    'avoirs.clientLabel': 'Cliente:',
    'avoirs.printTicket': 'Imprimir recibo de vale',
    'avoirs.downloadPdf': 'Baixar PDF',
    'avoirs.historyTitle': 'Histórico de movimentações',
    'avoirs.cancelRemaining': 'Cancelar o saldo restante',
    'avoirs.confirmCancel': 'Cancelar o saldo restante de {{ref}}?',
    'avoirs.close': 'Fechar',
    'avoirs.statutDisponible': 'Disponível',
    'avoirs.statutPartiel': 'Parcialmente utilizado',
    'avoirs.statutUtilise': 'Utilizado',
    'avoirs.statutAnnule': 'Cancelado',
    'stockMov.tab.dashboard': 'Painel',
    'stockMov.tab.movements': 'Movimentações',
    'stockMov.tab.imei': 'IMEI / Séries',
    'stockMov.tab.inventory': 'Inventário',
    'stockMov.header.title': 'Estoque avançado',
    'stockMov.header.subtitle': 'Movimentações · IMEI · sessões de inventário · painel',
    'stockMov.cancel': 'Cancelar',
    'stockMov.save': 'Salvar',
    'stockMov.saving': 'Salvando...',
    'stockMov.loadError': 'Erro de carregamento',
    'stockMov.error': 'Erro: {{detail}}',
    'stockMov.loading': 'Carregando…',
    'stockMov.pageOf': 'Página {{page}} / {{total}}',
    'stockMov.kpi.totalArticles': 'Total de artigos',
    'stockMov.kpi.qteBoutique': 'Qtd. loja',
    'stockMov.kpi.qteDepot': 'Qtd. depósito',
    'stockMov.kpi.ruptures': 'Rupturas',
    'stockMov.kpi.imeiEnStock': 'IMEI em estoque',
    'stockMov.boutique': 'Loja',
    'stockMov.depot': 'Depósito',
    'stockMov.total': 'Total',
    'stockMov.valeurAchat': 'Valor de compra',
    'stockMov.valeurVente': 'Valor de venda',
    'stockMov.marge': 'Margem',
    'stockMov.margeTotale': 'Margem total',
    'stockMov.stocksNegatifs': 'Estoque negativo ({{count}})',
    'stockMov.aucunStockNegatif': 'Nenhum estoque negativo',
    'stockMov.articlesSousSeuil': 'Artigos abaixo do limite ({{count}})',
    'stockMov.tousAuDessusSeuil': 'Todos os artigos estão acima do seu limite de alerta',
    'stockMov.filter.all': 'Todos',
    'stockMov.filter.entrees': 'Entradas',
    'stockMov.filter.sorties': 'Saídas',
    'stockMov.magasinLabel': 'Loja:',
    'stockMov.nouveauMouvement': 'Nova movimentação',
    'stockMov.col.date': 'Data',
    'stockMov.col.type': 'Tipo',
    'stockMov.col.motif': 'Motivo',
    'stockMov.col.article': 'Artigo',
    'stockMov.col.magasin': 'Loja',
    'stockMov.col.qte': 'Qtd.',
    'stockMov.col.stockAvant': 'Estoque antes',
    'stockMov.col.stockApres': 'Estoque depois',
    'stockMov.col.imei': 'IMEI',
    'stockMov.col.par': 'Por',
    'stockMov.aucunMouvement': 'Nenhuma movimentação registrada',
    'stockMov.type.transfert': 'Transferência',
    'stockMov.type.entree': 'Entrada',
    'stockMov.type.sortie': 'Saída',
    'stockMov.modalNewMovement': 'Nova movimentação de estoque',
    'stockMov.field.motif': 'Motivo',
    'stockMov.field.article': 'Artigo',
    'stockMov.searchArticlePlaceholder': 'Pesquisar um artigo...',
    'stockMov.refStock': '({{ref}}) Estoque: {{qty}}',
    'stockMov.refShort': 'Ref.: {{ref}}',
    'stockMov.field.quantite': 'Quantidade',
    'stockMov.field.prixUnitaire': 'Preço unitário',
    'stockMov.field.imeiOptional': 'IMEI / N.º de série (opcional)',
    'stockMov.imeiPlaceholder': 'Ex.: 353012345678901',
    'stockMov.field.noteOptional': 'Nota (opcional)',
    'stockMov.commentPlaceholder': 'Comentário...',
    'stockMov.imeiRefRequired': 'IMEI e referência obrigatórios',
    'stockMov.refQtyRequired': 'Referência e quantidade obrigatórias',
    'stockMov.registreTitle': 'Registro IMEI — rastreabilidade de telefones',
    'stockMov.registreDesc': 'Cada aparelho em estoque deve ter um IMEI único. Permite consultar o histórico (compra, venda POS, reparo).',
    'stockMov.nouveauTelephone': 'Novo telefone',
    'stockMov.searchImeiPlaceholder': 'Pesquisar IMEI, artigo...',
    'stockMov.tousLesStatuts': 'Todos os status',
    'stockMov.enregistrerImei': 'Registrar IMEI',
    'stockMov.col.imeiSerie': 'IMEI / N.º de série',
    'stockMov.col.refDot': 'Ref.',
    'stockMov.col.magShort': 'Loja',
    'stockMov.col.etat': 'Condição',
    'stockMov.col.statut': 'Status',
    'stockMov.col.origine': 'Origem',
    'stockMov.aucunImei': 'Nenhum IMEI — adicione um telefone ao estoque e registre o número aqui.',
    'stockMov.historique': 'Histórico',
    'stockMov.historiqueImei': 'Histórico · {{imei}}',
    'stockMov.byUser': 'por {{user}}',
    'stockMov.aucunMouvementImei': 'Nenhuma movimentação vinculada a este IMEI.',
    'stockMov.modalRegisterImei': 'Registrar um IMEI / N.º de série',
    'stockMov.field.articleStockRef': 'Artigo de estoque (referência)',
    'stockMov.searchPlaceholder': 'Pesquisar...',
    'stockMov.field.etat': 'Condição',
    'stockMov.field.origine': 'Origem',
    'stockMov.origine.achat': 'Compra',
    'stockMov.origine.reprise_client': 'Troca de cliente',
    'stockMov.origine.transfert': 'Transferência',
    'stockMov.etat.neuf': 'Novo',
    'stockMov.etat.occasion': 'Usado',
    'stockMov.etat.reconditionne': 'Recondicionado',
    'stockMov.etat.hs': 'Com defeito',
    'stockMov.statut.en_stock': 'Em estoque',
    'stockMov.statut.vendu': 'Vendido',
    'stockMov.statut.reserve': 'Reservado',
    'stockMov.statut.en_reparation': 'Em reparo',
    'stockMov.motif.achat_fournisseur': 'Compra de fornecedor',
    'stockMov.motif.retour_client': 'Devolução de cliente',
    'stockMov.motif.correction_inventaire': 'Correção de inventário',
    'stockMov.motif.transfert_entrant': 'Transferência de entrada',
    'stockMov.motif.reception_commande': 'Recebimento de pedido',
    'stockMov.motif.reintegration_reparation': 'Reintegração de reparo',
    'stockMov.motif.vente_pos': 'Venda POS',
    'stockMov.motif.consommation_reparation': 'Consumo em reparo',
    'stockMov.motif.perte_casse': 'Perda / quebra',
    'stockMov.motif.retour_fournisseur': 'Devolução a fornecedor',
    'stockMov.motif.transfert_sortant': 'Transferência de saída',
    'stockMov.motif.ajustement_inventaire': 'Ajuste de inventário',
    'stockMov.sessionsInventaire': 'Sessões de inventário',
    'stockMov.nouvelInventaire': 'Novo inventário',
    'stockMov.aucuneSession': 'Nenhuma sessão de inventário',
    'stockMov.parUser': 'Por {{user}}',
    'stockMov.articlesEcarts': '{{articles}} artigos, {{ecarts}} diferenças',
    'stockMov.status.enCours': 'Em andamento',
    'stockMov.status.valide': 'Validado',
    'stockMov.retourSessions': 'Voltar às sessões',
    'stockMov.statutColon': 'Status:',
    'stockMov.validePar': 'Validado por {{user}}',
    'stockMov.validerSansCorrection': 'Validar sem correção',
    'stockMov.validerCorriger': 'Validar + corrigir estoque',
    'stockMov.comptagePhysique': 'Contagem física',
    'stockMov.searchArticleShort': 'Pesquisar artigo...',
    'stockMov.inv.bdShort': 'L:{{b}} D:{{d}}',
    'stockMov.stockSelectionne': 'Estoque selecionado:',
    'stockMov.dotBoutique': '· loja {{q}}',
    'stockMov.dotDepot': '· depósito {{q}}',
    'stockMov.qteComptee': 'Qtd. contada',
    'stockMov.col.stockTheorique': 'Estoque teórico',
    'stockMov.col.comptagePhysique': 'Contagem física',
    'stockMov.col.ecart': 'Diferença',
    'stockMov.col.comptePar': 'Contado por',
    'stockMov.aucunArticleCompte': 'Nenhum artigo contado. Inicie a contagem acima.',
    'stockMov.modalNewSession': 'Nova sessão de inventário',
    'stockMov.field.titreOptional': 'Título (opcional)',
    'stockMov.titrePlaceholder': 'Ex.: Inventário mensal março de 2026',
    'stockMov.creating': 'Criando...',
    'stockMov.creer': 'Criar',
    'stockMov.confirmValidateApply': 'Validar E aplicar as correções de estoque?',
    'stockMov.confirmValidateNoApply': 'Validar SEM aplicar as correções?',
    'stockMov.sessionValidee': 'Sessão validada!',
    'stockMov.countSaved': 'Contagem salva: Estoque teórico {{theorique}}, Físico {{physique}}, Diferença {{ecart}}',
    'stock.err.templateDownload': 'Erro ao baixar o modelo',
    'stock.err.missingId': 'Erro: ID do artigo ausente',
    'stock.deleteSuccess': 'Artigo excluído com sucesso',
    'stock.err.delete': 'Erro ao excluir',
    'stock.confirmDeleteMany': 'Excluir {{count}} artigo(s)?',
    'stock.err.update': 'Erro ao atualizar',
    'stock.err.transfer': 'Erro na transferência',
    'stock.err.bulkTransfer': 'Erro na transferência em massa',
    'stock.depotOnlyM1': 'O depósito está disponível apenas em M1 por enquanto.',
    'stock.sameSourceDest': 'A origem e o destino são idênticos.',
    'stock.noLineToTransfer': 'Nenhuma linha para transferir (quantidades nulas ou loja de origem = destino).',
    'stock.confirmBulkPublish': 'Colocar {{count}} artigo(s) à venda on-line?',
    'stock.confirmBulkUnpublish': 'Retirar {{count}} artigo(s) da venda on-line?',
    'stock.confirmPublishOne': 'Colocar "{{name}}" à venda on-line?',
    'stock.confirmUnpublishOne': 'Retirar "{{name}}" da venda on-line?',
    'stock.importDone': 'Importação concluída',
    'stock.importCreated': 'criado(s)',
    'stock.importUpdated': 'atualizado(s)',
    'stock.importSkipped': 'ignorado(s)',
    'stock.importErrors': 'erro(s)',
    'stock.importRetryHint': '{{count}} artigo(s) já existia(m) — execute novamente no modo "Atualizar".',
    'stock.importRetryBtn': 'Executar novamente (atualizar)',
    'stock.importViewErrors': 'Ver os {{count}} erro(s)',
    'stock.transferTitle': 'Transferência de estoque',
    'stock.boutique': 'Loja',
    'stock.depot': 'Depósito',
    'stock.sourceStore': 'Loja de origem',
    'stock.sourceLocation': 'Local de origem',
    'stock.destStore': 'Loja de destino',
    'stock.destLocation': 'Local de destino',
    'stock.quantity': 'Quantidade',
    'stock.availableAtSource': 'Disponível na origem: {{count}}',
    'stock.cancel': 'Cancelar',
    'stock.transferring': 'Transferindo…',
    'stock.transfer': 'Transferir',
    'stock.bulkTransferTitle': 'Mudar a loja de {{count}} artigo(s)',
    'stock.location': 'Local',
    'stock.bulkTransferR1Note': 'A transferência respeita a regra R1: o documento de origem mantém quantidade 0 se esvaziado e um novo documento é criado na loja de destino.',
    'stock.colArticle': 'Artigo',
    'stock.colCurrentStore': 'Loja atual',
    'stock.colStock': 'Estoque',
    'stock.colQtyToTransfer': 'Quantidade a transferir',
    'stock.runTransfer': 'Iniciar transferência',
    'stock.resultSucceeded': 'com sucesso',
    'stock.resultFailed': 'com falha',
    'stock.resultUnitsTransferred': 'unidades transferidas',
    'stock.failuresLabel': 'Falhas:',
    'stock.done': 'Concluir',
    'stock.storeN': 'Loja {{n}}',
    'stock.tab.view': 'Visão',
    'stock.tab.inventory': 'Inventário',
    'stock.tab.analyze': 'Analisar produto',
    'stock.tab.history': 'Histórico',
    'stock.tab.supplierOrders': 'Reposição fornecedor',
    'stock.tab.invoiceImport': 'Importar nota fiscal IA',
    'stock.tab.labels': 'Etiquetas',
    'stock.tab.advanced': 'Estoque avançado',
    'stock.tab.reconciliation': 'Reconciliação',
    'stock.tab.config': 'Configuração',
    'posV2.remisePlafonneeMsg': 'Desconto limitado a {{pct}}%. Acima disso, é necessária a aprovação da gerência.',
    'posV2.venteNonEnregRemiseRamenee': 'A venda NÃO foi registrada — o desconto foi reduzido ao limite; confira o total e cobre novamente.',
    'posV2.remiseRameneeVerif': 'O desconto foi reduzido ao limite — confira o total e cobre.',
    'posV2.catalogUnavailable': 'Catálogo indisponível',
    'posV2.paymentRefusedTpe': 'Pagamento recusado ou cancelado na maquininha — tente novamente.',
    'posV2.caisseClosedOpenFirst': 'Caixa {{mag}} fechado — abra-o antes de cobrar',
    'posV2.sumupCheckoutDesc': 'POS V2 · {{count}} linha(s)',
    'posV2.sumupTerminalNotConnected': 'Terminal SumUp não conectado',
    'posV2.sumupSaleNotSaved': '{{msg}}. A venda NÃO foi registrada (estoque inalterado). Verifique se a maquininha está ligada e conectada.',
    'posV2.cartEmpty': 'Carrinho vazio',
    'posV2.lookupValidAvoir': 'Busque um vale válido antes de cobrar',
    'posV2.printError': 'Erro de impressão',
    'posV2.caisseClosedBanner': 'Caixa {{mag}} fechado.',
    'posV2.open': 'Abrir',
    'posV2.oneEncaissementMultiStock': '1 cobrança {{mag}} · estoque multiloja',
    'posV2.catalog': 'Catálogo',
    'posV2.ficheButtonHint': 'Botão Ficha → galeria de fotos',
    'posV2.all': 'Todos',
    'posV2.stockMag': 'Estoque {{mag}}',
    'posV2.catalogPlaceholder': 'Catálogo…',
    'posV2.go': 'Ir',
    'posV2.catalogMeta': '{{total}} refs · {{scope}} · pág.{{page}}/{{pages}}',
    'posV2.enterAvoirRefOrClient': 'Digite uma referência de vale ou um nome de cliente',
    'posV2.avoirNotFound': 'Vale não encontrado',
    'posV2.productSheet': 'Ficha do produto',
    'posV2.productSheetSub': 'Galeria · estoque · adicionar ao carrinho',
    'posV2.ticketCenter': 'Central de tickets',
    'posV2.ticketCenterSub': 'Tickets recentes · reimpressão',
    'posV2.savStation': 'Posto de pós-venda / reparo',
    'posV2.savStationSub': 'Buscar ficha · cobrar saldo · sinal · carrinho',
    'posV2.horsStock': 'Fora de estoque',
    'posV2.horsStockSub': 'Venda de item avulso · selo FORA DE ESTOQUE · cobrança direta',
    'posV2.clientCenter': 'Central do cliente',
    'posV2.clientCenterSub': 'Histórico · fidelidade · vincular à venda',
    'posV2.orders': 'Pedidos',
    'posV2.ordersSub': 'Solicitação do cliente · pedido · sinal · carrinho',
    'openCaisse.denomBill': 'Cédula',
    'openCaisse.denomCoin': 'Moeda',
    'openCaisse.cardTotal': 'Total',
    'openCaisse.successOpen': 'Caixa {{magasin}} aberto com sucesso.',
    'openCaisse.errorOpen': 'Erro ao abrir o caixa',
    'openCaisse.backToDashboard': 'Voltar ao painel',
    'openCaisse.title': 'Abertura de caixa {{magasin}}',
    'openCaisse.titleForce': 'Abertura forçada de caixa {{magasin}}',
    'openCaisse.openingFund': 'Fundo de abertura',
    'openCaisse.openingFundHint': 'Informe as cédulas e moedas para o caixa {{magasin}}.',
    'openCaisse.totalOpening': 'Total de abertura',
    'openCaisse.forceWarning': 'Esta ação fechará o caixa aberto da loja de destino e criará um novo caixa com este valor.',
    'openCaisse.cancel': 'Cancelar',
    'openCaisse.opening': 'Abrindo...',
    'openCaisse.validateOpening': 'Confirmar abertura',
    'calcul.title': 'Ferramenta de cálculo de preço / orçamento',
    'calcul.subtitle': 'Interface idêntica ao cálculo PHP + geração de PDF 80mm e A4.',
    'calcul.clientSection': 'Informações do cliente',
    'calcul.clientName': 'Nome do cliente',
    'calcul.phone': 'Telefone',
    'calcul.email': 'E-mail',
    'calcul.saveClient': 'Salvar cliente',
    'calcul.deviceSection': 'Seleção do aparelho',
    'calcul.brand': 'Marca',
    'calcul.model': 'Modelo',
    'calcul.itemsSection': 'Itens',
    'calcul.itemDescription': 'Peça / Descrição',
    'calcul.itemReference': 'Ref. peça',
    'calcul.itemPurchasePrice': 'Preço de compra',
    'calcul.addLine': 'Adicionar uma linha',
    'calcul.paramsSection': 'Parâmetros',
    'calcul.quantity': 'Quantidade',
    'calcul.labor': 'Mão de obra (€)',
    'calcul.partReference': 'Referência da peça',
    'calcul.supplier': 'Fornecedor',
    'calcul.docType': 'Tipo de documento',
    'calcul.docTypeDevis': 'ORÇAMENTO',
    'calcul.docTypeFacture': 'FATURA',
    'calcul.docTypeProforma': 'PROFORMA',
    'calcul.acceptOnlinePayment': 'Aceitar pagamento online (SumUp)',
    'calcul.acceptOnlinePaymentHint': 'O cliente poderá solicitar um link de pagamento SumUp',
    'calcul.saveTicket': '✅ Salvar o ticket',
    'calcul.saving': 'Salvando...',
    'calcul.preview': '👁️ Pré-visualizar',
    'calcul.previewSection': 'Pré-visualização',
    'calcul.previewIframeTitle': 'Pré-visualização do ticket',
    'calcul.previewEmpty': 'Execute um cálculo para exibir o ticket.',
    'calcul.printTicket': 'Imprimir ticket',
    'calcul.transformA4': 'Converter em orçamento A4',
    'calcul.totalArticles': 'Total de itens',
    'calcul.totalPurchase': 'Total de compra',
    'calcul.shippingFees': 'Frete',
    'calcul.customsFees': 'Taxas alfandegárias',
    'calcul.costPerPiece': 'Custo por peça',
    'calcul.finalPrice': 'Preço final',
    'calcul.alertAllowPopups': 'Permita os pop-ups para imprimir.',
    'calcul.alertAddItem': 'Adicione pelo menos um item com preço de compra.',
    'calcul.ticketSaved': '✅ Ticket salvo.',
    'calcul.errorGenerateTicket': 'Erro ao gerar o ticket',
    'calcul.errorPrintTicket': 'Erro ao imprimir o ticket',
    'calcul.errorGenerateA4': 'Erro ao gerar o orçamento A4',
    'caisseHist.errPrint': 'Erro ao imprimir o caixa',
    'caisseHist.errPrintGeneric': 'Erro de impressão',
    'caisseHist.errLoadMonthly': 'Erro ao carregar o histórico mensal',
    'caisseHist.errExport': 'Erro ao exportar a contabilidade',
    'caisseHist.confirmForceClose': 'Fechar forçadamente o caixa de {{date}}? Esta ação é irreversível.',
    'caisseHist.errForceClose': 'Erro durante o fechamento forçado',
    'caisseHist.title': 'Histórico de aberturas / fechamentos de caixa',
    'caisseHist.month': 'Mês',
    'caisseHist.store': 'Loja',
    'caisseHist.allStores': 'Todas as lojas',
    'caisseHist.exportAccounting': 'Exportar contabilidade',
    'caisseHist.totalSales': 'Total de vendas',
    'caisseHist.totalCash': 'Total em dinheiro',
    'caisseHist.totalCard': 'Total cartão',
    'caisseHist.withdrawals': 'Retiradas',
    'caisseHist.totalTheoretical': 'Total teórico',
    'caisseHist.totalAccounting': 'Total contábil',
    'caisseHist.discrepancy': 'Diferença',
    'caisseHist.validatedBy': 'Validado por',
    'caisseHist.validationDate': 'Data de validação',
    'caisseHist.noValidatedCaisse': 'Nenhum caixa validado.',
    'caisseHist.opening': 'Abertura',
    'caisseHist.closing': 'Fechamento',
    'caisseHist.caisse': 'Caixa',
    'caisseHist.daySales': 'Vendas do dia',
    'caisseHist.dateStart': 'Data inicial',
    'caisseHist.dateEnd': 'Data final',
    'caisseHist.reset': 'Redefinir',
    'caisseHist.cashFloat': 'Fundo de caixa',
    'caisseHist.openedBy': 'Aberto por',
    'caisseHist.closedBy': 'Fechado por',
    'caisseHist.noHistory': 'Nenhum histórico disponível',
    'caisseHist.closingProgress': 'Fechando...',
    'caisseHist.forceClose': 'Fechar (forçado)',
    'caisseHist.forced': 'Forçado',
    'caisseHist.showMore': 'Ver mais ({{count}} aberturas anteriores)',
    'caisseHist.showLess': 'Ver menos',
    'repairDetail.popupBlocked': 'Permita os pop-ups para imprimir.',
    'repairDetail.downloadError': 'Erro ao baixar',
    'repairDetail.statusUpdateError': 'Erro ao atualizar',
    'repairDetail.invalidAmount': 'Valor inválido',
    'repairDetail.genericError': 'Erro',
    'repairDetail.filesAttached': '{{count}} arquivo(s) anexado(s)',
    'repairDetail.uploadProgress': 'Enviando {{current}}/{{total}}…',
    'repairDetail.addNoteError': 'Erro ao adicionar a nota',
    'repairDetail.confirmDeleteNote': 'Excluir esta nota?',
    'repairDetail.notFound': 'Reparo não encontrado',
    'repairDetail.backToRepairs': 'Voltar aos reparos',
    'repairDetail.photosTitle': 'Fotos ({{count}})',
    'repairDetail.photoAlt': 'Foto {{index}}',
    'repairDetail.notesTitle': 'Notas ({{count}})',
    'repairDetail.notePlaceholder': 'Adicionar uma nota...',
    'repairDetail.visibilityPublic': 'Público',
    'repairDetail.visibilityInternal': 'Interno',
    'repairDetail.filesBtn': 'Arquivos',
    'repairDetail.sending': 'Enviando...',
    'repairDetail.add': 'Adicionar',
    'repairDetail.noNotes': 'Sem notas',
    'repairDetail.staffDefault': 'Equipe',
    'repairDetail.printAcompteError': 'Erro ao imprimir o comprovante de sinal',
    'repairDetail.printAvoirError': 'Erro ao imprimir o comprovante de crédito',
    'repairDetail.downloadPdfError': 'Erro ao baixar o PDF',
    'repairDetail.changeStatus': 'Alterar o status',
    'repairDetail.noStatusChange': 'Nenhuma alteração permitida',
    'repairDetail.addDeposit': 'Adicionar um sinal',
    'repairDetail.amountLabel': 'Valor (€)',
    'repairDetail.paymentMode': 'Forma de pagamento',
    'repairDetail.paymentCash': 'Dinheiro',
    'repairDetail.paymentCard': 'Cartão',
    'repairDetail.paymentTransfer': 'Transferência',
    'repairDetail.paymentCheck': 'Cheque',
    'repairDetail.cancel': 'Cancelar',
    'repairDetail.statusRecu': 'Recebido',
    'repairDetail.statusEnCours': 'Em andamento',
    'repairDetail.statusAttentePieces': 'Aguardando peças',
    'repairDetail.statusPieceArrivee': 'Peça recebida',
    'repairDetail.statusNonReparable': 'Não reparável',
    'repairDetail.statusTermine': 'Concluído',
    'repairDetail.statusLivre': 'Entregue',
    'repairDetail.statusAttenteDepot': 'Aguardando entrega do aparelho',
    'closeCaisse.denomBillet': 'Cédula',
    'closeCaisse.denomPiece': 'Moeda',
    'closeCaisse.countBadge': '× {{count}}',
    'closeCaisse.total': 'Total',
    'closeCaisse.errLoad': 'Erro ao carregar o caixa',
    'closeCaisse.errPdf': 'Erro ao gerar o PDF',
    'closeCaisse.errConfirmCb': 'Confirme os pagamentos no cartão antes de fechar o caixa',
    'closeCaisse.confirmEcart': 'Atenção: foi detectada uma diferença de {{ecart}}.\n\nTotal teórico: {{theorique}}\nTotal contado: {{compte}}\n\nDeseja continuar?',
    'closeCaisse.closeSuccess': 'Caixa {{magasin}} fechado com sucesso.',
    'closeCaisse.errClose': 'Erro ao fechar o caixa',
    'closeCaisse.backToDashboard': 'Voltar ao painel',
    'closeCaisse.journee': 'Dia {{date}}',
    'closeCaisse.openedBy': 'aberto por {{name}}',
    'closeCaisse.refresh': 'Atualizar',
    'closeCaisse.summaryTitle': 'Resumo do caixa',
    'closeCaisse.activitySummary': 'Atividade da loja {{magasin}} — {{ops}} operação(ões) ({{pos}} vendas POS, {{acomptes}} adiantamentos).',
    'closeCaisse.fondOuverture': 'Fundo de abertura',
    'closeCaisse.ventesEspeces': 'Vendas em dinheiro',
    'closeCaisse.ventesCb': 'Vendas no cartão',
    'closeCaisse.paiementsStripe': 'Pagamentos Stripe',
    'closeCaisse.acomptes': 'Adiantamentos',
    'closeCaisse.retraits': 'Retiradas',
    'closeCaisse.totalTheorique': 'Total teórico',
    'closeCaisse.totalVentes': 'Total de vendas: {{montant}}',
    'closeCaisse.activiteVendeur': 'Atividade por vendedor',
    'closeCaisse.colVendeur': 'Vendedor',
    'closeCaisse.colOps': 'Ops',
    'closeCaisse.colEspeces': 'Dinheiro',
    'closeCaisse.colCb': 'Cartão',
    'closeCaisse.comptageEspeces': 'Contagem de dinheiro',
    'closeCaisse.comptageSubtitle': 'Cédulas e moedas com detalhamento visual para o fechamento.',
    'closeCaisse.totalCompte': 'Total contado',
    'closeCaisse.ecart': 'Diferença',
    'closeCaisse.ecartImportant': 'Diferença significativa detectada',
    'closeCaisse.infosComplementaires': 'Informações complementares',
    'closeCaisse.montantCoffreLabel': 'Valor depositado no cofre (EUR)',
    'closeCaisse.montantCoffreHint': 'Valor em dinheiro depositado no cofre.',
    'closeCaisse.cbConfirmLabel': 'Confirmei os pagamentos no cartão',
    'closeCaisse.cbConfirmHint': 'Verifique se todos os pagamentos no cartão foram recebidos no terminal.',
    'closeCaisse.imprimerRapport': 'Imprimir o relatório',
    'closeCaisse.validerCaisse': 'Validar o caixa',
    'closeCaisse.onlyAdmin': 'Somente um administrador pode validar o fechamento do caixa',
    'paiements.title': 'Pagamentos online',
    'paiements.proofsToValidate': '{{count}} comprovante(s) a validar',
    'paiements.pendingCount': '{{count}} pendente(s)',
    'paiements.tabSumup': 'Pagamentos SumUp ({{count}})',
    'paiements.tabProofs': 'Comprovantes de pagamento ({{count}})',
    'paiements.noProof': 'Nenhum comprovante de pagamento',
    'paiements.orderDefault': 'Pedido',
    'paiements.proofValidated': 'Validado',
    'paiements.proofPendingValidation': 'Aguardando validação',
    'paiements.totalLabel': 'Total: ',
    'paiements.sentLabel': 'Enviado: ',
    'paiements.byLabel': 'Por: ',
    'paiements.validatedByLabel': 'Validado por: ',
    'paiements.viewCapture': 'Ver captura',
    'paiements.validatePayment': 'Validar pagamento',
    'paiements.reject': 'Recusar',
    'paiements.confirmOrder': 'Confirmar pedido',
    'paiements.filterAll': 'Todos',
    'paiements.filterPending': 'Pendentes',
    'paiements.filterConfirmed': 'Confirmados',
    'paiements.filterCancelled': 'Cancelados',
    'paiements.noPayment': 'Nenhum pagamento',
    'paiements.amountLabel': 'Valor: ',
    'paiements.refLabel': 'Ref.: ',
    'paiements.dateLabel': 'Data: ',
    'paiements.ticketPdf': 'Recibo PDF',
    'paiements.validate': 'Validar',
    'paiements.cancel': 'Cancelar',
    'paiements.statusPaidApplied': 'Confirmado',
    'paiements.statusPaidPending': 'Pendente',
    'paiements.statusPending': 'Em andamento',
    'paiements.statusCancelled': 'Cancelado',
    'paiements.orderRepair': 'Reparo {{ref}}',
    'paiements.orderBoutique': 'Pedido da loja',
    'paiements.alertConfirmed': 'Pagamento confirmado e aplicado!',
    'paiements.errorConfirm': 'Erro ao confirmar',
    'paiements.confirmCancel': 'Cancelar este pagamento?',
    'paiements.error': 'Erro',
    'paiements.errorTicket': 'Erro ao baixar o recibo',
    'paiements.confirmValidateProof': 'Validar este comprovante de pagamento?',
    'paiements.alertProofValidated': 'Pagamento validado!',
    'paiements.confirmRejectProof': 'Recusar este comprovante de pagamento?',
    'paiements.confirmConfirmOrder': 'Confirmar este pedido?',
    'paiements.alertOrderConfirmed': 'Pedido confirmado!',
    'repairForm.deviceNotFound': 'Aparelho não encontrado',
    'repairForm.selectMagasinFirst': 'Escolha primeiro a loja responsável por este reparo.',
    'repairForm.saveError': 'Erro ao salvar',
    'repairForm.conversionFromCommande': 'Conversão a partir de pedido',
    'repairForm.prefillNotice': 'Informações pré-preenchidas · sinais ({{amount}}) transferidos na finalização.',
    'repairForm.sectionMagasin': 'Loja',
    'repairForm.magasinLabel': 'Loja responsável *',
    'repairForm.selectMagasinOption': '— Selecione uma loja —',
    'repairForm.sectionForcedEntry': 'Registro forçado',
    'repairForm.forcedEntryHint': 'Para uma entrega esquecida: registre o reparo com a data real de entrega (não a data de hoje).',
    'repairForm.useBackdateLabel': 'Usar uma data de entrega anterior',
    'repairForm.realDepotDateTime': 'Data e hora reais da entrega',
    'repairForm.sectionClient': 'Cliente',
    'repairForm.clientName': 'Nome do cliente *',
    'repairForm.phone': 'Telefone *',
    'repairForm.email': 'E-mail',
    'repairForm.address': 'Endereço',
    'repairForm.sectionDevice': 'Aparelho',
    'repairForm.brand': 'Marca *',
    'repairForm.model': 'Modelo *',
    'repairForm.problem': 'Problema',
    'repairForm.technician': 'Técnico',
    'repairForm.selectOption': '— Selecionar —',
    'repairForm.imeiSerial': 'IMEI / N.º de série',
    'repairForm.deviceLock': 'Código de bloqueio',
    'repairForm.sectionParts': 'Peças',
    'repairForm.defectivePartsHint': 'Peças não funcionais na recepção',
    'repairForm.phoneDoesntTurnOn': 'O cel. não liga',
    'repairForm.sectionStockParts': 'Peças em estoque (opcional)',
    'repairForm.stockPartsHint': 'Se a peça estiver no estoque da loja, será baixada na criação e o preço do reparo recalculado com base nos preços de catálogo. Caso contrário, informe um preço manual abaixo (orçamento teórico).',
    'repairForm.stockPartsTotal': 'Total de peças em estoque: {{amount}} — aplicado na criação se disponível.',
    'repairForm.sectionPricing': 'Preços',
    'repairForm.priceRepair': 'Preço do reparo (€)',
    'repairForm.theoreticalQuote': '— orçamento teórico',
    'repairForm.priceDiagnostic': 'Preço do diagnóstico (€)',
    'repairForm.receptionNotes': 'Notas de recepção',
    'repairForm.sectionPhotos': 'Fotos',
    'repairForm.addPhoto': 'Adicionar',
    'repairForm.cancel': 'Cancelar',
    'repairForm.save': 'Salvar',
    'repairForm.createRepair': 'Criar reparo',
    'repairForm.parts.speaker': 'Alto-falante',
    'repairForm.parts.lcd': 'Tela',
    'repairForm.parts.front_cam': 'Câmera frontal',
    'repairForm.parts.back_cam': 'Câmera traseira',
    'repairForm.parts.microphone': 'Microfone',
    'repairForm.parts.fingerprint': 'Impressão digital',
    'repairForm.parts.home_button': 'Botão início',
    'repairForm.parts.volume_button': 'Volume',
    'repairForm.parts.power_button': 'Liga/Desliga',
    'repairForm.parts.signal_carrier': 'Sinal',
    'repairForm.parts.battery': 'Bateria',
    'repairForm.parts.wifi_bt': 'Wi-Fi/Bluetooth',
    'repairForm.parts.ear_speaker': 'Auricular',
    'repairForm.parts.charging_port': 'Porta de carga',
    'labels.barcodeAuto': 'EAN13 será gerado automaticamente',
    'labels.allowPopups': 'Permita os pop-ups para imprimir.',
    'labels.selectAtLeastOne': 'Selecione pelo menos um produto',
    'labels.errorGenerate': 'Erro ao gerar etiquetas',
    'labels.infoNoEan': 'Info: {{count}} item(ns) sem EAN — EAN13 interno gerado automaticamente. Total: {{total}} etiqueta(s).',
    'labels.jobCreated': 'Trabalho de impressão criado ({{count}} etiquetas).\nID: {{id}}...\nO agente Bixolon vai buscar este lote.',
    'labels.jobNoEan': '\nNota: {{count}} sem EAN (gerado automaticamente).',
    'labels.errorBatch': 'Erro de impressão em lote',
    'labels.generating': 'Gerando...',
    'labels.generatePdf': 'Gerar PDF ({{count}})',
    'labels.previewPdf': 'Pré-visualização PDF ({{count}})',
    'labels.printBixolon': 'Imprimir Bixolon ({{count}})',
    'labels.clear': 'Limpar',
    'labels.format': 'Formato',
    'labels.formatBixolon': 'Bixolon 50 × 30 mm (térmica)',
    'labels.formatA4': 'Folha A4 (antiga)',
    'labels.pageTitle': 'Etiquetas de produtos',
    'labels.pageSubtitle': 'Etiquetas de produtos configuráveis',
    'labels.config': 'Config',
    'labels.searchPlaceholder': 'Buscar um produto...',
    'labels.boutique': 'Loja',
    'labels.depot': 'Depósito',
    'labels.deselectAll': 'Desmarcar tudo',
    'labels.colProduct': 'Produto',
    'labels.colPrice': 'Preço',
    'labels.colBoutiqueShort': 'Loja',
    'labels.colQtyToPrint': 'Qtd. a imprimir',
    'labels.noProduct': 'Nenhum produto',
    'labels.autoShort': 'auto',
    'labels.previewTitle': 'Pré-visualização da etiqueta',
    'labels.refLabel': 'Ref.:',
    'labels.selectedProducts': 'Produtos selecionados',
    'labels.totalLabels': 'Total de etiquetas',
    'labels.autoGenAtPdf': 'Gerado automaticamente no PDF',
    'labels.selectToPreview': 'Selecione um produto para pré-visualizar',
    'labels.batchVeryLarge': 'Lote muito grande',
    'labels.batchConfirmTitle': 'Confirmar o lote grande',
    'labels.confirmBodyPrefix': 'Você vai gerar',
    'labels.confirmBodySuffix': 'etiquetas.',
    'labels.estRoll': '≈ {{meters}} m de rolo (50×30mm)',
    'labels.estTime': '≈ {{minutes}} min de impressão (~1,5 s/etiqueta)',
    'labels.cancel': 'Cancelar',
    'labels.confirmAnyway': 'Confirmar mesmo assim',
    'labels.continue': 'Continuar',
    'rep.status.awaitingDeposit': 'Aguardando entrega',
    'rep.status.received': 'Recebido',
    'rep.status.inProgress': 'Em andamento',
    'rep.status.awaitingParts': 'Aguardando peças',
    'rep.status.completed': 'Concluído',
    'rep.status.notRepairable': 'Não reparável',
    'rep.status.delivered': 'Entregue',
    'rep.status.refused': 'Recusado',
    'rep.payCash': 'Dinheiro',
    'rep.payCard': 'Cartão',
    'rep.payTransfer': 'Transferência',
    'rep.payCheck': 'Cheque',
    'rep.accept': 'Aceitar',
    'rep.addError': 'Erro ao adicionar',
    'rep.adminOnlyStatus': 'Apenas um administrador pode alterar este status.',
    'rep.allowPopups': 'Permita os pop-ups para imprimir.',
    'rep.chatTitle': 'Chat de reparo {{ref}}',
    'rep.confirmArrivalAsk': 'Confirmar o recebimento do aparelho {{ref}} na loja?',
    'rep.confirmArrivalDone': 'Aparelho confirmado! O reparo agora está ativo.',
    'rep.confirmArrivalError': 'Erro ao confirmar',
    'rep.created': 'Criado',
    'rep.currentStatus': 'Status atual:',
    'rep.deleteError': 'Erro ao excluir',
    'rep.deleteRecordAsk': 'Excluir este registro?',
    'rep.deleteStatusAsk': 'Excluir o status "{{name}}"?',
    'rep.depositAmountEuro': 'Valor do sinal (€)',
    'rep.diagnosticPaid': 'Diagnóstico pago',
    'rep.diagnosticRemaining': 'Diagnóstico: {{amount}} restante',
    'rep.downloadError': 'Erro ao baixar',
    'rep.error': 'Erro',
    'rep.invalidAmount': 'Valor inválido',
    'rep.newStatus': 'Novo status',
    'rep.noDeposits': 'Nenhum sinal pago',
    'rep.noOnlineRequests': 'Nenhuma solicitação on-line pendente',
    'rep.onlineRequests': 'Solicitações on-line ({{count}})',
    'rep.or': 'ou',
    'rep.pointAtTicketQr': 'Aponte para o QR code do ticket',
    'rep.printAcompteError': 'Erro ao imprimir o comprovante de sinal',
    'rep.qrPrintHint': 'Escaneie para acompanhar seu reparo',
    'rep.qrSearchPlaceholder': 'Ex.: REM0094',
    'rep.qrTrackingHint': 'O cliente escaneia este QR code para acompanhar o reparo em tempo real',
    'rep.qrTrackingTitle': 'QR code de acompanhamento',
    'rep.reference': 'Referência:',
    'rep.repair': 'Reparo',
    'rep.scanOrEnterRef': 'Escaneie um QR code ou digite a referência',
    'rep.scanWithCamera': 'Escanear com a câmera',
    'rep.searchRepair': 'Buscar um reparo',
    'rep.statusManagement': 'Gestão de status',
    'rep.ticket': 'Comprovante',
    'rep.updateError': 'Erro ao atualizar',
    'rep.bulkNoteSentSingular': 'Nota enviada para {{count}} processo{{skip}}.',
    'rep.bulkNoteSentPlural': 'Nota enviada para {{count}} processos{{skip}}.',
    'rep.bulkNoteSkippedSingular': '({{count}} ignorado)',
    'rep.bulkNoteSkippedPlural': '({{count}} ignorados)',
    'devisDepl.title': 'Orçamentos a domicílio',
    'devisDepl.subtitle': 'Gestão de orçamentos para reparos a domicílio',
    'devisDepl.newDevis': 'Novo orçamento',
    'devisDepl.exportCsv': 'Exportar CSV',
    'devisDepl.remindBtn': 'Lembrar ({{count}})',
    'devisDepl.sending': 'Enviando...',
    'devisDepl.send': 'Enviar',
    'devisDepl.cancel': 'Cancelar',
    'devisDepl.errGeneric': 'Erro',
    'devisDepl.confirmSendReminders': 'Enviar um lembrete para {{count}} cliente(s) com orçamentos pendentes há mais de 3 dias?',
    'devisDepl.remindersSent': '{{count}} lembrete(s) enviado(s)!',
    'devisDepl.sentByEmail': 'Orçamento enviado por e-mail!',
    'devisDepl.errSend': 'Erro de envio',
    'devisDepl.confirmDelete': 'Excluir este orçamento?',
    'devisDepl.searchPlaceholder': 'Buscar por ref, nome, e-mail...',
    'devisDepl.noResults': 'Nenhum resultado',
    'devisDepl.empty': 'Nenhum orçamento criado',
    'devisDepl.travelFeeLabel': 'Taxa de deslocamento',
    'devisDepl.invalidAmount': 'Valor inválido',
    'devisDepl.errPayment': 'Erro de pagamento',
    'devisDepl.confirmStaffAccept': 'Validar este orçamento? Serão criados um pedido de compra e uma fatura.',
    'devisDepl.errValidation': 'Erro de validação',
    'devisDepl.reminderSent': 'Lembrete enviado',
    'devisDepl.errSendReminder': 'Erro ao enviar lembrete',
    'devisDepl.confirmValidateBon': 'Validar o pedido de compra?',
    'devisDepl.errSendFacture': 'Erro ao enviar fatura',
    'devisDepl.confirmDetach': 'Desvincular este orçamento do reparo {{ref}}?',
    'devisDepl.status.pending': 'Pendente',
    'devisDepl.status.accepted': 'Aceito',
    'devisDepl.status.refused': 'Recusado',
    'devisDepl.status.depositPaid': 'Sinal pago',
    'devisDepl.status.paid': 'Pago',
    'devisDepl.stats.total': 'Total',
    'devisDepl.stats.pending': 'Pendente',
    'devisDepl.stats.accepted': 'Aceitos',
    'devisDepl.stats.refused': 'Recusados',
    'devisDepl.stats.revenue': 'Receita',
    'devisDepl.filter.all': 'Todos os status',
    'devisDepl.requests.title': 'Solicitações de orçamento recebidas',
    'devisDepl.requests.newCountSingular': '{{count}} nova',
    'devisDepl.requests.newCountPlural': '{{count}} novas',
    'devisDepl.requests.defaultTitle': 'Solicitação de orçamento',
    'devisDepl.requests.statusNew': 'Novo',
    'devisDepl.requests.statusInProgress': 'Em andamento',
    'devisDepl.requests.statusRefused': 'Recusado',
    'devisDepl.requests.statusTreated': 'Tratado',
    'devisDepl.requests.client': 'Cliente',
    'devisDepl.requests.addressLabel': 'Endereço',
    'devisDepl.requests.createDevis': 'Criar orçamento',
    'devisDepl.requests.markTreated': 'Tratado',
    'devisDepl.requests.refuse': 'Recusar',
    'devisDepl.requests.refuseMotifLabel': 'Motivo da recusa',
    'devisDepl.requests.refuseMotifPlaceholder': 'Motivo da recusa (opcional)...',
    'devisDepl.requests.confirmRefuse': 'Confirmar recusa',
    'devisDepl.requests.refuseMotifShownLabel': 'Motivo da recusa:',
    'devisDepl.sumup.title': 'Solicitações de link SumUp',
    'devisDepl.sumup.pendingCount': '{{count}} pendente(s)',
    'devisDepl.sumup.enterLinkAlert': 'Insira o link do SumUp',
    'devisDepl.sumup.linkSentAlert': 'Link do SumUp enviado ao cliente por e-mail!',
    'devisDepl.sumup.linkPlaceholder': 'Cole o link do SumUp aqui...',
    'devisDepl.chart.title': 'Atividade dos últimos 30 dias',
    'devisDepl.chart.accepted': 'Aceitos',
    'devisDepl.chart.pending': 'Pendente',
    'devisDepl.chart.refused': 'Recusados',
    'devisDepl.chart.noData': 'Sem dados para este período',
    'devisDepl.form.editTitle': 'Editar orçamento',
    'devisDepl.form.newTitle': 'Novo orçamento',
    'devisDepl.form.clientName': 'Nome do cliente *',
    'devisDepl.form.searchPlaceholder': 'Digite para buscar...',
    'devisDepl.form.phone': 'Telefone',
    'devisDepl.form.email': 'E-mail *',
    'devisDepl.form.emailPlaceholder': 'email@exemplo.com',
    'devisDepl.form.address': 'Endereço',
    'devisDepl.form.addressPlaceholder': 'Endereço do cliente',
    'devisDepl.form.descriptionLabel': 'Descrição do reparo',
    'devisDepl.form.descriptionPlaceholder': 'Descrição do trabalho a realizar...',
    'devisDepl.form.lines': 'Itens do orçamento',
    'devisDepl.form.addLine': 'Adicionar',
    'devisDepl.form.designation': 'Descrição',
    'devisDepl.form.price': 'Preço',
    'devisDepl.form.travelFee': 'Taxa de deslocamento ({{amount}})',
    'devisDepl.form.acceptOnline': 'Aceitar pagamento online (SumUp)',
    'devisDepl.form.acceptOnlineHint': 'O cliente poderá solicitar um link de pagamento SumUp',
    'devisDepl.form.total': 'TOTAL',
    'devisDepl.form.submitEdit': 'Atualizar',
    'devisDepl.form.submitCreate': 'Criar orçamento',
    'devisDepl.form.nameEmailRequired': 'Nome e e-mail do cliente são obrigatórios',
    'devisDepl.form.atLeastOneLine': 'Adicione pelo menos um item com descrição e preço',
    'devisDepl.detail.phone': 'Tel.:',
    'devisDepl.detail.address': 'Endereço:',
    'devisDepl.detail.purchaseOrder': 'Pedido de compra:',
    'devisDepl.detail.invoice': 'Fatura:',
    'devisDepl.detail.emailSentOn': 'E-mail enviado em {{date}}',
    'devisDepl.detail.reminderSentOn': 'Lembrete enviado em {{date}}',
    'devisDepl.table.designation': 'Descrição',
    'devisDepl.table.qty': 'Qtd',
    'devisDepl.table.price': 'Preço',
    'devisDepl.table.total': 'Total',
    'devisDepl.actions.validateDevis': 'Validar orçamento',
    'devisDepl.actions.sendByEmail': 'Enviar orçamento por e-mail',
    'devisDepl.actions.remindAcceptance': 'Cobrar aceitação',
    'devisDepl.actions.edit': 'Editar',
    'devisDepl.actions.validateBon': 'Validar pedido de compra',
    'devisDepl.actions.bonValidated': 'Pedido validado',
    'devisDepl.actions.remindPayment': 'Cobrar pagamento',
    'devisDepl.actions.pdfDevis': 'PDF Orçamento',
    'devisDepl.actions.pdfBon': 'PDF Pedido de compra',
    'devisDepl.actions.pdfFacture': 'PDF Fatura',
    'devisDepl.actions.sendFactureEmail': 'Enviar fatura por e-mail',
    'devisDepl.actions.registerPayment': 'Registrar pagamento',
    'devisDepl.actions.delete': 'Excluir',
    'devisDepl.actions.linkedTo': 'Vinculado a {{ref}}',
    'devisDepl.actions.attachToRepair': 'Vincular a reparo',
    'devisDepl.payment.title': 'Registrar um pagamento',
    'devisDepl.payment.devisLabel': 'Orçamento:',
    'devisDepl.payment.totalLabel': 'Total:',
    'devisDepl.payment.methodLabel': 'Forma de pagamento',
    'devisDepl.payment.cash': 'Dinheiro',
    'devisDepl.payment.card': 'Cartão',
    'devisDepl.payment.transfer': 'Transferência',
    'devisDepl.payment.mixed': 'Misto',
    'devisDepl.payment.amount': 'Valor',
    'devisDepl.payment.noteLabel': 'Nota (opcional)',
    'devisDepl.payment.notePlaceholder': 'Ex.: sinal, saldo...',
    'devisDepl.payment.submit': 'Confirmar pagamento',
    'reviews.ratingFallback': 'Nossos clientes nos avaliam no Google',
    'reviews.subtitle': 'Veja o que nossos clientes dizem no Google e compartilhe sua experiência.',
    'reviews.readCta': 'Ver nossas avaliações no Google',
    'reviews.writeCta': 'Deixar uma avaliação',
    'acompteStart.title': 'Sinal do seu orçamento',
    'acompteStart.subtitle': 'Resurrection Mobile · pagamento seguro com SumUp',
    'acompteStart.loading': 'Preparando o pagamento…',
    'acompteStart.redirecting': 'Redirecionando para a página de pagamento',
    'acompteStart.clickHere': 'Clique aqui se nada acontecer.',
    'acompteStart.paid': 'Este sinal já foi pago. Obrigado! Seu pedido está sendo preparado.',
    'acompteStart.orderRef': 'Pedido {{ref}}',
    'acompteStart.errTitle': 'Pagamento on-line temporariamente indisponível',
    'acompteStart.retry': 'Tentar novamente',
    'acompteStart.whatsappPay': 'Pagar pelo WhatsApp / fale conosco',
    'acompteStart.inStore': 'O sinal também pode ser pago diretamente na loja.',
    'acompteStart.footer': 'Após o pagamento, seu pedido da peça é registrado automaticamente e um recibo é enviado para você por e-mail.',
    'acompteStart.backToSite': 'Voltar ao site',
    'acompteStart.errLinkUnavailable': 'Link de pagamento indisponível.',
    'acompteStart.errOnlineUnavailable': 'O pagamento on-line está temporariamente indisponível.',
    'acompteStart.waMessage': 'Olá, gostaria de pagar o sinal do meu orçamento ({{id}}).',
    'emailVerif.loadingTitle': 'Verificando...',
    'emailVerif.loadingSub': 'Aguarde, por favor',
    'emailVerif.successTitle': 'Conta ativada!',
    'emailVerif.successDefault': 'E-mail verificado com sucesso!',
    'emailVerif.login': 'Entrar',
    'emailVerif.errorTitle': 'Erro de verificação',
    'emailVerif.errorDefault': 'Erro de verificação',
    'emailVerif.invalidLink': 'Link de verificação inválido.',
    'emailVerif.backLogin': 'Voltar ao login',
    'emailVerif.expiredTitle': 'Link expirado',
    'emailVerif.expiredDefault': 'Este link expirou.',
    'emailVerif.backLoginResend': 'Voltar ao login (reenviar e-mail)',
    'paySuccess.noPaymentToVerify': 'Nenhum pagamento a verificar',
    'paySuccess.statusCheckFailed': 'Não foi possível verificar o status. O pagamento será processado automaticamente.',
    'paySuccess.verificationError': 'Erro ao verificar o pagamento',
    'paySuccess.completedTitle': 'Pagamento realizado!',
    'paySuccess.completedDesc': 'Seu pagamento foi confirmado e aplicado ao seu processo.',
    'paySuccess.failedTitle': 'Pagamento falhou',
    'paySuccess.failedDesc': 'O pagamento não pôde ser processado. Tente novamente.',
    'paySuccess.pendingTitle': 'Pagamento em processamento',
    'paySuccess.pendingDesc': 'Seu pagamento está sendo verificado. Ele será aplicado automaticamente.',
    'paySuccess.verifying': 'Verificando o pagamento...',
    'paySuccess.errorTitle': 'Erro',
    'paySuccess.amountLabel': 'Valor:',
    'paySuccess.repairLabel': 'Reparo:',
    'paySuccess.orderLabel': 'Pedido:',
    'paySuccess.referenceLabel': 'Referência:',
    'paySuccess.noInfo': 'Nenhuma informação de pagamento disponível.',
    'paySuccess.backToSpace': 'Voltar ao meu espaço',
    'devisChat.errStart': 'Não foi possível iniciar o chat. Tente novamente.',
    'devisChat.errSend': 'Erro ao enviar',
    'devisChat.errNetwork': 'Erro de rede',
    'devisChat.hint': 'Peça seu orçamento por e-mail',
    'devisChat.fabAria': 'Solicitar um orçamento',
    'devisChat.fabLabel': 'Orçamento grátis',
    'devisChat.panelTitle': 'Orçamento R.E.Mobiles',
    'devisChat.panelSubtitle': 'Envio por e-mail após a validação',
    'devisChat.close': 'Fechar',
    'devisChat.connecting': 'Conectando…',
    'devisChat.inputPlaceholder': 'Ex. tela iPhone 13…',
    'register.emailRequired': 'O e-mail é obrigatório para criar uma conta.',
    'register.passwordMinLength': 'A senha deve conter pelo menos 4 caracteres.',
    'register.passwordMismatch': 'As senhas não coincidem.',
    'register.registerError': 'Erro durante o cadastro',
    'register.verifyEmailTitle': 'Verifique seu e-mail!',
    'register.confirmationSentTo': 'Um e-mail de confirmação foi enviado para:',
    'register.activateHint': 'Clique no link do e-mail para ativar sua conta. Verifique também o spam se não o encontrar.',
    'register.goToLogin': 'Ir para o login',
    'register.clientSubtitle': 'Acesse o acompanhamento dos seus reparos',
    'register.namePlaceholder': 'João Silva',
    'register.emailPlaceholder': 'email@exemplo.com',
    'register.emailHint': 'Um e-mail de confirmação será enviado para ativar sua conta',
    'register.addressPlaceholder': 'Rua Exemplo, 123',
    'register.password': 'Senha',
    'register.confirmPassword': 'Confirmar senha',
    'register.referralCode': 'Código de indicação (opcional)',
    'register.referredBy': 'Indicado por {{nom}}',
    'register.invalidReferral': 'Código de indicação inválido',
    'register.termsNotice': 'Ao criar uma conta, você aceita nossos termos de uso',
    'login.googleDisabled': 'O login com Google foi desativado. Use seu usuário e senha.',
    'login.invalid2FA': 'Código 2FA inválido',
    'login.tabStaff': 'Equipe',
    'login.tabClient': 'Cliente',
    'login.tabBusiness': 'Empresa',
    'login.frenchGuiana': 'Guiana Francesa',
    'login.emailNotVerifiedTitle': 'E-mail não verificado',
    'login.emailNotVerifiedDesc': 'Você precisa confirmar seu e-mail antes de entrar.',
    'login.emailResent': 'E-mail reenviado! Verifique sua caixa de entrada.',
    'login.sending': 'Enviando...',
    'login.resendVerification': 'Reenviar e-mail de confirmação',
    'login.back': 'Voltar',
    'login.twoFATitle': 'Verificação 2FA',
    'login.twoFASubtitle': 'Digite o código do seu aplicativo',
    'login.verifying': 'Verificando...',
    'login.verify': 'Verificar',
    'login.passwordPlaceholder': 'Sua senha',
    'login.allRightsReserved': 'Todos os direitos reservados.',
    'acompteSuccess.errorIncompleteLink': 'Link de pagamento incompleto.',
    'acompteSuccess.errorCannotConfirm': 'Não foi possível confirmar o pagamento no momento.',
    'acompteSuccess.whatsappMessage': 'Olá, paguei o sinal do meu orçamento (ref. {{ref}}). Podem confirmar o meu pedido?',
    'acompteSuccess.whatsappDefault': 'Fale conosco no WhatsApp',
    'acompteSuccess.errorHint': 'Se o seu pagamento foi de fato debitado, o seu pedido será registrado automaticamente nos próximos minutos e você receberá um e-mail de confirmação.',
    'acompteSuccess.appliedTitle': 'Sinal recebido',
    'acompteSuccess.orderRegisteredLead': 'Obrigado. O seu pedido de peça',
    'acompteSuccess.orderRegisteredTail': 'está registrado. Um recibo foi enviado para você por e-mail; você receberá o número de rastreamento assim que for despachado.',
    'acompteSuccess.staffPendingTitle': 'Pagamento recebido',
    'acompteSuccess.staffPendingBody': 'O seu sinal foi registrado corretamente na SumUp. A nossa equipe está finalizando o seu pedido manualmente e confirmará por e-mail em breve.',
    'acompteSuccess.whatsappQuestion': 'Uma dúvida? WhatsApp',
    'acompteSuccess.sumupFailedTitle': 'Pagamento não concluído',
    'acompteSuccess.sumupFailedBody': 'A SumUp não confirmou o pagamento ({{status}}). Você pode tentar novamente pelo link do seu e-mail de orçamento, ou entrar em contato conosco.',
    'acompteSuccess.timedOutTitle': 'Confirmação em andamento',
    'acompteSuccess.timedOutBody': 'A SumUp ainda não confirmou o seu pagamento. Sem preocupação: se o débito ocorreu, o seu pedido será criado automaticamente nos próximos minutos e você receberá um e-mail de confirmação. Você pode fechar esta página.',
    'acompteSuccess.recheckNow': 'Verificar novamente agora',
    'acompteSuccess.whatsappProof': 'Enviar o comprovante de pagamento no WhatsApp',
    'acompteSuccess.verifyingTitle': 'Verificando o pagamento…',
    'acompteSuccess.verifyingBody': 'Aguarde alguns segundos, por favor.',
    'acompteSuccess.backHome': 'Voltar ao início',
    'b2bDashboard.acceptRefuse': 'Aceitar / Recusar',
    'b2bDashboard.actions': 'Ações',
    'b2bDashboard.addNotePlaceholder': 'Adicionar uma nota sobre este reparo...',
    'b2bDashboard.addPhoto': '+ Adicionar',
    'b2bDashboard.additionalInfoPlaceholder': 'Informações complementares...',
    'b2bDashboard.additionalNotes': 'Notas adicionais',
    'b2bDashboard.addressOptional': 'Endereço (opcional)',
    'b2bDashboard.addressPlaceholder': 'Endereço para deslocamento se necessário',
    'b2bDashboard.alertDescribeRequest': 'Por favor, descreva sua solicitação',
    'b2bDashboard.amount': 'Valor',
    'b2bDashboard.awaitingReceptionStore': 'Aguardando recebimento na loja',
    'b2bDashboard.back': 'Voltar',
    'b2bDashboard.backGlass': 'Vidro traseiro',
    'b2bDashboard.backGlassBroken': 'Vidro traseiro quebrado',
    'b2bDashboard.backGlassIntact': 'Vidro traseiro intacto',
    'b2bDashboard.brandModelRequired': 'Marca e modelo são obrigatórios',
    'b2bDashboard.broken': 'Quebrado',
    'b2bDashboard.changePassword': 'Alterar senha',
    'b2bDashboard.chat': 'Conversar',
    'b2bDashboard.clear': 'Limpar',
    'b2bDashboard.clickNewRequestHint': 'Clique em "Nova solicitação" para criar uma',
    'b2bDashboard.clickToAddPhotos': 'Clique para adicionar fotos',
    'b2bDashboard.code': 'Código',
    'b2bDashboard.code6Digits': 'Código de 6 dígitos',
    'b2bDashboard.codeDigitsLetters': 'Código (números/letras)',
    'b2bDashboard.codeValidatedSuccess': 'Código validado com sucesso!',
    'b2bDashboard.confirmOrderEmailPre': 'Um pedido de compra com um código de confirmação foi enviado para o seu e-mail. Digite este código na seção ',
    'b2bDashboard.confirmOrderEmailPost': ' para validar seu pedido.',
    'b2bDashboard.createdOn': 'Criada em',
    'b2bDashboard.customerProvidesPart': 'Eu forneço a peça',
    'b2bDashboard.date': 'Data',
    'b2bDashboard.delivery': 'Entrega',
    'b2bDashboard.delivery.pickup': 'Retirada',
    'b2bDashboard.delivery.postal': 'Envio postal',
    'b2bDashboard.delivery.store': 'Na loja',
    'b2bDashboard.describeProblemPlaceholder': 'Descreva o problema...',
    'b2bDashboard.designation': 'Descrição',
    'b2bDashboard.device': 'Aparelho',
    'b2bDashboard.devisStatus.accepted': 'Aceito',
    'b2bDashboard.devisStatus.depositPaid': 'Sinal pago',
    'b2bDashboard.devisStatus.paid': 'Pago',
    'b2bDashboard.devisStatus.pending': 'Pendente',
    'b2bDashboard.devisStatus.refused': 'Recusado',
    'b2bDashboard.diagRef': 'Ref. diag.:',
    'b2bDashboard.documentsWord': 'Documentos',
    'b2bDashboard.downloadError': 'Erro ao baixar',
    'b2bDashboard.downloadPdf': 'Baixar PDF',
    'b2bDashboard.enter6DigitCode': 'Digite o código de 6 dígitos',
    'b2bDashboard.enterCodePerOrder': 'Digite o código recebido por e-mail para validar cada pedido de compra.',
    'b2bDashboard.enterCodeToValidate': 'Digite o código recebido por e-mail para validar seu pedido.',
    'b2bDashboard.enterPinPlaceholder': 'Digite o código PIN, senha...',
    'b2bDashboard.enterValidationCode': 'Por favor, digite o código de validação',
    'b2bDashboard.error': 'Erro',
    'b2bDashboard.filter.all': 'Todas',
    'b2bDashboard.history': 'Histórico',
    'b2bDashboard.imeiSerial': 'IMEI / N.º de série',
    'b2bDashboard.imeiSerialShort': 'IMEI / Série',
    'b2bDashboard.incorrectCode': 'Código incorreto',
    'b2bDashboard.invoiceLabel': 'Fatura:',
    'b2bDashboard.invoiceType.combined': 'Comb.',
    'b2bDashboard.invoiceType.diag': 'Diag',
    'b2bDashboard.invoiceType.repair': 'Reparo',
    'b2bDashboard.invoices': 'Faturas',
    'b2bDashboard.invoicesAppearWhenPriced': 'As faturas aparecem assim que o preço for definido pela R.E.Mobiles',
    'b2bDashboard.latePayment': 'ATRASO NO PAGAMENTO - {{days}} dias',
    'b2bDashboard.lock': 'Bloqueio',
    'b2bDashboard.lockCode': 'Código de bloqueio',
    'b2bDashboard.mostRecent': 'Mais recentes',
    'b2bDashboard.nav.documents': 'Orçamentos / Faturas',
    'b2bDashboard.nav.quoteRequest': 'Solicitar um orçamento',
    'b2bDashboard.newQuoteRequest': 'Nova solicitação de orçamento',
    'b2bDashboard.newRequest': 'Nova solicitação',
    'b2bDashboard.noInvoiceAvailable': 'Nenhuma fatura disponível',
    'b2bDashboard.noPhoto': 'Nenhuma foto',
    'b2bDashboard.noPosInvoice': 'Nenhuma nota de compra',
    'b2bDashboard.noQuoteRequest': 'Nenhuma solicitação de orçamento',
    'b2bDashboard.noTravelQuote': 'Nenhum orçamento de deslocamento',
    'b2bDashboard.nonFunctionalParts': 'Peças não funcionais',
    'b2bDashboard.noteSaveError': 'Erro ao salvar a nota',
    'b2bDashboard.notes': 'Notas',
    'b2bDashboard.oldest': 'Mais antigas',
    'b2bDashboard.optional': 'Opcional',
    'b2bDashboard.orderValidated': 'Pedido de compra validado',
    'b2bDashboard.orderValidatedSuccess': 'Pedido de compra validado!',
    'b2bDashboard.orderValidationCode': 'Código de validação do pedido de compra',
    'b2bDashboard.paid': 'Paga',
    'b2bDashboard.paidLabel': 'Pago',
    'b2bDashboard.partProvidedByStore': 'A peça será fornecida pela R.E.Mobiles',
    'b2bDashboard.parts.backCam': 'Câmera traseira',
    'b2bDashboard.parts.backGlass': 'Vidro traseiro',
    'b2bDashboard.parts.battery': 'Bateria',
    'b2bDashboard.parts.chargingPort': 'Porta de carga',
    'b2bDashboard.parts.earSpeaker': 'Auricular',
    'b2bDashboard.parts.fingerprint': 'Impressão digital',
    'b2bDashboard.parts.frontCam': 'Câmera frontal',
    'b2bDashboard.parts.homeButton': 'Botão início',
    'b2bDashboard.parts.lcd': 'Tela',
    'b2bDashboard.parts.microphone': 'Microfone',
    'b2bDashboard.parts.powerButton': 'Botão de energia',
    'b2bDashboard.parts.signal': 'Sinal',
    'b2bDashboard.parts.speaker': 'Alto-falante',
    'b2bDashboard.parts.volumeButton': 'Volume',
    'b2bDashboard.parts.wifiBt': 'Wi-Fi/BT',
    'b2bDashboard.pattern': 'Padrão',
    'b2bDashboard.pay': 'Pagar',
    'b2bDashboard.payRemaining': 'Pagar o restante ({{amount}})',
    'b2bDashboard.paymentCreateError': 'Erro ao criar o pagamento',
    'b2bDashboard.paymentLinkUnavailable': 'Link de pagamento indisponível. Contate a R.E.Mobiles.',
    'b2bDashboard.pdfDownloadError': 'Erro ao baixar o PDF',
    'b2bDashboard.pdfInvoice': 'PDF Fatura',
    'b2bDashboard.pdfPurchaseOrder': 'PDF Pedido',
    'b2bDashboard.pdfQuote': 'PDF Orçamento',
    'b2bDashboard.penaltiesLine': 'Multas: {{penalty}} + Indenização: {{indemnity}}',
    'b2bDashboard.photos': 'Fotos',
    'b2bDashboard.pickupAddress': 'Endereço de retirada',
    'b2bDashboard.pickupAddressPlaceholder': 'Endereço completo onde retirar o telefone...',
    'b2bDashboard.pickupAddressRequired': 'Por favor, digite o endereço de retirada',
    'b2bDashboard.pickupRequested': 'Retirada solicitada - iremos buscar o aparelho',
    'b2bDashboard.posInvoices': 'Notas de compra (POS)',
    'b2bDashboard.price': 'Preço',
    'b2bDashboard.priceCol': 'Preço',
    'b2bDashboard.priceDiagnostic': 'Preço do diagnóstico',
    'b2bDashboard.pricePending': 'Pendente - será definido pela R.E.Mobiles',
    'b2bDashboard.priceRepair': 'Preço do reparo',
    'b2bDashboard.problem': 'Problema',
    'b2bDashboard.problemDescription': 'Problema / Descrição',
    'b2bDashboard.purchaseOrderLabel': 'Pedido de compra:',
    'b2bDashboard.quoteRequestTitle': 'Solicitação de orçamento',
    'b2bDashboard.refusalReason': 'Motivo da recusa:',
    'b2bDashboard.remaining': 'Restante',
    'b2bDashboard.repairAcceptedByStaff': 'Reparo aceito pela equipe',
    'b2bDashboard.repairRefusedByStaff': 'Reparo recusado pela equipe',
    'b2bDashboard.repairTitle': 'Reparo {{ref}}',
    'b2bDashboard.requestDescription': 'Descrição da sua solicitação',
    'b2bDashboard.requestDescriptionPlaceholder': 'Descreva o que deseja: tipo de reparo, quantidade, problemas, etc.',
    'b2bDashboard.requestStatus.inProgress': 'Em andamento',
    'b2bDashboard.requestStatus.new': 'Novo',
    'b2bDashboard.requestStatus.processed': 'Processado',
    'b2bDashboard.requestStatus.refused': 'Recusado',
    'b2bDashboard.retentionInvoices': 'As faturas são mantidas em nossos servidores por 18 meses.',
    'b2bDashboard.retentionQuotes': 'Os orçamentos são mantidos em nossos servidores por 1 mês.',
    'b2bDashboard.saveNote': 'Salvar nota',
    'b2bDashboard.saving': 'Salvando...',
    'b2bDashboard.searchPlaceholder': 'Pesquisar...',
    'b2bDashboard.sendRequest': 'Enviar minha solicitação',
    'b2bDashboard.sending': 'Enviando...',
    'b2bDashboard.status.awaitingParts': 'Aguard. peças',
    'b2bDashboard.status.awaitingPickup': 'Aguard. retirada',
    'b2bDashboard.status.awaitingReception': 'Aguard. recebimento',
    'b2bDashboard.status.completed': 'Concluído',
    'b2bDashboard.status.delivered': 'Entregue',
    'b2bDashboard.status.inProgress': 'Em andamento',
    'b2bDashboard.status.received': 'Recebido',
    'b2bDashboard.status.refused': 'Recusado',
    'b2bDashboard.statusCol': 'Status',
    'b2bDashboard.submitError': 'Erro no envio',
    'b2bDashboard.teamResponse': 'Resposta da equipe:',
    'b2bDashboard.titleOptional': 'Título (opcional)',
    'b2bDashboard.titlePlaceholder': 'Ex.: Reparo lote de telas Samsung',
    'b2bDashboard.total': 'Total',
    'b2bDashboard.totalDue': 'Total devido: {{amount}}',
    'b2bDashboard.trackingBadge': 'Rastreamento:',
    'b2bDashboard.trackingNumber': 'Número de rastreamento',
    'b2bDashboard.trackingPlaceholder': 'Ex.: 1Z999AA10123456784',
    'b2bDashboard.trackingRequired': 'Por favor, digite o número de rastreamento para o envio postal',
    'b2bDashboard.trackingShort': 'N.º rastreamento',
    'b2bDashboard.travelFee': 'Taxa de deslocamento',
    'b2bDashboard.travelQuotes': 'Orçamentos de deslocamento',
    'b2bDashboard.uploadError': 'Erro no upload',
    'b2bDashboard.uploading': 'Enviando...',
    'b2bDashboard.validate': 'Validar',
    'b2bDashboard.validationCodeConfirmed': 'Código de validação confirmado',
    'client.mySpace': 'Meu Espaço',
    'client.invoiceDownloadError': 'Erro ao baixar a fatura',
    'client.invoiceViewError': 'Erro ao exibir a fatura',
    'client.invoicePrintError': 'Erro ao imprimir a fatura',
    'client.pinMustBe4': 'O código PIN deve conter 4 dígitos',
    'client.pinMismatch': 'Os códigos PIN não coincidem',
    'client.pinChanged': 'Código PIN alterado com sucesso!',
    'client.pinChangeError': 'Erro ao alterar o PIN',
    'client.describeRequest': 'Descreva sua solicitação',
    'client.error': 'Erro',
    'client.enterValidationCode': 'Digite o código de validação',
    'client.codeValidated': 'Código validado com sucesso!',
    'client.codeIncorrect': 'Código incorreto',
    'client.sumupUrlUnavailable': 'Erro: URL de pagamento SumUp indisponível',
    'client.sumupCreateError': 'Erro ao criar o pagamento SumUp',
    'client.fillRequired': 'Preencha todos os campos obrigatórios',
    'client.invalidEmail': 'Endereço de e-mail inválido',
    'client.requestError': 'Erro durante a solicitação',
    'client.trackingSaved': 'Número de rastreamento salvo!',
    'client.statusText.recu': 'Aparelho recebido na oficina',
    'client.statusText.enCours': 'Reparo em andamento',
    'client.statusText.attentePieces': 'Aguardando peças',
    'client.statusText.termine': 'Reparo concluído - Pronto para retirada',
    'client.statusText.livre': 'Aparelho retirado',
    'client.statusText.demandeEnLigne': 'Aguardando o recebimento do aparelho',
    'client.statusText.nonReparable': 'Aparelho não reparável',
    'client.statusLabel.recu': 'Recebido',
    'client.statusLabel.enCours': 'Em andamento',
    'client.statusLabel.attentePieces': 'Aguardando peças',
    'client.statusLabel.termine': 'Concluído',
    'client.statusLabel.livre': 'Entregue',
    'client.statusLabel.recupere': 'Retirado',
    'client.statusLabel.demandeEnLigne': 'Solicitação on-line',
    'client.statusLabel.nonReparable': 'Não reparável',
    'client.created': 'Criado',
    'client.technicianNotes': 'Notas do técnico',
    'client.noNotes': 'Nenhuma nota por enquanto',
    'client.file': 'arquivo',
    'client.files': 'arquivos',
    'client.navigation': 'Navegação',
    'client.devisFactures': 'Orçamentos / Faturas',
    'client.myAddresses': 'Meus endereços',
    'client.myAccount': 'Minha conta',
    'client.needHelp': 'Precisa de ajuda?',
    'client.helpHours': 'Nossa equipe está disponível de segunda a sábado, das 9h às 19h.',
    'client.contactUs': 'Fale conosco',
    'client.contactSupport': 'Contatar o suporte',
    'client.guideMe': 'Oriente-me',
    'client.logout': 'Sair',
    'client.changePassword': 'Alterar senha',
    'client.addresses': 'Endereços',
    'client.requestRepair': 'Solicitar um reparo',
    'client.showDelivered': 'Ver entregues',
    'client.hideDelivered': 'Ocultar entregues',
    'client.noRepairsInProgress': 'Nenhum reparo em andamento',
    'client.onlineRepairRequest': 'Solicitação de reparo on-line',
    'client.diagFeeFormPre': 'Preencha o formulário abaixo. A taxa de diagnóstico de',
    'client.diagFeeFormPost': 'deve ser paga on-line.',
    'client.repairReason': 'Motivo do reparo',
    'client.repairReasonPlaceholder': 'Ex.: Tela quebrada, bateria...',
    'client.fullName': 'Nome completo',
    'client.fullNamePlaceholder': 'Seu nome completo',
    'client.postalAddress': 'Endereço postal',
    'client.addressPlaceholder': 'Seu endereço',
    'client.emailAddress': 'Endereço de e-mail',
    'client.emailPlaceholder': 'email@exemplo.com',
    'client.describeIssue': 'Descreva o problema em detalhes',
    'client.describeIssuePlaceholder': 'Conte como o telefone/tablet apresentou defeito e os sintomas observados...',
    'client.devicePhotos': 'Fotos do aparelho',
    'client.addPhotos': 'Adicionar fotos',
    'client.cancel': 'Cancelar',
    'client.sending': 'Enviando...',
    'client.sendRequest': 'Enviar solicitação',
    'client.requestSaved': 'Solicitação registrada: {{ref}}',
    'client.redirecting': 'Redirecionando...',
    'client.payDiagnosticSumup': 'Pagar {{amount}} com SumUp (diagnóstico)',
    'client.diagFeePending': 'Sua solicitação está pendente. Para iniciar o diagnóstico, pague a taxa de',
    'client.depositOrSend': 'Entregue seu aparelho na loja ou envie pelo correio com aviso de recebimento:',
    'client.trackingPlaceholder': 'Número de rastreamento postal',
    'client.save': 'Salvar',
    'client.postalDelayNotice': 'Em caso de envio postal: o prazo passa para 20 dias antes de a solicitação expirar (40 dias para exclusão)',
    'client.close': 'Fechar',
    'client.progress': 'Progresso',
    'client.deposits': 'Sinais',
    'client.rest': 'Restante',
    'client.payWithSumup': 'Pagar {{amount}} com SumUp',
    'client.detailedTracking': 'Acompanhamento detalhado',
    'client.chatRepair': 'Chat do reparo {{ref}}',
    'client.contact': 'Contatar',
    'client.photosCount': 'Fotos ({{count}})',
    'client.level': 'Nível {{name}}',
    'client.tierOr': 'Ouro',
    'client.tierArgent': 'Prata',
    'client.tierBronze': 'Bronze',
    'client.totalPurchases': '{{count}} compra(s) no total',
    'client.nextLevel': 'Próximo nível:',
    'client.purchasesToNext': '{{count}} compra(s) restante(s)',
    'client.rewardAvailable': 'Recompensa disponível!',
    'client.reward10Reached': 'Parabéns, você atingiu {{count}} compras',
    'client.rewardPosDesc': 'na sua próxima compra na loja',
    'client.rewardRepairDesc': 'no seu próximo reparo',
    'client.loyaltyPoints': 'Pontos de fidelidade',
    'client.purchasesUntilReward': 'Faltam apenas {{count}} compra(s) para a recompensa',
    'client.rewardReached': 'Recompensa atingida!',
    'client.rewardsHistory': 'Histórico de recompensas',
    'client.reward15Pos': '-15% na loja',
    'client.reward10Repair': '-10% Reparo',
    'client.referralProgram': 'Programa de Indicação',
    'client.referralSubtitle': 'Compartilhe seu código e ganhe pontos bônus',
    'client.yourReferralCode': 'Seu código de indicação',
    'client.copied': 'Copiado!',
    'client.copy': 'Copiar',
    'client.referralShare1': 'Compartilhe este código com seus amigos. Quando eles se cadastrarem com ele, você ganha',
    'client.referralBonusPoints': '+2 pontos',
    'client.referralShare2': 'de fidelidade!',
    'client.copyReferralLink': 'Copiar o link de cadastro',
    'client.referrals': 'Indicado(s)',
    'client.bonusPoints': 'Pontos bônus',
    'client.yourReferrals': 'Seus indicados',
    'client.referralFallback': 'Indicado',
    'client.myDevis': 'Meus Orçamentos',
    'client.newRequest': 'Nova solicitação',
    'client.newDevisRequest': 'Nova solicitação de orçamento',
    'client.titleOptional': 'Título (opcional)',
    'client.devisTitlePlaceholder': 'Ex.: Reparo de tela do iPhone 15',
    'client.requestDescription': 'Descrição da sua solicitação',
    'client.devisDescPlaceholder': 'Descreva o que você deseja: tipo de reparo, problema, etc.',
    'client.addressOptional': 'Endereço (opcional, para deslocamento)',
    'client.devisAddressPlaceholder': 'Seu endereço, caso deseje um deslocamento',
    'client.sendMyRequest': 'Enviar minha solicitação',
    'client.myDevisRequests': 'Minhas solicitações de orçamento',
    'client.devisRequestTitle': 'Solicitação de orçamento',
    'client.devisReqNouveau': 'Novo',
    'client.devisReqEnCours': 'Em andamento',
    'client.devisReqRefuse': 'Recusado',
    'client.devisReqTraite': 'Processado',
    'client.teamResponse': 'Resposta da equipe:',
    'client.refusalReason': 'Motivo da recusa:',
    'client.clickNewRequest': 'Clique em "Nova solicitação" para criar uma',
    'client.designation': 'Descrição',
    'client.price': 'Preço',
    'client.travelFees': 'Taxa de deslocamento',
    'client.totalUpper': 'TOTAL',
    'client.paid': 'Pago',
    'client.purchaseOrder': 'Pedido de compra',
    'client.invoice': 'Fatura',
    'client.latePayment': 'ATRASO NO PAGAMENTO - {{days}} dias',
    'client.latePenaltyLabel': 'Multas por atraso ({{rate}}% ao ano)',
    'client.recoveryIndemnity': 'Indenização fixa de cobrança',
    'client.totalWithPenalties': 'Total devido com multas',
    'client.validationCodeTitle': 'Código de validação do pedido de compra',
    'client.validationCodeDesc': 'Digite o código recebido por e-mail para validar seu pedido.',
    'client.code6digits': 'Código de 6 dígitos',
    'client.validate': 'Validar',
    'client.codeConfirmed': 'Código de validação confirmado',
    'client.pdfDevis': 'PDF Orçamento',
    'client.pdfPurchaseOrder': 'PDF Pedido de compra',
    'client.pdfInvoice': 'PDF Fatura',
    'client.payRest': 'Pagar o restante ({{amount}})',
    'client.deposit50': 'Sinal de 50%',
    'client.fullPayment': 'Pagamento integral',
    'client.myInvoices': 'Minhas Faturas',
    'client.mostRecent': 'Mais recentes',
    'client.oldest': 'Mais antigas',
    'client.noInvoices': 'Nenhuma fatura disponível',
    'client.view': 'Ver',
    'client.print': 'Imprimir',
    'client.seeLess': 'Ver menos',
    'client.seeMoreInvoices': 'Ver mais ({{count}} faturas)',
    'client.invoiceRetention': 'As faturas são mantidas em nossos servidores por um período de 18 meses.',
    'client.devisRetention': 'Os orçamentos são mantidos em nossos servidores por um período de 1 mês.',
    'client.createCaricature': 'Criar minha caricatura',
    'client.copyrightBy': 'Copyright de',
    'client.notifications': 'Notificações',
    'client.markAllRead': 'Marcar tudo como lido',
    'client.noNotifications': 'Nenhuma notificação',
    'client.pinChangeTitle': 'Alteração do código PIN',
    'client.pinChangeDesc': 'Para sua segurança, escolha um novo código PIN de 4 dígitos.',
    'client.newPin': 'Novo código PIN',
    'client.confirmPin': 'Confirmar PIN',
    'client.modifying': 'Alterando...',
    'client.changePin': 'Alterar meu código PIN',
    'client.proofSent': 'Comprovante de pagamento enviado! A equipe vai verificá-lo.',
    'client.sendError': 'Erro ao enviar',
    'client.orderStatusEnAttente': 'Pendente',
    'client.orderStatusPayee': 'Paga',
    'client.orderStatusProofUploaded': 'Comprovante enviado',
    'client.orderStatusConfirmee': 'Confirmada',
    'client.orderStatusPreparee': 'Preparada',
    'client.orderStatusExpediee': 'Enviada',
    'client.orderStatusLivree': 'Entregue',
    'client.orderStatusAnnulee': 'Cancelada',
    'client.trackingNumber': 'Número de rastreamento:',
    'client.trackingHint': 'Use este número para rastrear sua encomenda',
    'client.stepCommande': 'Pedido',
    'client.proofSentLabel': 'Comprovante de pagamento enviado',
    'client.sentOn': 'Enviado em',
    'client.validatedByStaff': 'Validado pela equipe',
    'client.payWithSumupPlain': 'Pagar com SumUp',
    'client.sendProof': 'Enviar comprovante de pagamento (captura)',
    'client.history': 'Histórico',
    'client.chatOrder': 'Chat do pedido {{ref}}',
    'client.homeLabel': 'Casa',
    'client.enterFullAddress': 'Digite seu endereço completo.',
    'client.saveError': 'Erro ao salvar',
    'client.addressLabelField': 'Rótulo',
    'client.labelPlaceholder': 'Casa, Escritório...',
    'client.phone': 'Telefone',
    'client.phonePlaceholder': '06 94 ...',
    'client.recipient': 'Destinatário',
    'client.recipientPlaceholder': 'Nome do destinatário',
    'client.deliveryAddress': 'Endereço de entrega',
    'client.addressInputPlaceholder': 'Digite seu endereço completo',
    'client.freeAddressHint': 'Entrada livre: selecione uma sugestão se aparecer; caso contrário, apenas digite seu endereço.',
    'client.searching': 'Buscando...',
    'client.addressValidated': 'Endereço validado',
    'client.saving': 'Salvando...',
    'client.confirmDeleteAddress': 'Excluir este endereço?',
    'client.manageAddressesSubtitle': 'Gerencie seus endereços de entrega',
    'client.addAddress': 'Adicionar um endereço',
    'client.newAddress': 'Novo endereço',
    'client.editAddress': 'Editar o endereço',
    'client.default': 'Padrão',
    'client.edit': 'Editar',
    'client.delete': 'Excluir',
    'client.setDefault': 'Definir como padrão',
    'client.selectAddress': 'Selecione ou adicione um endereço de entrega.',
    'client.orderSuccess': 'Pedido realizado com sucesso!',
    'client.orderError': 'Erro ao fazer o pedido',
    'client.ourAccessories': 'Nossos acessórios',
    'client.expertSelection': 'Seleção testada por nossos especialistas',
    'client.allCategories': 'Todas as categorias',
    'client.cart': 'Carrinho',
    'client.noArticles': 'Nenhum item disponível',
    'client.inStock': 'Em estoque',
    'client.unavailable': 'Indisponível',
    'client.add': 'Adicionar',
    'client.myCart': 'Meu carrinho',
    'client.articleSingular': 'item',
    'client.articlesPlural': 'itens',
    'client.cartEmpty': 'Seu carrinho está vazio',
    'client.manage': 'Gerenciar',
    'client.processing': 'Processando...',
    'client.payOnDelivery': 'Pagamento na entrega',
    'publicShop.status.en_attente': 'Pendente',
    'publicShop.status.en_cours': 'Em andamento',
    'publicShop.status.termine': 'Concluído',
    'publicShop.status.pret': 'Pronto',
    'publicShop.status.livre': 'Entregue',
    'publicShop.status.annule': 'Cancelado',
    'publicShop.repairNotFound': 'Reparo não encontrado',
    'publicShop.shopNotFound': 'Loja não encontrada',
    'publicShop.trackTitle': 'Acompanhar meu reparo',
    'publicShop.trackSubtitle': 'Digite seu número de série ou código de acompanhamento',
    'publicShop.trackPlaceholder': 'Número de série ou código de acompanhamento...',
    'publicShop.trackButton': 'Acompanhar',
    'publicShop.labelDateEntree': 'Data de entrada:',
    'publicShop.labelSortiePrevue': 'Saída prevista:',
    'publicShop.labelProbleme': 'Problema:',
    'publicShop.labelRemarques': 'Observações:',
    'publicShop.poweredBy': 'Desenvolvido por {{brand}}',
    'invoiceRequest.subtitle': 'Solicitação de nota fiscal',
    'invoiceRequest.search.title': 'Encontre sua compra',
    'invoiceRequest.search.hint': 'Informe o valor exato e o horário aproximado.',
    'invoiceRequest.search.amountLabel': 'Valor pago (EUR)',
    'invoiceRequest.search.amountPlaceholder': 'Ex.: 25.00',
    'invoiceRequest.search.timeLabel': 'Horário',
    'invoiceRequest.search.dateLabel': 'Data',
    'invoiceRequest.search.loading': 'Buscando…',
    'invoiceRequest.search.submit': 'Buscar',
    'invoiceRequest.results.title': 'Selecione sua compra',
    'invoiceRequest.results.paidLabel': 'Pago:',
    'invoiceRequest.itemsCount': '{{count}} item(ns)',
    'invoiceRequest.back': 'Voltar',
    'invoiceRequest.form.title': 'Seus dados',
    'invoiceRequest.form.purchase': 'Compra',
    'invoiceRequest.form.alreadyPaid': 'Já pago',
    'invoiceRequest.form.payment': 'Pagamento',
    'invoiceRequest.form.remaining': 'Restante',
    'invoiceRequest.form.nameLabel': 'Nome completo',
    'invoiceRequest.form.namePlaceholder': 'João Silva',
    'invoiceRequest.form.emailLabel': 'Endereço de e-mail',
    'invoiceRequest.form.emailPlaceholder': 'joao@exemplo.com',
    'invoiceRequest.form.phoneLabel': 'Telefone',
    'invoiceRequest.form.phonePlaceholder': '0694XXXXXX',
    'invoiceRequest.form.sending': 'Enviando…',
    'invoiceRequest.form.submit': 'Enviar a nota fiscal',
    'invoiceRequest.pending.title': 'Solicitação pendente',
    'invoiceRequest.pending.desc': 'Esta nota fiscal já foi enviada para outro endereço.',
    'invoiceRequest.pending.validationRequired': 'Validação necessária',
    'invoiceRequest.pending.info': 'Sua solicitação foi encaminhada à nossa equipe. Você receberá a nota fiscal em {{email}} após a validação.',
    'invoiceRequest.newRequest': 'Nova solicitação',
    'invoiceRequest.success.title': 'Nota fiscal enviada!',
    'invoiceRequest.success.desc': 'Sua nota fiscal foi enviada para {{email}}.',
    'invoiceRequest.success.accountCreated': 'Conta de cliente criada!',
    'invoiceRequest.success.newAccountDesc': 'Suas credenciais de acesso foram enviadas para {{email}}.',
    'invoiceRequest.success.sendingCredentials': 'Enviando…',
    'invoiceRequest.success.resendCredentials': 'Receber minhas credenciais por e-mail',
    'invoiceRequest.success.credentialsSent': 'Credenciais enviadas para {{email}}',
    'invoiceRequest.success.trackRepairs': 'Acompanhar meus reparos',
    'invoiceRequest.footer': 'R.E.Mobiles — 102 Avenue Général de Gaulle, Porte 2, 97300 Cayenne',
    'invoiceRequest.errors.search': 'Erro na busca',
    'invoiceRequest.errors.notFound': 'Nenhuma venda encontrada para esse valor e horário. Verifique as informações.',
    'invoiceRequest.errors.send': 'Erro ao enviar',
    'invoiceRequest.errors.generic': 'Erro',
    'storefront.notfound.title': 'Empresa não encontrada',
    'storefront.notfound.desc': 'Esta empresa não existe ou não está mais ativa.',
    'storefront.notfound.back': 'Voltar ao início',
    'storefront.tab.track': 'Acompanhar meu reparo',
    'storefront.tab.login': 'Área do cliente',
    'storefront.track.title': 'Acompanhamento de reparo',
    'storefront.track.subtitle': 'Digite sua referência para acompanhar o andamento do seu reparo',
    'storefront.track.format': 'Formato da referência:',
    'storefront.track.submit': 'Acompanhar',
    'storefront.track.not_found': 'Reparo não encontrado',
    'storefront.track.ref': 'Referência',
    'storefront.track.device': 'Aparelho',
    'storefront.track.problem': 'Problema',
    'storefront.track.date_in': 'Data de entrada',
    'storefront.track.date_out': 'Data de saída prevista',
    'storefront.status.waiting': 'Pendente',
    'storefront.status.in_progress': 'Em andamento',
    'storefront.status.done': 'Concluído',
    'storefront.status.delivered': 'Entregue',
    'storefront.status.cancelled': 'Cancelado',
    'storefront.status.unknown': 'Desconhecido',
    'storefront.login.title': 'Login do cliente',
    'storefront.login.subtitle': 'Acesse sua área do cliente na {{name}}',
    'storefront.login.phone': 'Telefone',
    'storefront.login.pin': 'Código PIN',
    'storefront.login.error_fields': 'Digite seu telefone e seu código PIN (4 ou 6 dígitos)',
    'storefront.login.error_invalid': 'Credenciais incorretas',
    'storefront.login.loading': 'Entrando...',
    'storefront.login.submit': 'Entrar',
    'storefront.login.create_account': 'Ainda não tem conta? Criar uma conta',
    'storefront.register.title': 'Criar uma conta',
    'storefront.register.subtitle': 'Cadastre-se na {{name}}',
    'storefront.register.name': 'Nome completo',
    'storefront.register.name_ph': 'João Silva',
    'storefront.register.phone': 'Telefone',
    'storefront.register.email': 'E-mail (opcional)',
    'storefront.register.email_ph': 'email@exemplo.com',
    'storefront.register.pin': 'Código PIN',
    'storefront.register.pin_confirm': 'Confirmar PIN',
    'storefront.register.error_required': 'Nome e telefone obrigatórios',
    'storefront.register.error_pin_short': 'O PIN deve conter pelo menos 4 dígitos',
    'storefront.register.error_pin_mismatch': 'Os PINs não coincidem',
    'storefront.register.error_generic': 'Erro ao criar a conta',
    'storefront.register.loading': 'Criando...',
    'storefront.register.submit': 'Criar minha conta',
    'storefront.register.back_to_login': 'Já tem uma conta? Entrar',
    'landing.svcScreenTitle': 'Tela quebrada',
    'landing.svcScreenDesc': 'Substituição de tela iPhone, Samsung, Huawei',
    'landing.svcBatteryTitle': 'Bateria',
    'landing.svcBatteryDesc': 'Substituição de bateria de todas as marcas',
    'landing.svcConnectorTitle': 'Conector',
    'landing.svcConnectorDesc': 'Conector de carga, entrada de áudio',
    'landing.svcCameraTitle': 'Câmera',
    'landing.svcCameraDesc': 'Câmera frontal e traseira',
    'landing.svcOxidationTitle': 'Desoxidação',
    'landing.svcOxidationDesc': 'Telefone que caiu na água',
    'landing.svcDiagTitle': 'Diagnóstico',
    'landing.svcDiagDesc': 'De 35 a 80 € conforme o aparelho · orçamento gratuito',
    'landing.tip1': '**Olá!** Posso acompanhar o seu reparo ou dar uma estimativa.',
    'landing.tip2': '**Garantia de 6 meses** em todos os nossos reparos, peças e mão de obra.',
    'landing.tip3': '**Diagnóstico** de 35 a 80 € conforme o aparelho, informado antes de começar.',
    'landing.tip4': 'Caiu na água? **Desligue-o** e venha rápido: desoxidação na oficina.',
    'landing.tip5': 'Acompanhe o seu reparo ao vivo com a sua referência **REM0001**.',
    'landing.tip6': '**Microssolda** e recuperação de dados, mesmo que o aparelho não ligue mais.',
    'landing.tip7': 'Aberto **seg–sex 9h–19h** e **sáb 9h–14h**, entrega sem hora marcada.',
    'landing.tip8': '**Orçamento gratuito** on-line, enviado por e-mail após a confirmação.',
    'landing.tip9': 'Profissionais: um **Espaço Empresa** dedicado (portal B2B).',
    'landing.tip10': 'iPhone, Samsung, Huawei, Xiaomi, tablets e **consoles**: consertamos tudo.',
    'landing.tipFromPrice': 'a partir de {{price}} — preço confirmado na loja.',
    'landing.guideMe': 'Oriente-me',
    'landing.flashUntil': 'Até {{date}}',
    'landing.cadbotTitle': 'CADBOT, o seu assistente',
    'landing.cadbotDesc': 'Acompanhamento de reparos, estimativa de orçamento, horários — ele responde diretamente no site. O preço final é sempre confirmado na loja.',
    'landing.servicesTitle': 'Nossos serviços de reparo',
    'landing.servicesDesc': 'Reparo expresso de smartphones e tablets em Caiena, Guiana Francesa',
    'landing.seeAllPrices': 'Ver todos os nossos preços',
    'landing.readBlog': 'Ler o nosso blog',
    'landing.diagTitle': 'Diagnóstico na loja',
    'landing.diagDesc': 'De 35 a 80 € conforme o aparelho. O preço é informado antes de começar. O orçamento on-line continua gratuito.',
    'landing.tierFrom': 'a partir de',
    'landing.tierUpTo': 'até',
    'landing.tierEntryTitle': 'Linha de entrada e intermediária',
    'landing.tierEntryDesc': 'Falha simples e identificada',
    'landing.tierRecentTitle': 'Smartphones recentes',
    'landing.tierRecentDesc': 'Vários sintomas a verificar',
    'landing.tierComplexTitle': 'Casos complexos',
    'landing.tierComplexDesc': 'Dano por água, microssolda, consoles, tablets',
    'landing.enlarge': 'Ampliar',
    'landing.storePhotoAlt': 'Nossa loja Resurrection Mobile em Caiena',
    'landing.storeTag': 'Nossa loja · Caiena',
    'landing.enlargedPhoto': 'Foto ampliada',
    'landing.close': 'Fechar',
    'landing.storePhotoAltSimple': 'Loja Resurrection Mobile',
    'landing.freeQuote': 'Orçamento gratuito',
    'privacy.title': 'Política de privacidade',
    'privacy.last_updated': 'Última atualização: 19 de março de 2026',
    'privacy.intro.part1': 'Esta Política de privacidade descreve como ',
    'privacy.intro.part2': ' (“nós”, “nosso”, “nossos”) coleta, usa, conserva e protege os dados pessoais dos usuários (“você”, “seu”) em conformidade com o ',
    'privacy.intro.rgpd': 'Regulamento Geral sobre a Proteção de Dados (RGPD — UE 2016/679)',
    'privacy.intro.part3': ' aplicável na França e na Guiana Francesa.',
    'privacy.s1.title': 'Controlador dos dados',
    'privacy.s1.company_label': 'Empresa',
    'privacy.s1.status_label': 'Forma jurídica',
    'privacy.s1.controller_note': 'O controlador dos dados é a pessoa ou entidade que determina as finalidades e os meios do tratamento dos seus dados pessoais.',
    'privacy.s2.title': 'Dados pessoais coletados',
    'privacy.s2.sub1_title': '2.1 Dados de identificação',
    'privacy.s2.sub1_b1': 'Nome e sobrenome',
    'privacy.s2.sub1_b2': 'Endereço postal',
    'privacy.s2.sub1_b3': 'Número de telefone',
    'privacy.s2.sub1_b4': 'Endereço de e-mail',
    'privacy.s2.sub1_b5': 'Nome da empresa (se cliente profissional)',
    'privacy.s2.sub2_title': '2.2 Dados relacionados aos serviços',
    'privacy.s2.sub2_b1': 'Informações sobre os aparelhos confiados (marca, modelo, IMEI, número de série)',
    'privacy.s2.sub2_b2': 'Histórico de reparos',
    'privacy.s2.sub2_b3': 'Pedidos, orçamentos e faturas',
    'privacy.s2.sub2_b4': 'Assinaturas eletrônicas',
    'privacy.s2.sub3_title': '2.3 Dados de pagamento',
    'privacy.s2.sub3_b1': 'Informações da transação',
    'privacy.s2.sub3_b2': 'Meio de pagamento utilizado',
    'privacy.s2.payment_important_label': 'Importante:',
    'privacy.s2.payment_important_text': 'Nunca armazenamos os seus dados bancários completos. Os pagamentos são processados por prestadores seguros (Stripe).',
    'privacy.s2.sub4_title': '2.4 Dados técnicos',
    'privacy.s2.sub4_b1': 'Endereço IP',
    'privacy.s2.sub4_b2': 'Dados de conexão',
    'privacy.s2.sub4_b3': 'Cookies e rastreadores',
    'privacy.s2.sub4_b4': 'Dados de navegação',
    'privacy.s3.title': 'Finalidades do tratamento',
    'privacy.s3.b1': 'Fornecer os nossos serviços de reparo e venda',
    'privacy.s3.b2': 'Gerenciar pedidos, orçamentos e faturamento',
    'privacy.s3.b3': 'Garantir o acompanhamento do cliente e o serviço pós-venda',
    'privacy.s3.b4': 'Comunicar com você (SMS, e-mail, telefone)',
    'privacy.s3.b5': 'Cumprir as nossas obrigações legais e contábeis',
    'privacy.s3.b6': 'Melhorar os nossos serviços e a segurança',
    'privacy.s3.b7': 'Prevenir fraudes',
    'privacy.s4.title': 'Base legal do tratamento',
    'privacy.s4.intro': 'Em conformidade com o RGPD, os tratamentos baseiam-se em:',
    'privacy.s4.i1': 'A execução de um contrato',
    'privacy.s4.i2': 'O cumprimento de obrigações legais',
    'privacy.s4.i3': 'O seu consentimento (ex.: marketing)',
    'privacy.s4.i4': 'O nosso interesse legítimo (segurança, melhoria)',
    'privacy.s5.title': 'Destinatários dos dados',
    'privacy.s5.b1': 'Os nossos funcionários autorizados',
    'privacy.s5.b2': 'Os nossos prestadores técnicos (hospedagem, pagamento, SMS, e-mail)',
    'privacy.s5.b3': 'As autoridades administrativas ou judiciais quando a lei o exigir',
    'privacy.s5.no_sale': 'Nenhum dado pessoal é vendido a terceiros.',
    'privacy.s6.title': 'Transferência para fora da União Europeia',
    'privacy.s6.text': 'Se alguns prestadores estiverem localizados fora da UE, asseguramo-nos de que oferecem um nível de proteção adequado em conformidade com o RGPD (cláusulas contratuais-tipo, decisões de adequação, etc.).',
    'privacy.s7.title': 'Prazo de conservação',
    'privacy.s7.r1_label': 'Dados dos clientes',
    'privacy.s7.r1_value': '5 anos após a última relação comercial',
    'privacy.s7.r2_label': 'Dados de faturamento',
    'privacy.s7.r2_value': '10 anos (obrigação legal)',
    'privacy.s7.r3_label': 'Dados de marketing',
    'privacy.s7.r3_value': 'Até a retirada do consentimento',
    'privacy.s7.r4_label': 'Cookies',
    'privacy.s7.r4_value': 'Máximo de 13 meses',
    'privacy.s8.title': 'Segurança dos dados',
    'privacy.s8.intro': 'Implementamos medidas técnicas e organizacionais apropriadas:',
    'privacy.s8.b1': 'Acesso restrito aos dados',
    'privacy.s8.b2': 'Hospedagem segura',
    'privacy.s8.b3': 'Criptografia quando necessário',
    'privacy.s8.b4': 'Backups regulares',
    'privacy.s8.b5': 'Proteção contra acessos não autorizados',
    'privacy.s9.title': 'Os seus direitos',
    'privacy.s9.intro': 'Em conformidade com o RGPD, você dispõe dos seguintes direitos:',
    'privacy.s9.r1': 'Direito de acesso',
    'privacy.s9.r2': 'Direito de retificação',
    'privacy.s9.r3': 'Direito ao apagamento (“direito ao esquecimento”)',
    'privacy.s9.r4': 'Direito à limitação do tratamento',
    'privacy.s9.r5': 'Direito de oposição',
    'privacy.s9.r6': 'Direito à portabilidade dos dados',
    'privacy.s9.r7': 'Direito de retirar o seu consentimento',
    'privacy.s9.exercise': 'Para exercer os seus direitos, entre em contato conosco em:',
    'privacy.s9.complaint_before': 'Você também pode apresentar uma reclamação junto à ',
    'privacy.s9.complaint_after': '.',
    'privacy.s10.title': 'Cookies',
    'privacy.s10.intro': 'O nosso site pode utilizar cookies para:',
    'privacy.s10.b1': 'Garantir o funcionamento do site',
    'privacy.s10.b2': 'Medir a audiência',
    'privacy.s10.b3': 'Melhorar a experiência do usuário',
    'privacy.s10.manage': 'Você pode gerenciar as suas preferências pelo seu navegador ou pelo nosso banner de cookies.',
    'privacy.s11.title': 'Dados de menores',
    'privacy.s11.text': 'Os nossos serviços não se destinam a menores sem autorização dos pais. Se os dados de um menor tiverem sido coletados por engano, entre em contato conosco para a sua exclusão.',
    'privacy.s12.title': 'Alterações da política',
    'privacy.s12.text': 'Podemos alterar esta Política a qualquer momento para refletir a evolução legal ou técnica. A versão em vigor é a publicada no nosso site.',
    'privacy.s13.title': 'Contato',
    'privacy.s13.intro': 'Para qualquer dúvida relativa a esta Política ou aos seus dados pessoais:',
    'privacy.footer': 'Ao utilizar os nossos serviços, você reconhece ter tomado conhecimento da presente Política de privacidade.',
    'track.title': 'Acompanhar meu reparo',
    'track.label_ref': 'Referência',
    'track.label_device': 'Aparelho',
    'track.label_received': 'Recebido em',
    'track.label_expected': 'Previsão de entrega',
    'track.label_completed': 'Concluído em',
    'track.label_amount': 'Valor',
    'track.status_pending': 'Aguardando',
    'track.see_full': 'Ver detalhes completos',
    'track.input_placeholder': 'Digite sua referência (ex.: REM0001)',
    'track.btn_track': 'Acompanhar',
    'track.scan_qr': 'Escanear o QR code do meu comprovante',
    'track.err_invalid_ref': 'Referência inválida. Formato esperado: REM0001',
    'track.err_not_found': 'Reparo não encontrado',
    'chatWidget.statusStaffOnline': 'Equipe on-line',
    'chatWidget.statusAiActive': 'IA ativa — resposta automática',
    'chatWidget.statusOffline': 'Off-line — deixe uma mensagem',
    'chatWidget.launcherLabel': 'Chat e ajuda',
    'chatWidget.tabStaff': 'Chat de suporte',
    'chatWidget.tabAi': 'Ajuda IA',
    'chatWidget.newMessage': 'Nova mensagem',
    'chatWidget.loading': 'Carregando...',
    'chatWidget.noConversations': 'Nenhuma conversa',
    'chatWidget.emptyConvoHint': 'Clique em "{{action}}" para falar conosco',
    'chatWidget.conversationFallback': 'Conversa',
    'chatWidget.autoReplyTitle': 'Modo de resposta automática IA ativo',
    'chatWidget.autoReplyDesc': 'A equipe está off-line. A IA responde enquanto isso.',
    'chatWidget.staffEmptyTitle': 'Envie uma mensagem para a equipe',
    'chatWidget.staffEmptyDesc': 'Responderemos o mais rápido possível',
    'chatWidget.aiAssistant': 'Assistente IA',
    'chatWidget.badgeAuto': 'auto',
    'chatWidget.badgeQuoteIndicative': 'orçamento indicativo',
    'chatWidget.badgeQuotePending': 'orçamento em preparação',
    'chatWidget.supportFallback': 'Suporte',
    'chatWidget.sending': 'Enviando...',
    'chatWidget.staffInputPlaceholder': 'Sua mensagem...',
    'chatWidget.interactiveGuides': 'Guias interativos',
    'chatWidget.stepsCount': '{{count}} etapas',
    'chatWidget.faqTitle': 'Perguntas frequentes',
    'chatWidget.back': 'Voltar',
    'chatWidget.stepProgress': 'Etapa {{current}} / {{total}}',
    'chatWidget.previous': 'Anterior',
    'chatWidget.next': 'Próximo',
    'chatWidget.finish': 'Concluir',
    'chatWidget.aiInputPlaceholder': 'Faça sua pergunta...',
    'chatWidget.aiError': 'Desculpe, ocorreu um erro.',
    'chatWidget.me': 'Eu',
    'chatWidget.newConversationSubject': 'Nova conversa',
    'hours.title': 'Horário de funcionamento',
    'hours.rows.weekdays.label': 'Segunda - Sexta',
    'hours.rows.weekdays.hours': '9h - 19h',
    'hours.rows.saturday.label': 'Sábado',
    'hours.rows.saturday.hours': '9h - 14h',
    'hours.rows.sunday.label': 'Domingo',
    'hours.closed': 'Fechado',
    'hours.unit.hour': 'h',
    'hours.unit.minute': 'min',
    'hours.unit.second': 's',
    'hours.clock': 'são {{time}} em Caiena',
    'hours.ring.dayProgress': 'do dia',
    'hours.ring.untilReopen': 'até a reabertura',
    'hours.state.openNow': 'Aberto agora',
    'hours.state.closingSoon': 'Fecha em breve',
    'hours.state.closed': 'Fechado',
    'hours.count.untilClose': 'até o fechamento ({{hour}}h)',
    'hours.count.untilOpen': 'até a abertura',
    'hours.sub.openSince': 'Aberto há {{duration}}',
    'hours.sub.nextOpen': 'Próxima abertura: {{when}} às {{hour}}h',
    'hours.when.today': 'hoje',
    'hours.when.tomorrow': 'amanhã',
    'hours.mood.closingSoon': '⏳ Reta final — ainda esperamos você por mais um tempinho!',
    'hours.mood.justOpened': '☕ Acabamos de abrir — passe para nos ver!',
    'hours.mood.open': '🟢 Estamos abertos, passe quando quiser!',
    'hours.mood.opensSoon': '🚪 Abrimos em menos de uma hora — a porta já vai subir!',
    'hours.mood.sundayRest': '🌴 Domingo é dia de descanso — até segunda às 9h!',
    'hours.mood.morning': '🌅 Bom dia! Abrimos às {{hour}}h, prepare seus aparelhos.',
    'hours.mood.evening': '🌙 Fechado por hoje à noite — até breve!',
    'hours.dayName.0': 'domingo',
    'hours.dayName.1': 'segunda-feira',
    'hours.dayName.2': 'terça-feira',
    'hours.dayName.3': 'quarta-feira',
    'hours.dayName.4': 'quinta-feira',
    'hours.dayName.5': 'sexta-feira',
    'hours.dayName.6': 'sábado',
    'cadbot.welcome': 'Olá, eu sou o **CADBOT**, o assistente da Resurrection Mobile. Digite sua referência **REM0001** para acompanhar seu reparo, ou descreva o defeito para uma estimativa.',
    'cadbot.chip.status': 'Como está meu reparo?',
    'cadbot.chip.screen': 'Tela do iPhone 11 quebrada, quanto custa?',
    'cadbot.chip.battery': 'Bateria do Galaxy S21, preço?',
    'cadbot.chip.diagnostic': 'Quanto custa o diagnóstico?',
    'cadbot.chip.hours': 'Horário e endereço?',
    'cadbot.note': 'As estimativas são indicativas e sempre confirmadas na loja. O orçamento detalhado é enviado por e-mail após a validação da nossa equipe.',
    'cadbot.status.online': 'online',
    'cadbot.resume.label': 'Retomar minha conversa',
    'cadbot.resume.title': 'Mostrar a conversa iniciada nesta aba',
    'cadbot.reset.label': 'Nova conversa',
    'cadbot.reset.title': 'Apagar esta conversa e recomeçar',
    'cadbot.input.label': 'Sua mensagem',
    'cadbot.input.placeholderIdentity': 'Seu nome, telefone ou e-mail…',
    'cadbot.input.placeholderDefault': 'REM0001, tela do iPhone 13, bateria…',
    'cadbot.send.aria': 'Enviar',
    'cadbot.local.greeting': 'Olá! Eu sou o **CADBOT**. Posso acompanhar seu reparo (referência REM0001), estimar um orçamento ou informar nosso horário.',
    'cadbot.local.diagnostic': 'O diagnóstico na loja varia de {{min}} a {{max}} conforme o aparelho e a complexidade. O preço é informado antes de começar. Já o orçamento on-line é gratuito.',
    'cadbot.local.water': 'Desligue-o e não o carregue, depois leve-o à loja o quanto antes. A desoxidação é orçada após o diagnóstico.',
    'cadbot.local.hoursLine': 'Estamos em **{{address}}**. Horário: {{hours}}. {{state}}',
    'cadbot.local.hoursOpen': '**{{state}}** — {{time}} {{countLabel}}.',
    'cadbot.local.hoursClosed': '**Fechado** — {{sub}}.',
    'cadbot.local.closedLower': 'fechado',
    'cadbot.local.warranty': 'Todos os nossos reparos têm garantia de **6 meses**, peças e mão de obra.',
    'cadbot.local.accounts': 'Os acessos estão logo acima: **Área do Cliente** (acompanhamento dos seus reparos), **Área Empresa** (portal B2B) e **Área Staff**.',
    'cadbot.local.trackAsk': 'Informe sua referência no formato **REM0001** (ela está no seu comprovante de entrega) e eu informo o andamento.',
    'cadbot.local.quoteFollowup': 'Seu orçamento é enviado por e-mail assim que nossa equipe o valida (confira a caixa de spam). Sem retorno em 24 h, fale conosco no WhatsApp pelo **{{phone}}**.',
    'cadbot.local.contact': 'Você pode falar conosco pelo **{{phone}}** (ligação e WhatsApp).',
    'cadbot.track.here': 'Aqui está o acompanhamento de **{{ref}}**:',
    'cadbot.track.notFound': 'Não encontro o reparo **{{ref}}**. Verifique a referência no seu comprovante de entrega.',
    'cadbot.track.unavailable': 'O acompanhamento está temporariamente indisponível, tente novamente em instantes.',
    'cadbot.server.ackDefault': 'Obrigado, um técnico responderá em breve.',
    'cadbot.error.rateLimit': 'Muitas solicitações de uma vez — aguarde {{wait}} e tente novamente.',
    'cadbot.error.waitMinutes': '{{n}} min',
    'cadbot.error.waitFallback': 'um minuto',
    'cadbot.error.server': 'Não consigo acessar o servidor. Fale conosco no WhatsApp pelo **{{phone}}**.',
    // ── tarifs.* (pilote i18n 2026-09-12 — à relire) ──
    'tarifs.back': 'Início',
    'tarifs.searchPlaceholder': 'Buscar um modelo ou tipo de reparo…',
    'tarifs.loading': 'Carregando os preços…',
    'tarifs.updateTitle': 'Preços em atualização',
    'tarifs.updateDesc': 'Nossos preços estão sendo atualizados. Fale conosco para um orçamento gratuito e personalizado.',
    'tarifs.call': 'Ligar',
    'tarifs.callPrefix': 'Ligar: ',
    'tarifs.callNow': 'Ligar agora',
    'tarifs.noResult': 'Nenhum resultado',
    'tarifs.soon': 'Preços em breve',
    'tarifs.tryOther': 'Tente outros termos',
    'tarifs.contactFree': 'Fale conosco para um orçamento gratuito',
    'tarifs.repairBrand': 'Reparo {{brand}}',
    'tarifs.tariffsCount': '{{count}} preço(s) disponível(is)',
    'tarifs.colModel': 'Modelo',
    'tarifs.colRepair': 'Reparo',
    'tarifs.colPrice': 'Preço',
    'tarifs.colDelay': 'Prazo',
    'tarifs.allModels': 'Todos os modelos',
    'tarifs.whatsapp': 'WhatsApp',
    'tarifs.portal': 'Portal do cliente',
    'tarifs.faqTitle': 'Perguntas frequentes',
    'tarifs.titleFallback': 'Preços de Reparo de Celular',
    'tarifs.subtitleFallback': 'Conheça nossos preços de reparo para iPhone, Samsung, Huawei e mais. Reparo rápido e garantido em Caiena, Guiana Francesa.',
    'tarifs.ctaTitleFallback': 'Precisa de um orçamento personalizado?',
    'tarifs.ctaDescFallback': 'Cada reparo é único. Fale conosco para um diagnóstico gratuito e um orçamento preciso adaptado à sua situação.',
    'nav.activityHub': 'Central de atividade', 'nav.salesHistory': 'Histórico de vendas', 'nav.equipeMagasins': 'Equipe e lojas', 'nav.usersLegacy': 'Usuários (legado)', // [i18n-P0 2026-09-12: a relire]
    _name: 'Português (Brasil)',
    _flag: '🇧🇷',
    // Nav
    'nav.dashboard': 'Painel',
    'nav.pos': 'Ponto de venda',
    'nav.calcul': 'Cálculo de preço',
    'nav.devis': 'Orçamentos / Faturas',
    'nav.devisDeplacement': 'Orçamentos deslocamento',
    'nav.commandes': 'Pedidos',
    'nav.addDevice': 'Adicionar dispositivo',
    'nav.reparations': 'Reparos',
    'nav.clients': 'Clientes',
    'nav.stock': 'Estoque',
    'nav.addStock': 'Adicionar estoque',
    'nav.etiquettes': 'Etiquetas',
    'nav.users': 'Usuários',
    'nav.clientPwd': 'Senhas de clientes',
    'nav.boutiqueOrders': 'Pedidos da loja',
    'nav.caisseHistory': 'Histórico do caixa',
    'nav.database': 'Banco de dados',
    'nav.historique': 'Histórico',
    'nav.paiements': 'Pagamentos online',
    'nav.chatClients': 'Chat de clientes',
    'nav.chat': 'Mensagens',
    'nav.notes': 'Notas',
    'nav.logout': 'Sair',
    'nav.quit': 'Encerrar',
    'nav.admin': 'Administração',
    'nav.navigation': 'Navegação',
    'nav.b2b': 'Gestão B2B',
    'nav.b2bPayments': 'Pagamentos B2B',
    'nav.brandsModels': 'Marcas & Modelos',
    // Common
    'common.save': 'Salvar',
    'common.cancel': 'Cancelar',
    'common.delete': 'Excluir',
    'common.edit': 'Editar',
    'common.search': 'Buscar',
    'common.add': 'Adicionar',
    'common.close': 'Fechar',
    'common.confirm': 'Confirmar',
    'common.loading': 'Carregando...',
    'common.noData': 'Sem dados',
    'common.actions': 'Ações',
    'common.status': 'Status',
    'common.date': 'Data',
    'common.total': 'Total',
    'common.print': 'Imprimir',
    'common.yes': 'Sim',
    'common.no': 'Não',
    'common.back': 'Voltar',
    'common.next': 'Próximo',
    'common.validate': 'Validar',
    'common.ref': 'Referência',
    'common.client': 'Cliente',
    'common.phone': 'Telefone',
    'common.email': 'Email',
    'common.price': 'Preço',
    'common.quantity': 'Quantidade',
    'common.amount': 'Valor',
    'common.send': 'Enviar',
    'common.download': 'Baixar',
    'common.export': 'Exportar',
    'common.refresh': 'Atualizar',
    'common.filter': 'Filtrar',
    'common.all': 'Todos',
    'common.name': 'Nome',
    'common.address': 'Endereço',
    'common.description': 'Descrição',
    'common.payment': 'Pagamento',
    'common.paid': 'Pago',
    'common.pending': 'Pendente',
    'common.accepted': 'Aceito',
    'common.refused': 'Recusado',
    // Layout
    'layout.panel': 'Painel de gestão',
    // POS
    'pos.title': 'Ponto de Venda',
    'pos.scanner': 'Scanner',
    'pos.searchProduct': 'Buscar um produto (ref, nome, código de barras)...',
    'pos.outOfStock': 'Sem estoque',
    'pos.article': 'Artigo',
    'pos.unitPrice': 'Preço unit.',
    'pos.qty': 'Qtd',
    'pos.emptyCart': 'Carrinho vazio',
    'pos.checkout': 'Pagamento',
    'pos.clientOptional': 'Cliente (opcional)',
    'pos.discount': 'Desconto',
    'pos.subtotal': 'Subtotal',
    'pos.validateSale': 'Validar a venda',
    'pos.paymentMode': 'Forma de pagamento',
    'pos.choosePayment': 'Escolha a forma de pagamento:',
    'pos.cash': 'Dinheiro',
    'pos.card': 'Cartão',
    'pos.mixed': 'Misto',
    'pos.totalToCollect': 'Total a receber',
    'pos.change': 'Troco',
    'pos.confirmPayment': 'Confirmar pagamento',
    'pos.validating': 'Validando...',
    'pos.lastTicket': 'Último cupom',
    'pos.caisseClosed': 'O caixa está fechado. Abra-o pelo Painel para realizar vendas.',
    'pos.insufficientCash': 'Valor em dinheiro insuficiente',
    'pos.insufficientCard': 'Valor em cartão insuficiente',
    'pos.mixedMustEqual': 'O pagamento misto deve ser igual ao total',
    'pos.emptyCartAlert': 'Carrinho vazio',
    'pos.selectPayment': 'Escolha uma forma de pagamento',
    'pos.saleValidated': 'Venda validada!',
    'pos.adminOverride': 'Autorização do administrador',
    'pos.outOfStockProduct': 'Produto sem estoque',
    'pos.adminId': 'ID do administrador',
    'pos.adminCode': 'Código do administrador',
    'pos.manualAdd': 'Adicionar artigo fora de estoque',
    'pos.designation': 'Designação',
    'pos.stockInsufficient': 'Estoque insuficiente',
    // Devis
    'devis.title': 'Orçamentos & Faturas',
    'devis.subtitle': 'Documentos do cálculo de preço (conversíveis em pedido).',
    'devis.noDoc': 'Nenhum documento encontrado',
    'devis.type': 'Tipo',
    'devis.convertConfirm': 'Converter este orçamento em pedido?',
    'devis.orderCreated': 'Pedido criado',
    'devis.deleteConfirm': 'Excluir este documento?',
    'devis.deleted': 'Documento excluído',
    // Devis Déplacement
    'devDep.title': 'Orçamentos deslocamento',
    'devDep.subtitle': 'Gestão de orçamentos para reparos a domicílio',
    'devDep.new': 'Novo orçamento',
    'devDep.edit': 'Editar orçamento',
    'devDep.clientName': 'Nome do cliente',
    'devDep.clientPhone': 'Telefone',
    'devDep.clientEmail': 'Email',
    'devDep.clientAddress': 'Endereço',
    'devDep.repairDesc': 'Descrição do reparo',
    'devDep.lines': 'Linhas do orçamento',
    'devDep.addLine': 'Adicionar',
    'devDep.travelFee': 'Taxa de deslocamento',
    'devDep.sendByEmail': 'Enviar por email',
    'devDep.sending': 'Enviando...',
    'devDep.pdfDevis': 'PDF Orçamento',
    'devDep.pdfBon': 'PDF Pedido',
    'devDep.pdfFacture': 'PDF Fatura',
    'devDep.searchPlaceholder': 'Buscar por ref, nome, email...',
    'devDep.allStatuses': 'Todos os status',
    'devDep.pending': 'Pendente',
    'devDep.accepted': 'Aceito',
    'devDep.refused': 'Recusado',
    'devDep.depositPaid': 'Sinal pago',
    'devDep.fullyPaid': 'Pago',
    'devDep.stats': 'Estatísticas',
    'devDep.revenues': 'Receitas',
    'devDep.activity30d': 'Atividade dos últimos 30 dias',
    'devDep.remind': 'Lembrar',
    'devDep.remindConfirm': 'Enviar lembrete para clientes com orçamentos pendentes há mais de 3 dias?',
    'devDep.noDevis': 'Nenhum orçamento criado',
    'devDep.noResults': 'Sem resultados',
    'devDep.bon': 'Pedido de compra',
    'devDep.facture': 'Fatura',
    'devDep.emailSent': 'Email enviado em',
    'devDep.reminderSent': 'Lembrete enviado em',
    // Reparations
    'rep.title': 'Reparos',
    'rep.search': 'Buscar um reparo...',
    'rep.new': 'Novo reparo',
    'rep.deviceRef': 'Ref. dispositivo',
    'rep.brand': 'Marca',
    'rep.model': 'Modelo',
    'rep.problem': 'Problema',
    'rep.technician': 'Técnico',
    'rep.timeline': 'Cronologia',
    // Commandes
    'cmd.title': 'Pedidos',
    'cmd.search': 'Buscar um pedido...',
    'cmd.piece': 'Peça',
    'cmd.supplier': 'Fornecedor',
    'cmd.deposit': 'Sinal',
    'cmd.remaining': 'Valor restante',
    // Clients
    'clients.title': 'Clientes',
    'clients.search': 'Buscar um cliente...',
    'clients.name': 'Nome',
    'clients.address': 'Endereço',
    'clients.addClient': 'Novo cliente',
    // Stock
    'stock.title': 'Gestão de Estoque',
    'stock.search': 'Buscar um artigo...',
    'stock.addArticle': 'Adicionar artigo',
    'stock.category': 'Categoria',
    'stock.buyPrice': 'Preço de compra',
    'stock.sellPrice': 'Preço de venda',
    'stock.available': 'Disponível',
    // Dashboard
    'dash.title': 'Painel',
    'dash.openCaisse': 'Abrir caixa',
    'dash.closeCaisse': 'Fechar caixa',
    'dash.todaySales': 'Vendas de hoje',
    'dash.monthSales': 'Vendas do mês',
    'dash.activeRepairs': 'Reparos ativos',
    'dash.pendingOrders': 'Pedidos pendentes',
    // Login
    'login.title': 'Login',
    'login.username': 'Usuário',
    'login.password': 'Código de acesso',
    'login.submit': 'Entrar',
    'login.clientAccess': 'Acesso cliente',
    'login.staffAccess': 'Acesso equipe',
    // Language
    'lang.select': 'Idioma',
    // Client Portal
    'client.space': 'Área do Cliente',
    'client.repairs': 'Reparos',
    'client.boutique': 'Loja',
    'client.orders': 'Pedidos',
    'client.messages': 'Mensagens',
    'client.devis': 'Orçamentos',
    'client.trackRepairs': 'Acompanhe seus reparos',
    'client.noRepairs': 'Nenhum reparo em andamento',
    'client.trackOrders': 'Acompanhe seus pedidos',
    'client.noOrders': 'Nenhum pedido em andamento',
    'client.shop': 'Loja online',
    'client.noProducts': 'Nenhum produto disponível',
    'client.addToCart': 'Adicionar ao carrinho',
    'client.yourMessages': 'Suas mensagens',
    'client.noMessages': 'Sem mensagens',
    'client.send': 'Enviar',
    'client.brand': 'Marca',
    'client.model': 'Modelo',
    'client.problem': 'Problema',
    'client.status': 'Status',
    'client.deposit': 'Sinal',
    'client.remaining': 'Valor restante',
    'client.total': 'Total',
    'client.timeline': 'Cronologia',
    'client.noDevis': 'Nenhum orçamento no momento',
    'client.acceptRefuse': 'Aceitar / Recusar',
    'client.pay': 'Pagar',
    // Landing
    'landing.mobileRepair': 'Reparo de celular na Guiana Francesa',
    'landing.staffSpace': 'ÁREA DA EQUIPE',
    'landing.staffDesc': 'Acesso equipe técnica',
    'landing.clientSpace': 'ÁREA DO CLIENTE',
    'landing.clientDesc': 'Acompanhamento de reparo',
    'landing.businessSpace': 'ÁREA EMPRESARIAL',
    'landing.businessDesc': 'Portal B2B',
    'landing.contact': 'Contato',
    'landing.callWhatsapp': 'Ligar & WhatsApp',
    'landing.writeUs': 'Escreva-nos diretamente',
    'landing.hours': 'Horário de funcionamento',
    'landing.legal': 'Informações legais',
    'landing.capital': 'com capital de',
    'landing.headquarters': 'Sede',
    'landing.allRights': 'Todos os direitos reservados',
    'landing.heroSubtitle': 'Seu especialista em reparo de celular na Guiana Francesa',
    'landing.mondayFriday': 'Segunda - Sexta',
    'landing.saturday': 'Sábado',
    'landing.sunday': 'Domingo',
    'landing.closed': 'Fechado',
    'landing.companyType': 'Sociedade por Ações Simplificada (SAS)',
    'landing.openMaps': 'Abrir no Maps',
    'landing.rcs': 'RCS',
    'landing.siret': 'SIRET',
    'landing.euid': 'EUID',
    'landing.shopAddress': 'Ponto de venda',
    // Login extra
    'login.clientSpace': 'Área do Cliente',
    'login.businessSpace': 'Área Empresarial',
    'login.staffSpace': 'Área da Equipe',
    'login.connectYou': 'Fazer login',
    'login.phoneNumber': 'Número de telefone',
    'login.proEmail': 'Email profissional',
    'login.pin': 'Código PIN (4 ou 6 dígitos)',
    'login.pinHint': 'Digite seu código pelo teclado ou teclado numérico.',
    'login.connecting': 'Conectando...',
    'login.connect': 'Entrar',
    'login.noAccount': 'Ainda não tem conta?',
    'login.createAccount': 'Criar conta',
    'login.forgotPwd': 'Esqueceu a senha?',
    'login.notRegistered': 'Ainda não cadastrado?',
    'login.businessRegister': 'Cadastro empresarial',
    'login.secure': 'Login seguro',
    'login.caricature': 'Criar minha caricatura',
    'login.backHome': 'Voltar ao início',
    'login.wrongCredentials': 'Credenciais incorretas',
    'login.pinError': 'O código PIN deve conter 4 ou 6 dígitos',
    'login.b2bPassword': 'Senha',
    'login.b2bPlaceholder': 'Sua senha',
    'login.yourId': 'Seu identificador',
    // Dashboard extra
    'dash.hello': 'Olá',
    'dash.loggedAs': 'Conectado como',
    'dash.caisseOpen': 'Caixa aberto',
    'dash.closeCaisseReminder': 'Lembre-se de fechar o caixa',
    'dash.noCaisse': 'Nenhum caixa aberto',
    'dash.openCaisseTitle': 'Abrir caixa',
    'dash.openTotal': 'Total de abertura',
    'dash.opening': 'Abrindo...',
    'dash.open': 'Abrir',
    'dash.searchPlaceholder': 'Buscar por referência, cliente, telefone...',
    'dash.noResults': 'Nenhum resultado encontrado',
    'dash.today': 'Hoje',
    'dash.thisMonth': 'Este mês',
    'dash.completed': 'Concluídos',
    'dash.repairsSub': 'reparos',
    'dash.inProgress': 'Em andamento',
    'dash.waitingParts': 'aguardando peças incl.',
    'dash.registeredMonth': 'registrados este mês',
    'dash.statsTitle': 'Estatísticas & Análises',
    'dash.statsDesc': 'Faturamento, reparos, B2B, clientes',
    'dash.brandsModelsLabel': 'Marcas & Modelos',
    'dash.brandsModelsDesc': 'Gerenciar catálogo de dispositivos',
    'dash.b2bPaymentsLabel': 'Pagamentos B2B',
    'dash.b2bPaymentsDesc': 'Acompanhamento de faturas e pagamentos',
    'dash.stockAlerts': 'Alertas de estoque',
    'dash.lowStock': 'produtos com estoque baixo',
    'dash.outOfStock': 'sem estoque',
    'dash.recentRepairs': 'Últimos reparos',
    'dash.noClient': 'Sem cliente',
    'dash.unclosedTitle': 'Caixa não fechado',
    'dash.unclosedNotClosed': 'não foi fechado',
    'dash.contactAdmin': 'Entre em contato com um administrador para fechá-lo antes de continuar.',
    'dash.mustClose': 'Você deve fechá-lo antes de poder continuar trabalhando.',
    'dash.forceClose': 'Fechamento forçado',
    'dash.closing': 'Fechando...',
    'dash.closeNormal': 'Fechar normalmente',
    'dash.noCaisseToday': 'Nenhum caixa aberto hoje.',
    'dash.openQuestion': 'Deseja abrir o caixa agora?',
    'dash.dontOpen': 'Não abrir (continuar)',
    'dash.salesBlocked': 'As vendas estão bloqueadas enquanto o caixa não estiver aberto.',
    'dash.calculation': 'Cálculo',
    'dash.repairs': 'Reparos',
    'dash.addDevice': 'Adicionar',
    'dash.clients': 'Clientes',
    'dash.openedBy': 'aberto por',
    'dash.unknown': 'desconhecido',
    'dash.forceCloseConfirm': 'Forçar fechamento do caixa de',
    'dash.errorForceClose': 'Erro no fechamento forçado',
    'dash.errorOpenCaisse': 'Erro ao abrir o caixa',
    // Devis Accept
    'devisAccept.error': 'Erro',
    'devisAccept.notFound': 'Orçamento não encontrado',
    'devisAccept.refused': 'Orçamento recusado',
    'devisAccept.refusedMsg': 'Você recusou o orçamento',
    'devisAccept.thanks': 'Obrigado por nos informar.',
    'devisAccept.accepted': 'Orçamento aceito!',
    'devisAccept.acceptedMsg': 'Obrigado por aceitar o orçamento',
    'devisAccept.bonCommande': 'Pedido de compra',
    'devisAccept.facture': 'Fatura',
    'devisAccept.emailSent': 'Um email com seu pedido de compra, código de validação e suas credenciais foi enviado.',
    'devisAccept.proceedPayment': 'Ir para o pagamento',
    'devisAccept.paymentMsg': 'Para finalizar seu pedido, faça um sinal ou o pagamento completo:',
    'devisAccept.deposit50': 'Sinal 50%',
    'devisAccept.fullPayment': 'Pagamento completo',
    'devisAccept.alreadyAccepted': 'Este orçamento já foi aceito.',
    'devisAccept.alreadyRefused': 'Este orçamento foi recusado.',
    'devisAccept.statusMsg': 'Status do orçamento',
    'devisAccept.payDeposit': 'Pagar sinal 50%',
    'devisAccept.homeRepairQuote': 'Orçamento de reparo a domicílio',
    'devisAccept.hello': 'Olá',
    'devisAccept.findBelow': 'Encontre abaixo os detalhes do seu orçamento:',
    'devisAccept.designation': 'Designação',
    'devisAccept.travelFee': 'Taxa de deslocamento',
    'devisAccept.tvaNote': 'IVA não aplicável, art. 293B do CGI. Orçamento válido por 30 dias.',
    'devisAccept.refuse': 'Recusar',
    'devisAccept.accept': 'Aceitar o orçamento',
    'devisAccept.confirmRefuse': 'Tem certeza de que deseja recusar este orçamento?',
    // Payment
    'payment.secure': 'Pagamento seguro',
    'payment.error': 'Erro',
    'payment.backToDevis': 'Voltar ao orçamento',
    'payment.notAccepted': 'Orçamento não aceito',
    'payment.mustAcceptFirst': 'Você deve primeiro aceitar o orçamento antes de prosseguir com o pagamento.',
    'payment.viewDevis': 'Ver orçamento',
    'payment.fullyPaid': 'Fatura totalmente paga',
    'payment.alreadyPaid': 'já está totalmente pago.',
    'payment.accessClient': 'Acessar sua área de cliente',
    'payment.deposit50': 'Sinal 50%',
    'payment.fullPayment': 'Pagamento completo',
    'payment.devis': 'Orçamento',
    'payment.client': 'Cliente',
    'payment.totalDevis': 'Total do orçamento',
    'payment.alreadyPaidAmount': 'Já pago',
    'payment.remaining': 'Valor restante',
    'payment.depositPercent': 'Sinal (50%)',
    'payment.amountToPay': 'Valor a pagar',
    'payment.pay': 'Pagar',
    'payment.redirecting': 'Redirecionando para o Stripe...',
    'payment.securedBy': 'Pagamento seguro via Stripe',
    'payment.urlNotAvailable': 'URL de pagamento não disponível',
    'payment.creationError': 'Erro na criação do pagamento',
    // Payment success
    'paySuccess.confirmed': 'Pagamento confirmado!',
    'paySuccess.paymentFor': 'Seu pagamento para o orçamento',
    'paySuccess.registered': 'foi registrado com sucesso.',
    'paySuccess.depositRegistered': 'Sinal registrado!',
    'paySuccess.depositFor': 'Seu sinal para o orçamento',
    'paySuccess.depositDone': 'foi registrado.',
    'paySuccess.checking': 'Verificando...',
    'paySuccess.pleaseWait': 'Estamos verificando seu pagamento, aguarde.',
    'paySuccess.waitingConfirm': 'Aguardando confirmação',
    'paySuccess.processing': 'Seu pagamento está sendo processado. Você receberá um email de confirmação.',
    'paySuccess.totalInvoice': 'Total da fatura',
    'paySuccess.amountPaid': 'Valor pago',
    'paySuccess.remaining': 'Valor restante',
    'paySuccess.payRemaining': 'Pagar o restante',
    'paySuccess.loginClient': 'Faça login na sua área de cliente',
    // Registration
    'register.clientTitle': 'Criar conta de cliente',
    'register.fullName': 'Nome completo',
    'register.phone': 'Telefone',
    'register.email': 'Email (opcional)',
    'register.address': 'Endereço (opcional)',
    'register.pin': 'Código PIN (4 ou 6 dígitos)',
    'register.confirmPin': 'Confirmar código PIN',
    'register.creating': 'Criando...',
    'register.createAccount': 'Criar minha conta',
    'register.alreadyAccount': 'Já tem conta?',
    'register.login': 'Entrar',
    'register.backHome': 'Voltar ao início',
    'register.pinError': 'O código PIN deve conter 4 ou 6 dígitos',
    'register.pinNoMatch': 'Os códigos PIN não coincidem',
    'register.pinMinLength': 'O código PIN deve conter pelo menos 4 dígitos',
    // B2B Registration
    'b2bRegister.title': 'Cadastro Empresarial',
    'b2bRegister.subtitle': 'Crie sua conta profissional',
    'b2bRegister.companyName': 'Nome da empresa',
    'b2bRegister.managerName': 'Nome do gerente',
    'b2bRegister.proEmail': 'Email profissional',
    'b2bRegister.phone': 'Telefone',
    'b2bRegister.address': 'Endereço',
    'b2bRegister.siret': 'CNPJ',
    'b2bRegister.password': 'Senha',
    'b2bRegister.confirmPassword': 'Confirmar senha',
    'b2bRegister.kbis': 'Contrato social (PDF)',
    'b2bRegister.kbisDesc': 'Envie seu contrato social ou documento comprovativo (PDF)',
    'b2bRegister.dropFile': 'Clique ou arraste seu arquivo aqui',
    'b2bRegister.creating': 'Cadastrando...',
    'b2bRegister.submit': 'Cadastrar',
    'b2bRegister.success': 'Cadastro realizado!',
    'b2bRegister.successMsg': 'Sua conta empresarial está em validação. Você receberá um email de confirmação.',
    'b2bRegister.goLogin': 'Ir para o login',
    'b2bRegister.fillAll': 'Preencha todos os campos obrigatórios',
    'b2bRegister.siretError': 'O CNPJ deve conter 14 dígitos',
    'b2bRegister.pwdNoMatch': 'As senhas não coincidem',
    'b2bRegister.pwdMinLength': 'A senha deve conter pelo menos 6 caracteres',
    'b2bRegister.kbisRequired': 'Envie seu contrato social',
    'b2bRegister.alreadyAccount': 'Já cadastrado?',
    // Reset password
    'reset.forgotTitle': 'Esqueci a senha',
    'reset.forgotDesc': 'Receba um link de redefinição por email',
    'reset.enterEmail': 'Digite seu email',
    'reset.emailSent': 'Email enviado',
    'reset.emailSentMsg': 'Se existir uma conta com este endereço, você receberá um email com um link para redefinir sua senha.',
    'reset.linkValid': 'O link é válido por 1 hora.',
    'reset.backLogin': 'Voltar ao login',
    'reset.clientEmail': 'Endereço de email da sua conta',
    'reset.sending': 'Enviando...',
    'reset.sendLink': 'Enviar link de redefinição',
    'reset.newPwdTitle': 'Nova senha',
    'reset.newPwdDesc': 'Escolha sua nova senha',
    'reset.newPwd': 'Nova senha',
    'reset.confirmPwd': 'Confirmar senha',
    'reset.resetting': 'Redefinindo...',
    'reset.resetPwd': 'Redefinir senha',
    'reset.pwdReset': 'Senha redefinida',
    'reset.pwdResetMsg': 'Sua senha foi alterada com sucesso.',
    'reset.pwdMinLength': 'A senha deve conter pelo menos 4 caracteres',
    'reset.pwdNoMatch': 'As senhas não coincidem',
    'reset.error': 'Ocorreu um erro',
    // B2B Dashboard
    'b2b.welcome': 'Bem-vindo',
    'b2b.newRepair': 'Novo reparo',
    'b2b.registerDevice': 'Registrar dispositivo',
    'b2b.myRepairs': 'Meus reparos',
    'b2b.viewAll': 'Ver todos os reparos',
    'b2b.recentRepairs': 'Últimos reparos',
    'b2b.noRepairs': 'Sem reparos',
    'b2b.repairRegistered': 'Reparo registrado',
    'b2b.reference': 'Referência',
    'b2b.viewDetails': 'Ver detalhes',
    'b2b.anotherRepair': 'Novo reparo',
    'b2b.deviceInfo': 'Informações do dispositivo',
    'b2b.brand': 'Marca',
    'b2b.model': 'Modelo',
    'b2b.backGlass': 'Vidro traseiro',
    'b2b.backGlassBroken': 'Vidro traseiro quebrado',
    'b2b.backGlassOk': 'Vidro traseiro intacto',
    'b2b.providePart': 'Eu forneço a peça',
    'b2b.partByShop': 'A peça será fornecida pela R.E.Mobiles',
    'b2b.lockCode': 'Código de desbloqueio',
    'b2b.lockTypeCode': 'Código (números/letras)',
    'b2b.lockTypeSchema': 'Padrão',
    'b2b.problem': 'Problema / Descrição',
    'b2b.brokenParts': 'Peças não funcionais',
    'b2b.deliveryMethod': 'Método de entrega',
    'b2b.inStore': 'Na loja',
    'b2b.inStoreDesc': 'Entrega na loja',
    'b2b.postal': 'Envio postal',
    'b2b.postalDesc': 'Com número de rastreio',
    'b2b.pickup': 'Coleta',
    'b2b.pickupDesc': 'Vamos buscar',
    'b2b.trackingNumber': 'Número de rastreio',
    'b2b.pickupAddress': 'Endereço de coleta',
    'b2b.devicePhotos': 'Fotos do dispositivo',
    'b2b.addPhotos': 'Clique para adicionar fotos',
    'b2b.additionalNotes': 'Notas adicionais',
    'b2b.submitting': 'Enviando...',
    'b2b.submitRepair': 'Registrar o reparo',
    'b2b.brandModelRequired': 'Marca e modelo são obrigatórios',
    'b2b.noRepairFound': 'Nenhum reparo encontrado',
    'b2b.allStatus': 'Todos',
    'b2b.documents': 'Documentos & Faturas',
    'b2b.documentsDesc': 'Valide seus pedidos de compra e baixe suas faturas',
    'b2b.pendingValidation': 'Pedidos de compra a validar',
    'b2b.enterCode': 'Digite o código recebido por email para validar cada pedido de compra.',
    'b2b.validate': 'Validar',
    'b2b.invoices': 'Faturas',
    'b2b.noInvoices': 'Nenhuma fatura disponível',
    'b2b.device': 'Dispositivo',
    'b2b.amount': 'Valor',
    'b2b.date': 'Data',
    'b2b.actions': 'Ações',
    'b2b.paid': 'Paga',
    'b2b.repairAccepted': 'Reparo aceito pela equipe',
    'b2b.repairRefused': 'Reparo recusado pela equipe',
    'b2b.orderValidated': 'Pedido de compra validado',
    'b2b.noPhotos': 'Sem fotos',
    'b2b.history': 'Histórico',
    'b2b.repairPrice': 'Preço do reparo',
    'b2b.diagPrice': 'Preço do diagnóstico',
    'b2b.priceWaiting': 'Pendente - será definido pela R.E.Mobiles',
    'b2b.createdOn': 'Criado em',
    'b2b.clear': 'Limpar',
    'b2b.thisMonth': 'Este mês',
    'b2b.waitingReception': 'Aguardando recepção',
    'b2b.received': 'Recebido',
    'b2b.inProgress': 'Em Andamento',
    'b2b.waitingParts': 'Aguardando Peças',
    'b2b.completed': 'Concluído',
    'b2b.delivered': 'Entregue',
    // B2B Devis
    'b2bDevis.title': 'Orçamentos deslocamento',
    'b2bDevis.pending': 'pendente',
    'b2bDevis.noDevis': 'Sem orçamentos',
    'b2bDevis.noDevisDesc': 'Você não tem orçamentos de deslocamento no momento.',
    'b2bDevis.travelFee': 'Taxa de deslocamento',
    'b2bDevis.validationCode': 'Código de validação',
    'b2bDevis.codeHint': 'Digite o código de 6 dígitos recebido por email.',
    'b2bDevis.acceptFirst': 'Aceite primeiro o orçamento para poder validá-lo.',
    'b2bDevis.payDeposit': 'Pagar sinal 50%',
    'b2bDevis.payFull': 'Pagar o total',
    'b2bDevis.payRemaining': 'Pagar o restante',
    'b2bDevis.alreadyPaid': 'Já pago',
    'b2bDevis.remaining': 'Valor restante',
    'b2bDevis.invoiceDownload': 'Baixar fatura',
    'b2bDevis.orderDownload': 'Baixar pedido de compra',
    'b2bDevis.quoteDownload': 'Baixar orçamento',
    // Admin Site Settings
    'adminSettings.title': 'Página inicial',
    'adminSettings.preview': 'Pré-visualizar',
    'adminSettings.saving': 'Salvando...',
    'adminSettings.save': 'Salvar',
    'adminSettings.saved': 'Salvo!',
    'adminSettings.error': 'Erro',
    'adminSettings.heroSection': 'Hero / Cabeçalho',
    'adminSettings.mainTitle': 'Título principal',
    'adminSettings.subtitle': 'Subtítulo',
    'adminSettings.accentColor': 'Cor de destaque (hex)',
    'adminSettings.bgImage': 'Imagem de fundo',
    'adminSettings.change': 'Alterar',
    'adminSettings.companyInfo': 'Informações da empresa',
    'adminSettings.companyName': 'Nome da empresa',
    'adminSettings.companyType': 'Tipo (SAS, SARL...)',
    'adminSettings.capital': 'Capital',
    'adminSettings.rcs': 'RCS',
    'adminSettings.siret': 'CNPJ',
    'adminSettings.euid': 'EUID',
    'adminSettings.headquarters': 'Sede',
    'adminSettings.salesPoint': 'Ponto de venda',
    'adminSettings.contactHours': 'Contato & Horários',
    'adminSettings.phone': 'Telefone',
    'adminSettings.whatsapp': 'WhatsApp',
    'adminSettings.email': 'Email',
    'adminSettings.googleMaps': 'Busca Google Maps',
    'adminSettings.gallery': 'Galeria de fotos',
    'adminSettings.addImage': 'Adicionar imagem',
    // Admin Database
    'adminDb.title': 'Administração do Banco de Dados',
    'adminDb.subtitle': 'Exportação, importação e gestão de dados',
    'adminDb.accessDenied': 'Acesso negado',
    'adminDb.adminOnly': 'Esta página é reservada a administradores',
    'adminDb.clients': 'Clientes',
    'adminDb.users': 'Usuários',
    'adminDb.repairs': 'Reparos',
    'adminDb.stockArticles': 'Artigos de estoque',
    'adminDb.exportTitle': 'Exportar banco de dados',
    'adminDb.exportDesc': 'Exportar todos os dados (clientes, usuários, estoque, reparos, vendas) em formato JSON.',
    'adminDb.exportConfirm': 'Exportar todo o banco de dados?',
    'adminDb.exportBtn': 'Exportar banco de dados completo',
    'adminDb.exportSuccess': 'Exportação bem-sucedida!',
    'adminDb.exportError': 'Erro na exportação',
    'adminDb.importTitle': 'Importar banco de dados',
    'adminDb.importDesc': 'Importar um arquivo JSON para restaurar ou migrar dados.',
    'adminDb.fileSelected': 'Arquivo selecionado',
    'adminDb.uploading': 'Enviando arquivo...',
    'adminDb.importDone': 'Importação concluída!',
    'adminDb.importSuccess': 'Importação bem-sucedida!',
    'adminDb.importError': 'Erro na importação',
    'adminDb.importClientsBtn': 'Importar clientes',
    'adminDb.importFullBtn': 'Importação completa',
    'adminDb.importWarning': 'A importação completa substituirá os dados existentes',
    'adminDb.importConfirm': 'ATENÇÃO: Esta ação substituirá os dados existentes. Continuar?',
    'adminDb.importClientsConfirm': 'Importar clientes? As contas serão criadas com o número de telefone como identificador.',
    'adminDb.selectFile': 'Selecione um arquivo',
    'adminDb.selectFileClients': 'Selecione um arquivo JSON com clientes',
    'adminDb.logsTitle': 'Registro de operações',
    'adminDb.noLogs': 'Nenhuma operação registrada',
    // Admin B2B
    'adminB2b.title': 'Gestão B2B',
    'adminB2b.home': 'Início',
    'adminB2b.monthlyRecap': 'Resumo mensal',
    'adminB2b.sending': 'Enviando...',
    'adminB2b.search': 'Buscar...',
    'adminB2b.recapTitle': 'Resultado do resumo mensal',
    'adminB2b.recapSent': 'Enviado',
    'adminB2b.recapSkipped': 'Sem reparos',
    'adminB2b.recapError': 'Erro',
    'adminB2b.companies': 'Empresas',
    'adminB2b.b2bRepairs': 'Reparos B2B',
    'adminB2b.paymentHistory': 'Histórico de pagamentos',
    'adminB2b.all': 'Todos',
    'adminB2b.pending': 'Pendentes',
    'adminB2b.validated': 'Validados',
    'adminB2b.refused': 'Recusados',
    'adminB2b.suspended': 'Suspensos',
    'adminB2b.noCompany': 'Nenhuma empresa encontrada',
    'adminB2b.phone': 'Telefone',
    'adminB2b.siret': 'CNPJ',
    'adminB2b.address': 'Endereço',
    'adminB2b.registeredOn': 'Cadastrado em',
    'adminB2b.validatedBy': 'Validado por',
    'adminB2b.downloadKbis': 'Baixar contrato social',
    'adminB2b.validate': 'Validar',
    'adminB2b.refuse': 'Recusar',
    'adminB2b.suspend': 'Suspender',
    'adminB2b.confirmValidate': 'Deseja validar esta empresa?',
    'adminB2b.confirmRefuse': 'Deseja recusar esta empresa?',
    'adminB2b.confirmSuspend': 'Deseja suspender esta empresa?',
    'adminB2b.pendingReception': 'Aguardando recepção',
    'adminB2b.confirmReception': 'Confirmar recepção',
    'adminB2b.ref': 'Ref',
    'adminB2b.company': 'Empresa',
    'adminB2b.brandModel': 'Marca / Modelo',
    'adminB2b.problem': 'Problema',
    'adminB2b.delivery': 'Entrega',
    'adminB2b.price': 'Preço',
    'adminB2b.status': 'Status',
    'adminB2b.actions': 'Ações',
    'adminB2b.noRepairs': 'Nenhum reparo B2B encontrado',
    'adminB2b.postal': 'Postal',
    'adminB2b.pickup': 'Coleta',
    'adminB2b.inStore': 'Loja',
    'adminB2b.changeStatus': 'Alterar status',
    'adminB2b.setPrice': 'Definir preço',
    'adminB2b.repairPrice': 'Preço do reparo',
    'adminB2b.diagPrice': 'Preço do diagnóstico',
    'adminB2b.locked': 'Bloqueado (pago)',
    'adminB2b.total': 'Total',
    'adminB2b.existingInvoices': 'Faturas existentes',
    'adminB2b.diagnostic': 'Diagnóstico',
    'adminB2b.repair': 'Reparo',
    'adminB2b.combined': 'Combinada',
    'adminB2b.paidMethod': 'Paga',
    'adminB2b.awaitingPayment': 'Pendente',
    'adminB2b.markPaid': 'Paga',
    'adminB2b.finalize': 'Finalizar faturamento',
    'adminB2b.backGlassBroken': 'Vidro tras. quebrado',
    'adminB2b.clientPart': 'Peça do cliente',
    'adminB2b.bcValidated': 'PC validado',
    'adminB2b.invoiceCancelled': 'Fatura cancelada',
    'adminB2b.monthPrompt': 'Mês (1-12)? Deixe vazio para o mês anterior:',
    'adminB2b.yearPrompt': 'Ano?',
    'adminB2b.paymentMethodPrompt': 'Forma de pagamento?',
    'adminB2b.filterCompany': 'Empresa',
    'adminB2b.filterDateStart': 'Data início',
    'adminB2b.filterDateEnd': 'Data fim',
    'adminB2b.filter': 'Filtrar',
    'adminB2b.clearFilter': 'Limpar',
    'adminB2b.totalCollected': 'Total recebido',
    'adminB2b.payments': 'pagamento(s)',
    'adminB2b.payHistoryTitle': 'Histórico de pagamentos B2B',
    'adminB2b.noPayments': 'Nenhum pagamento B2B registrado',
    'adminB2b.invoice': 'Fatura',
    // Users Management
    'users.title': 'Gestão de usuários',
    'users.count': 'usuário(s)',
    'users.new': 'Novo usuário',
    'users.edit': 'Editar usuário',
    'users.username': 'Nome de usuário',
    'users.password': 'Senha',
    'users.newPassword': 'Nova senha (deixe vazio para não alterar)',
    'users.role': 'Função',
    'users.roleAdmin': 'Administrador',
    'users.roleUser': 'Comercial',
    'users.roleTech': 'Técnico',
    'users.status': 'Status',
    'users.active': 'Ativo',
    'users.inactive': 'Inativo',
    'users.createdAt': 'Criado em',
    'users.noUsers': 'Sem usuários',
    'users.accessDenied': 'Acesso reservado a administradores',
    'users.deleteConfirm': 'Excluir este usuário?',
    // Clients (extra keys)
    'clients.manage': 'Gestão de Clientes',
    'clients.total': 'clientes no total',
    'clients.add': 'Adicionar',
    'clients.noClients': 'Nenhum cliente encontrado',
    'clients.type': 'Tipo',
    'clients.discount': 'Desconto',
    'clients.account': 'Conta',
    'clients.sent': 'Enviado',
    'clients.activeAccount': 'Ativo',
    'clients.noEmail': 'Sem email',
    'clients.editClient': 'Editar cliente',
    'clients.newClient': 'Novo cliente',
    'clients.company': 'Empresa',
    'clients.clientType': 'Tipo de cliente',
    'clients.individual': 'Pessoa física',
    'clients.business': 'Empresa',
    'clients.discountPct': 'Desconto (%)',
    'clients.deleteConfirm': 'Excluir este cliente?',
    'clients.page': 'Página',
    // Stats
    'stats.title': 'Estatísticas & Análises',
    'stats.revenue': 'Faturamento',
    'stats.repairs': 'Reparos',
    'stats.b2b': 'B2B',
    'stats.clients': 'Clientes',
    'stats.back': 'Voltar',
    'stats.monthlyRevenue': 'Faturamento mensal',
    'stats.revenueByType': 'Faturamento por tipo',
    'stats.revenueByPayment': 'Faturamento por forma de pagamento',
    'stats.totalRevenue': 'Faturamento total (12 meses)',
    'stats.repairsByStatus': 'Por status',
    'stats.repairsByBrand': 'Por marca',
    'stats.topModels': 'Top modelos',
    'stats.monthly': 'Evolução mensal',
    'stats.totalRepairs': 'Reparos totais',
    'stats.avgRepairTime': 'Duração média',
    'stats.completionRate': 'Taxa de conclusão',
    'stats.b2bCompanies': 'Empresas B2B',
    'stats.b2bRepairs': 'Reparos B2B',
    'stats.b2bRevenue': 'Faturamento B2B',
    'stats.b2bByCompany': 'Por empresa',
    'stats.totalClients': 'Clientes totais',
    'stats.newThisMonth': 'Novos este mês',
    'stats.withAccount': 'Com conta',
    'stats.clientsByType': 'Por tipo',
    'stats.registrations': 'Cadastros mensais',
    'stats.noData': 'Sem dados',
    // Reparations (extra)
    'rep.manage': 'Gestão de Reparos',
    'rep.noRepairs': 'Nenhum reparo encontrado',
    'rep.allStatuses': 'Todos os status',
    'rep.imei': 'IMEI / Série',
    'rep.client': 'Cliente',
    'rep.phone': 'Tel.',
    'rep.date': 'Data',
    'rep.deposit': 'Sinal',
    'rep.printFiche': 'Imprimir ficha',
    'rep.printEtiquette': 'Imprimir etiqueta',
    'rep.deleteConfirm': 'Excluir este reparo?',
    'rep.addDeposit': 'Adicionar sinal',
    'rep.depositAmount': 'Valor do sinal',
    'rep.paymentMode': 'Forma de pagamento',
    'rep.depositHistory': 'Histórico de sinais',
    'rep.totalDeposits': 'Total de sinais',
    'rep.changeStatus': 'Alterar status',
    'rep.notes': 'Notas internas',
    'rep.sendChat': 'Enviar mensagem',
    'rep.noTimeline': 'Sem eventos',
    // Commandes (extra)
    'cmd.manage': 'Gestão de Pedidos',
    'cmd.noOrders': 'Nenhum pedido encontrado',
    'cmd.allStatuses': 'Todos os status',
    'cmd.ordered': 'Pedido feito',
    'cmd.received': 'Recebido',
    'cmd.cancelled': 'Cancelado',
    'cmd.status': 'Status',
    'cmd.ref': 'Ref',
    'cmd.addOrder': 'Novo pedido',
    'cmd.editOrder': 'Editar pedido',
    'cmd.deleteConfirm': 'Excluir este pedido?',
    // Stock (extra)
    'stock.manage': 'Gestão de Estoque',
    'stock.noItems': 'Nenhum artigo encontrado',
    'stock.barcode': 'Código de barras',
    'stock.reference': 'Referência',
    'stock.alert': 'Alerta',
    'stock.lowStockAlert': 'Estoque baixo',
    'stock.addForm': 'Adicionar artigo',
    'stock.editForm': 'Editar artigo',
    'stock.deleteConfirm': 'Excluir este artigo?',
    // Historique
    'hist.title': 'Histórico de vendas',
    'hist.search': 'Buscar uma venda...',
    'hist.noSales': 'Nenhuma venda encontrada',
    'hist.ref': 'Ref.',
    'hist.client': 'Cliente',
    'hist.amount': 'Valor',
    'hist.payment': 'Pagamento',
    'hist.date': 'Data',
    'hist.articles': 'Artigos',
    'hist.refund': 'Reembolsar',
    'hist.refundConfirm': 'Reembolsar esta venda?',
    // Paiements
    'pay.title': 'Pagamentos online',
    'pay.search': 'Buscar...',
    'pay.noPayments': 'Nenhum pagamento encontrado',
    'pay.ref': 'Referência',
    'pay.client': 'Cliente',
    'pay.amount': 'Valor',
    'pay.status': 'Status',
    'pay.date': 'Data',
    'pay.type': 'Tipo',
    // Caisse
    'caisse.title': 'Histórico de Caixas',
    'caisse.noCaisse': 'Nenhum caixa encontrado',
    'caisse.openedBy': 'Aberto por',
    'caisse.openingAmount': 'Valor de abertura',
    'caisse.closingAmount': 'Valor de fechamento',
    'caisse.sales': 'Vendas',
    'caisse.openDate': 'Abertura',
    'caisse.closeDate': 'Fechamento',
    // Notes
    'notes.title': 'Notas',
    'notes.new': 'Nova nota',
    'notes.noNotes': 'Sem notas',
    'notes.deleteConfirm': 'Excluir esta nota?',
    // Etiquettes
    'labels.title': 'Etiquetas',
    'labels.search': 'Buscar...',
    'labels.print': 'Imprimir',
    'labels.selectAll': 'Selecionar tudo',
    'labels.noLabels': 'Sem etiquetas',
    // Calcul Prix
    'calc.title': 'Cálculo de Preço',
    'calc.searchDevice': 'Buscar um dispositivo...',
    'calc.selectRepair': 'Selecionar um reparo',
    'calc.generateQuote': 'Gerar orçamento',
    'calc.generateInvoice': 'Gerar fatura',
    // Boutique
    'boutique.title': 'Pedidos da Loja',
    'boutique.noOrders': 'Sem pedidos',
    'boutique.orderRef': 'Ref. pedido',
    'boutique.clientName': 'Cliente',
    'boutique.total': 'Total',
    'boutique.status': 'Status',
    // Chat
    'chat.title': 'Mensagens',
    'chat.noConversations': 'Sem conversas',
    'chat.typeMessage': 'Digite sua mensagem...',
    // Brands & Models
    'brands.title': 'Marcas & Modelos',
    'brands.addBrand': 'Adicionar marca',
    'brands.addModel': 'Adicionar modelo',
    'brands.noBrands': 'Sem marcas',
    'brands.deleteConfirm': 'Excluir esta marca?',
    // Remcaches
    'remcaches.title': 'Reset de Cache',
    'remcaches.noItems': 'Sem artigos',
    // Close Caisse
    'closeCaisse.title': 'Fechamento de Caixa',
    'closeCaisse.countCoins': 'Contagem de dinheiro',
    'closeCaisse.theoreticalTotal': 'Total teórico',
    'closeCaisse.actualTotal': 'Total real',
    'closeCaisse.difference': 'Diferença',
    'closeCaisse.close': 'Fechar caixa',
    'closeCaisse.closing': 'Fechando...',
    // Client Passwords
    'clientPwd.title': 'Senhas de Clientes',
    'clientPwd.search': 'Buscar um cliente...',
    'clientPwd.noClients': 'Nenhum cliente encontrado',
    'clientPwd.generatePin': 'Gerar PIN',
    'clientPwd.sendByEmail': 'Enviar por email',
    // B2B Payments
    'b2bPay.title': 'Pagamentos B2B',
    'b2bPay.noPayments': 'Sem pagamentos',
    // Reparation Form
    'repForm.title': 'Adicionar dispositivo',
    'repForm.editTitle': 'Editar reparo',
    'repForm.brand': 'Marca',
    'repForm.model': 'Modelo',
    'repForm.imei': 'IMEI / N.º de série',
    'repForm.lockCode': 'Código de desbloqueio',
    'repForm.problem': 'Problema constatado',
    'repForm.client': 'Cliente',
    'repForm.technician': 'Técnico designado',
    'repForm.price': 'Preço do reparo',
    'repForm.submit': 'Salvar',
    'repForm.submitting': 'Salvando...',
    'sumup.acceptOnlinePayment': 'Aceitar pagamento online (SumUp)', 'sumup.acceptOnlinePaymentDesc': 'O cliente poderá solicitar um link de pagamento SumUp', 'sumup.requestLink': 'Solicitar link de pagamento SumUp', 'sumup.requestSent': 'Solicitação enviada! Você receberá o link por e-mail.', 'sumup.alreadyRequested': 'Solicitação já em andamento.', 'sumup.onlinePayment': 'Pagamento online SumUp', 'sumup.receiveLink': 'Receba um link de pagamento seguro por e-mail', 'sumup.linkRequested': 'Link solicitado', 'sumup.pendingRequests': 'Solicitações de link SumUp', 'sumup.pending': 'pendente', 'sumup.pasteLinkHere': 'Colar link SumUp aqui...', 'sumup.send': 'Enviar', 'sumup.linkSent': 'Link SumUp enviado ao cliente por e-mail!',
  };

export default ptBR;
